const local = {
  view: {
    grid: 'موزائیکی',
    list: 'لیست',
    compact: 'فشرده'
  },
  calculator: {
    title: 'ماشین حساب هزینه API',
    description: 'هزینه استفاده از ارائه‌دهنده را برای یک درخواست یا بار کاری برآورد کنید.',
    estimateSetup: 'تنظیم برآورد',
    totalPayable: 'مبلغ قابل پرداخت',
    providerUsageCost: 'هزینه استفاده از ارائه‌دهنده',
    platformFeeZero: 'کارمزد پلتفرم AvalAI (۰٪)',
    effectivePerRequest: 'هزینه مؤثر هر درخواست',
    dominantCostDriver: 'بیشترین عامل هزینه',
    providerUsageTruth: 'شیء usage در پاسخ ارائه‌دهنده، مرجع نهایی محاسبه هزینه است.',
    exchangeUnavailable: 'نرخ تبدیل در دسترس نیست',
    currentExchangeRate: 'نرخ تبدیل فعلی',
    unitDefinition: '1 UNIT = 1 USD',
    fallbackCatalog: 'نسخه محدود فهرست عمومی فعال است.',
    unsupportedPrice: 'در حال حاضر قابل محاسبه نیست',
    requests: 'تعداد درخواست‌ها',
    monthlyGrowth: 'رشد ماهانه',
    forecastHorizon: 'بازه پیش‌بینی',
    maxResults: 'حداکثر نتیجه در هر ابزار جستحوی وب',
    monthCount: '{count} ماه',
    assumptions: 'نرخ‌ها و فرضیات',
    retry: 'تلاش دوباره',
    retryExchange: 'تلاش دوباره برای نرخ تبدیل',
    copyEstimate: 'کپی خلاصه برآورد',
    copySuccess: 'برآورد کپی شد',
    copyFailed: 'کپی برآورد انجام نشد',
    resetExample: 'بازنشانی نمونه',
    openTokenizer: 'باز کردن توکن‌پرداز',
    model: 'مدل',
    serviceTier: 'سطح سرویس',
    catalogUnavailable: 'قیمت‌گذاری عمومی در دسترس نیست',
    noPricing: 'قیمت قابل محاسبه‌ای برای این مدل منتشر نشده است.',
    thresholdRateApplied: 'برای این بار کاری نرخ پنجره زمینه بزرگ‌تر فعال است.',
    usageType: 'نوع استفاده',
    quantity: 'مقدار',
    rate: 'نرخ ارائه‌دهنده',
    serviceTier_standard: 'استاندارد',
    serviceTier_flex: 'انعطاف‌پذیر',
    serviceTier_batch: 'دسته‌ای',
    serviceTier_priority: 'اولویت‌دار',
    serviceTier_default: 'استاندارد',
    unit_million_tokens: 'یک میلیون توکن',
    unit_thousand_tokens: 'هزار توکن',
    rateScale: 'مقیاس نرخ',
    rateScalePerMillion: 'به ازای هر یک میلیون توکن',
    rateScalePerThousand: 'به ازای هر هزار توکن',
    unit_character: 'نویسه',
    unit_second: 'ثانیه',
    unit_image: 'تصویر',
    unit_video_second: 'ثانیه ویدئو',
    unit_page: 'صفحه',
    unit_query: 'ابزار جستحوی وب',
    unit_megapixel: 'مگاپیکسل',
    unit_citation: 'استناد',
    pricing_input: 'توکن ورودی',
    pricing_cached_input: 'توکن ورودی کش‌شده',
    pricing_cache_creation_input: 'توکن ایجاد کش',
    pricing_output: 'توکن خروجی',
    pricing_reasoning_output: 'توکن خروجی استدلال',
    pricing_audio_input: 'توکن ورودی صوت',
    pricing_audio_cached_input: 'توکن ورودی صوت کش‌شده',
    pricing_audio_output: 'توکن خروجی صوت',
    pricing_image_input: 'توکن ورودی تصویر',
    pricing_image_cached_input: 'توکن ورودی تصویر کش‌شده',
    pricing_image_output: 'توکن خروجی تصویر',
    pricing_video_input: 'توکن ورودی ویدئو',
    pricing_character_input: 'نویسه ورودی',
    pricing_time: 'مدت زمان',
    pricing_video_output: 'ویدئوی تولیدشده',
    pricing_image_generation: 'تصویر تولیدشده',
    pricing_page_input: 'صفحه ورودی',
    pricing_annotation_page_input: 'صفحه حاشیه‌نویسی',
    pricing_query_input: 'ابزار جستحوی وب',
    pricing_megapixel: 'مگاپیکسل',
    pricing_citation: 'استناد',
    pricing_other: 'سایر موارد استفاده',
    compareModels: 'مقایسه مدل‌ها',
    maxComparison: 'حداکثر چهار مدل را مقایسه کنید',
    estimatedCost: 'هزینه برآوردشده',
    differenceFromLowest: 'اختلاف با کمترین هزینه',
    context: 'پنجره زمینه',
    endpoints: 'نقاط پایانی',
    capabilities: 'قابلیت‌ها',
    pricingSource: 'منبع قیمت‌گذاری',
    provider: 'ارائه‌دهنده',
    minimumTier: 'حداقل سطح حساب',
    serviceTiers: 'سطوح سرویس',
    lifecycleRelease: 'تاریخ انتشار',
    lifecycleSnapshot: 'تاریخ نسخه ثابت',
    lifecycleDeprecation: 'تاریخ توقف',
    lifecycleUnpublished: 'منتشر نشده',
    estimateUnavailable: 'برآورد در دسترس نیست',
    cumulativeCost: 'هزینه تجمعی',
    forecastTable: 'جزئیات پیش‌بینی',
    month: 'ماه',
    rateInput: 'ورودی',
    rateCached: 'کش‌شده',
    rateOutput: 'خروجی',
    unit: 'UNIT',
    irt: 'تومان',
    tokenRange: '{input} / {output}',
    emptyEstimateTitle: 'برای برآورد هزینه، میزان مصرف را وارد کنید',
    emptyEstimateHint: 'برای مشاهده برآورد زنده، تعداد توکن‌ها یا درخواست‌ها را در بالا وارد کنید.',
    comparisonSelected: '{count} / {max} انتخاب‌شده',
    comparisonEmptyTitle: 'مدل‌ها را برای مقایسه انتخاب کنید',
    comparisonEmptyHint: 'تا چهار مدل را در بالا انتخاب کنید تا هزینه‌ها، نرخ‌ها و قابلیت‌ها را کنار هم ببینید.',
    comparisonBestValue: 'بهترین ارزش',
    comparisonMoreItems: '+{count} مورد دیگر'
  },
  tokenizer: {
    title: 'توکن‌پرداز مرورگر',
    description: 'نحوه تقسیم متن ساده با کدگذاری مدل‌های پشتیبانی‌شده OpenAI را در مرورگر بررسی کنید.',
    providerUsageTitle: 'میزان استفاده اعلام‌شده توسط ارائه‌دهنده معتبر است',
    providerUsageTruth:
      'AvalAI روش توکن‌پردازی یا تعداد توکن قابل صورتحساب را تعیین نمی‌کند. شیء usage ارائه‌دهنده که در پاسخ API بازگردانده می‌شود، مرجع نهایی است.',
    localEstimateOnly:
      'این برآورد محلی فقط متن ساده را پوشش می‌دهد. ابزارها، اسکیماها، فایل‌ها، تصویر، صوت و قالب‌بندی ارائه‌دهنده می‌توانند مصرف بیشتری ایجاد کنند.',
    supportedModel: 'مدل پشتیبانی‌شده',
    encoding: 'کدگذاری',
    placeholder: 'متن را برای بررسی توکن‌ها وارد کنید…',
    showExample: 'نمایش نمونه',
    clear: 'پاک کردن',
    copyText: 'کپی متن',
    tokens: 'توکن‌ها',
    characters: 'نویسه‌ها',
    words: 'واژه‌ها',
    averageCharacters: 'میانگین نویسه در هر توکن',
    contextUsage: 'زمینه مصرف‌شده',
    visualization: 'نمایش توکن‌ها',
    textView: 'متن',
    idView: 'شناسه توکن',
    visualizationTruncated: 'فقط {count} توکن نخست نمایش داده می‌شود؛ شمارش کل کامل است.',
    textTooLarge: 'متن نباید بیش از ۲٬۰۰۰٬۰۰۰ نویسه داشته باشد.',
    workerFailed: 'توکن‌پرداز مرورگر راه‌اندازی نشد. دوباره تلاش کنید.',
    noSupportedModels: 'هیچ مدل فهرست‌شده‌ای توسط کتابخانه نصب‌شده پشتیبانی نمی‌شود.',
    localPrivacy: 'توکن‌پردازی در مرورگر محاسبه می شود و متن شما برای AvalAI ارسال نمی‌شود.',
    useInCalculator: 'استفاده در ماشین حساب',
    copySuccess: 'متن کپی شد',
    copyFailed: 'کپی متن انجام نشد',
    emptyVisualization: 'برای بررسی مرز توکن‌ها متن وارد کنید.',
    catalogUnavailable: 'فهرست عمومی مدل‌ها در دسترس نیست',
    retry: 'تلاش دوباره'
  },
  support: {
    title: 'مرکز پشتیبانی',
    description: 'دریافت کمک و مدیریت تیکت‌های پشتیبانی',
    myTickets: 'تیکت‌های من',
    createTicket: 'ایجاد تیکت',
    agent: 'پشتیبان',

    aiOperations: {
      title: 'عملیات هوش مصنوعی پشتیبانی',
      description: 'سلامت اجرای سامانه و فراداده امن اجراهای بین‌تیکتی را بررسی کنید.',
      accessDenied: 'قابلیت مشاهده عملیات هوش مصنوعی پشتیبانی برای شما فعال نیست.',
      openRun: 'باز کردن در عملیات هوش مصنوعی',
      tabs: {
        overview: 'نمای کلی',
        runs: 'اجراها',
        evaluations: 'ارزیابی‌ها'
      },
      filters: {
        window: 'بازه زمانی',
        language: 'زبان',
        operation: 'عملیات',
        state: 'وضعیت',
        ticket: 'شماره تیکت',
        ticketPlaceholder: 'TK-…',
        datasetKey: 'کلید مجموعه‌داده',
        datasetKeyPlaceholder: 'support-core',
        all: 'همه'
      },
      windows: {
        '1h': 'یک ساعت گذشته',
        '24h': '۲۴ ساعت گذشته',
        '7d': '۷ روز گذشته',
        '30d': '۳۰ روز گذشته'
      },
      languages: {
        en: 'انگلیسی',
        fa: 'فارسی'
      },
      audiences: {
        internal: 'داخلی',
        agent: 'پشتیبان'
      },
      evidenceStatus: {
        dataset: {
          missing: 'موجود نیست',
          fresh: 'تازه',
          expired: 'منقضی‌شده'
        },
        hardGate: {
          missing: 'موجود نیست',
          passed: 'قبول‌شده',
          failed: 'ردشده'
        },
        calibration: {
          missing: 'موجود نیست',
          uncalibrated: 'کالیبره‌نشده',
          eligible: 'واجد شرایط',
          passed: 'قبول‌شده',
          failed: 'ردشده'
        }
      },
      metrics: {
        totalRuns: 'کل اجراها',
        completion: 'نرخ تکمیل',
        blocked: 'نرخ توقف',
        failure: 'نرخ خطا',
        timeout: 'نرخ پایان مهلت',
        latency: 'رویدادهای تأخیر',
        retrieval: 'سلامت بازیابی',
        degraded: 'افت‌کیفیت',
        zeroResults: 'بدون نتیجه',
        evaluation: 'شواهد ارزیابی',
        dataset: 'مجموعه‌داده',
        hardGates: 'دروازه‌های قطعی',
        calibration: 'کالیبراسیون',
        rollouts: 'خلاصه عرضه',
        active: 'فعال',
        paused: 'متوقف موقت',
        fenced: 'محصور'
      },
      runs: {
        title: 'صف اجراها',
        empty: 'اجرایی با این فیلترها پیدا نشد.',
        select: 'برای بررسی فراداده امن، یک اجرا را انتخاب کنید.',
        resultCount: '{count} اجرا در این صفحه',
        rowLabel: 'باز کردن اجرای {run} برای تیکت {ticket}',
        loading: 'در حال بارگذاری اجراها…'
      },
      evaluations: {
        title: 'مجموعه‌داده‌های ارزیابی',
        empty: 'هیچ مجموعه‌داده ارزیابی با این فیلتر پیدا نشد.',
        select: 'برای بررسی فراداده امن، یک مجموعه‌داده ارزیابی را انتخاب کنید.',
        resultCount: '{count} مجموعه‌داده ارزیابی در این صفحه',
        rowLabel: 'باز کردن مجموعه‌داده ارزیابی {dataset}، نسخه {version}',
        loading: 'در حال بارگذاری مجموعه‌داده‌های ارزیابی…'
      },
      evaluationDetail: {
        title: 'جزئیات مجموعه‌داده ارزیابی',
        datasetKey: 'کلید مجموعه‌داده',
        version: 'نسخه',
        datasetHash: 'هش مجموعه‌داده',
        schemaHash: 'هش طرح‌واره',
        created: 'زمان ایجاد',
        exampleCount: 'نمونه‌ها',
        languages: 'زبان‌ها',
        categories: 'دسته‌ها',
        examples: 'نمونه‌های ارزیابی',
        inputHash: 'هش ورودی',
        expectedHash: 'هش خروجی مورد انتظار',
        sourceRun: 'شناسه اجرای منبع',
        attested: 'تأیید متصدی',
        redactionAttested: 'تأیید حذف اطلاعات حساس',
        expires: 'انقضای محتوا',
        purged: 'پاک‌سازی محتوا'
      },
      evaluationOrigins: {
        synthetic: 'مصنوعی',
        manually_redacted: 'پاک‌سازی‌شده به‌صورت دستی'
      },
      evaluationCategories: {
        response_quality: 'کیفیت پاسخ',
        citation_grounding: 'پشتوانه استناد',
        safety: 'ایمنی',
        privacy: 'حریم خصوصی',
        routing: 'مسیریابی',
        multilingual: 'چندزبانه'
      },
      detail: {
        title: 'جزئیات اجرا',
        ticket: 'تیکت',
        request: 'شناسه درخواست',
        requester: 'شناسه درخواست‌کننده',
        conversation: 'شناسه گفتگو',
        operation: 'عملیات',
        language: 'زبان',
        state: 'وضعیت',
        stage: 'مرحله',
        cursor: 'نشانگر رویداد',
        created: 'ایجاد',
        updated: 'به‌روزرسانی',
        completed: 'تکمیل',
        blockCategory: 'دسته توقف',
        failureCategory: 'دسته خطا',
        model: 'مدل',
        prompt: 'نسخه پرامپت',
        attempts: 'تعداد تلاش',
        sources: 'منابع',
        events: 'تاریخچه امن رویدادها'
      },
      actions: {
        refresh: 'به‌روزرسانی',
        retry: 'تلاش دوباره',
        previous: 'صفحه قبل',
        next: 'صفحه بعد',
        backToRuns: 'بازگشت به اجراها',
        backToEvaluations: 'بازگشت به ارزیابی‌ها'
      },
      status: {
        loading: 'در حال بارگذاری عملیات هوش مصنوعی پشتیبانی…',
        refreshed: 'داده‌های عملیات هوش مصنوعی پشتیبانی به‌روز شد.'
      },
      errors: {
        summary: 'خلاصه عملیات موقتاً در دسترس نیست.',
        runs: 'صف اجراها موقتاً در دسترس نیست.',
        detail: 'جزئیات این اجرا موقتاً در دسترس نیست.',
        evaluations: 'مجموعه‌داده‌های ارزیابی موقتاً در دسترس نیستند.',
        evaluationDetail: 'جزئیات این مجموعه‌داده ارزیابی موقتاً در دسترس نیست.',
        revoked: 'دسترسی به عملیات هوش مصنوعی پشتیبانی دیگر در دسترس نیست.'
      },
      common: {
        notAvailable: 'در دسترس نیست',
        yes: 'بله',
        no: 'خیر'
      }
    },

    // Navigation
    navigation: {
      dashboard: 'داشبورد',
      backToDashboard: 'بازگشت به داشبورد',
      createTicket: 'ایجاد تیکت',
      myTickets: 'تیکت‌های من',
      allTickets: 'همه تیکت‌ها',
      openTickets: 'تیکت‌های باز',
      inProgress: 'در حال انجام',
      resolved: 'حل شده'
    },

    // Ticket properties
    ticket: {
      subject: 'موضوع',
      description: 'توضیحات',
      status: 'وضعیت',
      priority: 'اولویت',
      category: 'دسته‌بندی',
      createdAt: 'ایجاد شده',
      updatedAt: 'به‌روزرسانی شده',
      assignedTo: 'اختصاص داده شده به',
      ticketNumber: 'شماره تیکت',
      replies: 'پاسخ‌ها',
      attachments: 'فایل‌های پیوست',
      details: 'جزئیات تیکت',
      information: 'اطلاعات تیکت',
      createdBy: 'ایجاد شده توسط',
      username: 'نام کاربری',
      email: 'ایمیل',
      phone: 'شماره تلفن',
      notProvided: 'ندارد',
      resolvedAt: 'حل شده در',
      slaDueAt: 'موعد SLA',
      internalNotes: 'یادداشت‌های داخلی',
      addressInfo: 'اطلاعات آدرس',
      customFields: 'فیلدهای سفارشی',
      selectTicket: 'انتخاب تیکت {ticketNumber}',
      read: 'خوانده شده',
      unread: 'خوانده نشده',
      newBadge: 'جدید',
      updatedBadge: 'به‌روز شده',
      unseenByAgents: 'هنوز توسط هیچ پشتیبانی دیده نشده است',
      updatedSinceView: 'پس از آخرین بازدید شما به‌روزرسانی شده است',
      newCustomerReply: 'پاسخ جدید',
      newCustomerReplyHint: 'کاربر پاسخ داده است — در انتظار پاسخ شما',
      newAgentReply: 'پاسخ جدید',
      newAgentReplyHint: 'پشتیبانی پاسخ داده است — پاسخ جدیدی دارید',
      unassigned: 'اختصاص نیافته',
      unassignedHint: 'این تیکت هنوز به هیچ پشتیبانی اختصاص داده نشده است',
      lastAgentViewAt: 'آخرین بازدید پشتیبان',
      customerLastViewedAt: 'آخرین بازدید کاربر',
      cardAriaLabel: 'تیکت {ticketNumber}: {subject}',
      activityBy: 'توسط: {name}',
      agentReplied: 'پشتیبان پاسخ داد',
      customerReplied: 'کاربر پاسخ داد',
      supportReplied: 'پشتیبانی پاسخ داد',
      youReplied: 'شما پاسخ دادید',
      lastUpdated: 'آخرین به‌روزرسانی',
      replyCount: '{count} پاسخ',
      customerContact: 'اطلاعات تماس مشتری',
      contactNotProvided: 'ایمیل یا شماره تلفن ثبت نشده است',
      createdLabel: 'ایجاد',
      customerReference: 'کاربر {id}',
      unknownCustomer: 'کاربر',
      apiTier4PriorityHint: 'کاربر سطح ۴ API — دارای اولویت بالاتر در پشتیبانی.',
      apiTier5PriorityHint: 'کاربر سطح ۵ API — دارای بالاترین اولویت در پشتیبانی.'
    },

    queue: {
      awaitingAgent: 'در انتظار پاسخ',
      neverAnswered: 'بدون پاسخ پشتیبان',
      waitingUnder12h: 'انتظار کمتر از ۱۲ ساعت',
      waiting12To24h: 'انتظار ۱۲ تا ۲۴ ساعت',
      waitingOver24h: 'انتظار بیش از ۲۴ ساعت',
      neverAnsweredBadge: 'بدون پاسخ',
      neverAnsweredHint: 'هیچ پشتیبانی هنوز پاسخ عمومی برای کاربر ارسال نکرده است',
      notHandled: 'رسیدگی‌نشده',
      userReplied: 'پاسخ کاربر',
      waitingForAgent: 'در انتظار پشتیبان؛ {duration}',
      waitingAgeAria: 'کاربر به مدت {duration} در انتظار پاسخ پشتیبان است',
      aria: {
        awaitingAgent: '{count} تیکت در انتظار پاسخ پشتیبان',
        neverAnswered: '{count} تیکت که هنوز پشتیبان پاسخ نداده است',
        waitingUnder12h: '{count} تیکت با انتظار کمتر از ۱۲ ساعت',
        waiting12To24h: '{count} تیکت با انتظار بین ۱۲ تا ۲۴ ساعت',
        waitingOver24h: '{count} تیکت با انتظار بیش از ۲۴ ساعت'
      }
    },

    account: {
      title: 'حساب کاربری مشتری',
      joinedDate: 'تاریخ عضویت',
      totalPaid: 'مجموع پرداختی (واحد)',
      subscriptionType: 'نوع اشتراک',
      subscriptionStart: 'شروع اشتراک',
      subscriptionEnd: 'پایان اشتراک',
      apiTier: 'سطح API',
      active: 'فعال',
      expired: 'منقضی‌شده',
      noSubscription: 'بدون اشتراک'
    },

    customerAdmin: {
      title: 'مرکز مدیریت مشتری',
      open: 'باز کردن مرکز مدیریت',
      openAria: 'باز کردن مرکز مدیریت مشتری تیکت {ticket}',
      staffOnly: 'ویژه کارشناسان و مدیران پشتیبانی',
      sectionNavigation: 'بخش‌های مدیریت مشتری',
      ticketScopedIdentity: 'هویت مشتری فقط از همین تیکت تعیین می‌شود',
      userScopedIdentity: 'مشتری بر اساس شناسه حساب تعیین شده است (جستجوی پشتیبانی)',
      privacyTitle: 'دسترسی حساس و ثبت‌شونده',
      privacyNotice:
        'اطلاعات تیکت {ticket} فقط هنگام نیاز بارگیری می‌شود. هر مشاهده موفق ثبت شده و با بستن این پنجره پاک می‌شود.',
      privacyNoticeUser:
        'اطلاعات این حساب مشتری فقط هنگام نیاز بارگیری می‌شود. هر مشاهده موفق ثبت شده و با بستن این پنجره پاک می‌شود.',
      loadingSection: 'اطلاعات مدیریت مشتری در حال بارگیری است',
      refreshingSection: 'این بخش در حال به‌روزرسانی است…',
      refreshSection: 'به‌روزرسانی {section}',
      sectionLoaded: 'بخش {section} بارگیری شد',
      scrollableTable: 'جدول پیمایشی مدیریت مشتری',
      scrollHint: 'برای مشاهده ستون‌های بیشتر، جدول را افقی پیمایش کنید. برای جزئیات چرخه و مالی، ردیف را باز کنید.',
      accountActions: {
        menuAria: 'عملیات تماس و حساب {customer}',
        copyEmail: 'کپی ایمیل',
        emailCopied: 'ایمیل مشتری کپی شد',
        copyPhone: 'کپی شماره تلفن',
        phoneCopied: 'شماره تلفن مشتری کپی شد',
        copyId: 'کپی شناسه حساب',
        idCopied: 'شناسه حساب کپی شد',
        copyFailed: 'کپی اطلاعات مشتری ممکن نبود',
        openManagement: 'باز کردن مدیریت حساب در زبانه جدید'
      },
      sections: {
        overview: 'نمای کلی حساب',
        tickets: 'تیکت‌ها',
        credits: 'اعتبار و بسته‌ها',
        activity: 'فعالیت API',
        apiKeys: 'کلیدهای API',
        payments: 'پرداخت‌ها',
        affiliates: 'همکاری در فروش',
        reports: 'گزارش‌ها'
      },
      sectionDescriptions: {
        overview: 'هویت، وضعیت حساب، شاخص‌های امنیتی، مجموع استفاده و اشتراک مشتری را بررسی کنید.',
        tickets: 'تیکت‌های اخیر مشتری، وضعیت آن‌ها و تیکت‌های احتمالاً تکراری را بررسی کنید.',
        credits: 'مانده اعتبار، اعتبارهای هدیه، بسته‌های خریداری‌شده، انقضا و دامنه سرویس را ببینید.',
        activity: 'حجم درخواست، مصرف توکن، هزینه، مدل‌ها، ارائه‌دهندگان و سطح سرویس را تحلیل کنید.',
        apiKeys: 'فهرست کلیدهای پوشانده‌شده، وضعیت عملیاتی، محدودیت‌ها، بودجه و آخرین استفاده را بررسی کنید.',
        payments: 'تراکنش‌ها، وضعیت چرخه، مبالغ و علت امن خطا را فیلتر و بررسی کنید.',
        affiliates: 'عملکرد معرفی، کمیسیون‌ها، برداشت‌ها و جزئیات چرخه را بررسی کنید.',
        reports: 'گزارش مصرف قابل مشاهده برای مشتری بسازید و وضعیت تحویل و دانلود آن را مدیریت کنید.'
      },
      tickets: {
        total: 'کل',
        open: 'باز',
        empty: 'این مشتری تیکتی ندارد.',
        noSubject: '(بدون موضوع)',
        truncated: '{count} تیکت اخیر نمایش داده می‌شود',
        duplicatesTitle: 'تیکت‌های احتمالاً تکراری ({count})',
        duplicateCount: '{count} تیکت ({open} باز) در بازه زمانی نزدیک ثبت شده‌اند',
        actions: {
          menuAria: 'عملیات تیکت {ticket}',
          copyId: 'کپی شناسه تیکت',
          copied: 'تیکت {ticket} کپی شد',
          copyFailed: 'کپی شناسه تیکت ممکن نبود',
          openManagement: 'باز کردن در مدیریت تیکت‌ها'
        },
        columns: {
          ticket: 'تیکت',
          subject: 'موضوع',
          status: 'وضعیت',
          priority: 'اولویت',
          category: 'دسته‌بندی',
          created: 'ایجاد'
        }
      },
      search: {
        launch: 'یافتن مشتری',
        openAria: 'جستجوی مشتری و باز کردن مرکز مدیریت',
        title: 'یافتن مشتری',
        notice: 'با نام کاربری، ایمیل یا شماره تلفن جستجو کنید تا مرکز مدیریت هر حساب باز شود.',
        placeholder: 'نام کاربری، ایمیل یا تلفن…',
        submit: 'جستجو',
        minLength: 'حداقل {count} کاراکتر وارد کنید',
        fastHint: 'شماره تلفن یا ایمیل کامل، یا ابتدای نام کاربری را وارد کنید و سپس جستجو را بزنید.',
        searching: 'در حال جستجو…',
        prompt: 'برای جستجوی مشتری، تایپ کنید.',
        noResults: 'مشتری منطبقی یافت نشد.',
        truncated: 'نتایج بیشتری وجود دارد — جستجو را دقیق‌تر کنید.',
        error: 'جستجو ناموفق بود. دوباره تلاش کنید.',
        open: 'باز کردن',
        copyId: 'کپی شناسه',
        idCopied: 'شناسه مشتری کپی شد',
        openTickets: '{count} باز',
        deepHint: 'حساب‌های حذف‌شده فقط با جستجوی عمیق پیدا می‌شوند؛ این جستجو همه فیلدها را بررسی می‌کند و کندتر است.',
        deepSubmit: 'جستجوی عمیق',
        deepBadge: 'جستجوی عمیق',
        matchedBy: {
          phone: 'مطابقت با تلفن',
          email: 'مطابقت با ایمیل',
          username: 'مطابقت با نام کاربری',
          deep: 'جستجوی عمیق'
        },
        state: {
          active: 'فعال',
          deleted: 'حذف‌شده',
          suspended: 'تعلیق‌شده',
          inactive: 'غیرفعال',
          guest: 'مهمان'
        }
      },
      common: {
        yes: 'بله',
        no: 'خیر',
        retry: 'تلاش دوباره',
        noRecords: 'رکوردی یافت نشد',
        confirm: 'تایید',
        cancel: 'انصراف'
      },
      timeframes: {
        lastHour: 'یک ساعت گذشته',
        last6Hours: '۶ ساعت گذشته',
        last12Hours: '۱۲ ساعت گذشته',
        lastDay: '۲۴ ساعت گذشته',
        last2Days: '۲ روز گذشته',
        last3Days: '۳ روز گذشته',
        lastWeek: '۷ روز گذشته',
        last28Days: '۲۸ روز گذشته',
        last30Days: '۳۰ روز گذشته',
        lastMonth: 'یک ماه گذشته',
        last3Months: '۳ ماه گذشته',
        hours: '{count} ساعت'
      },
      purchaseItems: {
        api: 'اعتبار API',
        credit_package: 'بسته اعتبار',
        tier1: 'سطح ۱',
        tier2: 'پلاس',
        tier2_30: 'پلاس · ۳۰ روز',
        tier2_90: 'پلاس · ۹۰ روز',
        tier2_180: 'پلاس · ۱۸۰ روز',
        tier2_365: 'پلاس · ۳۶۵ روز',
        tier3: 'سطح ۳'
      },
      fields: {
        fullName: 'نام کامل',
        joinedAt: 'تاریخ عضویت',
        lastLogin: 'آخرین ورود',
        country: 'کشور',
        accountType: 'نوع حساب',
        registrationMethod: 'روش ثبت‌نام',
        language: 'زبان',
        updatedAt: 'به‌روزرسانی',
        name: 'نام',
        scope: 'دامنه',
        status: 'وضعیت',
        lastUsed: 'آخرین استفاده',
        model: 'مدل',
        provider: 'ارائه‌دهنده',
        serviceTier: 'سطح سرویس',
        type: 'نوع',
        amount: 'مبلغ',
        details: 'جزئیات',
        createdAt: 'ایجاد',
        expiresAt: 'انقضا',
        trackingCode: 'کد رهگیری',
        actions: 'عملیات'
      },
      overview: {
        verification: 'شاخص‌های احراز و امنیت',
        emailVerified: 'تایید ایمیل',
        phoneVerified: 'تایید تلفن',
        googleVerified: 'تایید ایمیل گوگل',
        twoFactor: 'احراز هویت دو مرحله‌ای',
        suspended: 'تعلیق شده',
        deleted: 'حذف شده',
        guest: 'حساب مهمان',
        dataConsent: 'رضایت استفاده از داده',
        totalPaid: 'کل پرداخت',
        suspensionDate: 'زمان تعلیق',
        suspensionReason: 'علت امن تعلیق',
        deletedAt: 'زمان حذف',
        chats: 'گفتگوهای فعال',
        messages: 'پیام‌های فعال',
        apiKeys: 'کلیدهای API',
        activeApiKeys: 'کلیدهای API فعال',
        subscription: 'اشتراک',
        periodDays: 'دوره (روز)'
      },
      credits: {
        noCredit: 'حساب اعتباری یافت نشد',
        remainingIrt: 'مانده ریالی',
        remainingUnit: 'مانده واحد',
        limit: 'سقف اعتبار',
        grants: 'اعتبارهای هدیه',
        packages: 'بسته‌های خریداری‌شده',
        updatedAt: 'به‌روزرسانی اعتبار',
        lastToppedUp: 'آخرین افزایش اعتبار',
        linkedOrganization: 'استفاده از اعتبار سازمان متصل',
        exhausted: 'مصرف‌شده',
        price: 'قیمت خرید',
        discount: 'تخفیف',
        purchasedAt: 'زمان خرید',
        instrument: 'اعتبار',
        packageInstanceId: 'شناسه بسته خریداری‌شده',
        packageTemplateId: 'شناسه قالب بسته',
        noPackageTemplate: 'بدون قالب متصل',
        allowedServices: 'سرویس‌های مجاز',
        allServices: 'همه سرویس‌ها',
        scopeDetails: 'جزئیات دامنه',
        unrestrictedScope: 'بدون محدودیت دامنه',
        openPackageDetails: 'نمایش جزئیات {package}',
        filterByStatus: 'فیلتر بر اساس وضعیت',
        searchPlaceholder: 'جستجو بر اساس نام، شناسه خرید یا شناسه قالب',
        visibleCount: 'نمایش {visible} از {total}',
        extend: {
          button: 'تمدید',
          packageTitle: 'تمدید بسته اعتباری',
          grantTitle: 'تمدید اعتبار اهدایی',
          target: 'اعتبار',
          newEndDate: 'تاریخ انقضای جدید',
          datePlaceholder: 'تاریخ آینده را انتخاب کنید',
          policyNotice:
            'تمدید فقط تاریخ انقضا را به جلو می‌برد و اعتبار را فعال می‌کند؛ مبلغ و موجودی باقی‌مانده هرگز تغییر نمی‌کند.',
          clearRevoked: 'ابطال‌شده',
          clearRevokedHint: 'پرچم ابطال نیز پاک شود',
          clearSuspended: 'معلق‌شده',
          clearSuspendedHint: 'پرچم تعلیق نیز پاک شود',
          success: 'تاریخ انقضا با موفقیت تمدید شد',
          errors: {
            packageNotFound: 'این بسته اعتباری برای این کاربر یافت نشد.',
            grantNotFound: 'این اعتبار اهدایی برای این کاربر یافت نشد.',
            invalidEndDate: 'تاریخ انقضای جدید باید در آینده باشد.',
            endDateTooFar: 'تاریخ انقضای جدید بیش از حد دور است (حداکثر ۳۶۵ روز).',
            invalidActor: 'حساب شما برای انجام این عملیات مجاز نیست.',
            unavailable: 'تمدید انجام نشد. لطفاً دوباره تلاش کنید.'
          }
        }
      },
      metrics: {
        requests: 'درخواست‌ها',
        successful: 'موفق',
        successRate: 'نرخ موفقیت',
        failed: 'ناموفق',
        tokens: 'توکن‌ها',
        costUnit: 'هزینه (واحد)',
        paidUnit: 'پرداخت‌شده (واحد)',
        paidIrt: 'پرداخت‌شده (ریال)',
        paidGrantIrt: 'پرداخت از اعتبار هدیه (ریال)',
        promptTokens: 'توکن ورودی',
        completionTokens: 'توکن خروجی',
        reasoningTokens: 'توکن استدلال',
        cachedTokens: 'توکن کش‌شده'
      },
      activity: {
        models: 'مصرف مدل‌ها',
        providers: 'ارائه‌دهندگان',
        serviceTiers: 'سطوح سرویس',
        tokenBreakdown: 'تفکیک توکن'
      },
      apiKeys: {
        maskedKey: 'کلید پوشانده‌شده',
        models: 'مدل‌ها',
        endpoints: 'نقاط پایانی',
        monthlyQuota: 'سهمیه ماهانه',
        totalBudget: 'بودجه کل',
        budgetUsed: 'بودجه مصرف‌شده',
        internal: 'کلید داخلی',
        maskingNotice:
          'فقط فراداده کلید پوشانده‌شده نمایش داده می‌شود. کلید خام API و محدودیت‌های IP هرگز در دسترس نیست.'
      },
      filters: {
        any: 'همه',
        apply: 'اعمال فیلترها',
        clear: 'پاک کردن فیلترها',
        activeCount: '{count} فیلتر فعال',
        confirmed: 'تایید شده',
        failed: 'ناموفق',
        hasError: 'دارای خطا',
        dateRange: 'بازه تاریخ',
        status: 'فیلتر وضعیت'
      },
      payments: {
        tracking: 'شناسه پرداخت',
        trackingPlaceholder: 'شناسه عددی، UUID تراکنش یا کد پیگیری دقیق',
        paymentId: 'شناسه پرداخت',
        transactionId: 'شناسه تراکنش',
        item: 'مورد خرید',
        amount: 'مبلغ',
        discountAmount: 'مبلغ تخفیف',
        netAmount: 'مبلغ خالص',
        paidAmount: 'مبلغ پرداختی',
        method: 'روش',
        paymentType: 'نوع پرداخت',
        vat: 'نیازمند مالیات ارزش افزوده',
        confirmedAt: 'زمان تایید',
        failedAt: 'زمان خطا',
        failureReason: 'علت امن خطا',
        bankDetails: 'جزئیات تراکنش بانکی',
        recheck: 'بررسی مجدد',
        recheckConfirmTitle: 'این پرداخت دوباره بررسی شود؟',
        recheckConfirmDescription:
          'این عملیات از ارائه‌دهنده پرداخت می‌خواهد {identifier} را دوباره اعتبارسنجی کند و ممکن است پرداخت را تایید و خرید مشتری را اعمال کند. این تلاش ممیزی می‌شود.',
        recheckConfirmAction: 'بررسی مجدد پرداخت',
        recheckConfirmed: 'ارائه‌دهنده پرداخت را تایید کرد. رکورد پرداخت به‌روز شد.',
        recheckNotConfirmed: 'ارائه‌دهنده پرداخت را تایید نکرد. آخرین وضعیت پرداخت نمایش داده می‌شود.',
        recheckUnavailable: 'این پرداخت در وضعیت فعلی قابل بررسی مجدد نیست.',
        recheckRateLimited: 'تعداد بررسی‌های مجدد پرداخت زیاد است. کمی صبر کنید و دوباره تلاش کنید.',
        recheckFailed: 'بررسی مجدد پرداخت ممکن نبود. جزئیات ارائه‌دهنده نمایش داده نشد.',
        recheckIneligible: {
          already_confirmed: 'این پرداخت قبلا تایید شده است.',
          missing_tracking: 'این پرداخت کد پیگیری قابل اعتبارسنجی ندارد.',
          unavailable: 'این پرداخت به تراکنش قابل اعتبارسنجی ارائه‌دهنده متصل نیست.'
        }
      },
      recordTypes: {
        all: 'همه رکوردها',
        commission: 'کمیسیون‌ها',
        withdrawal: 'برداشت‌ها'
      },
      affiliates: {
        referral: 'خلاصه معرفی',
        code: 'کد معرفی',
        createdAt: 'زمان ایجاد معرفی',
        lastSuccessful: 'آخرین معرفی موفق',
        completedAt: 'زمان تکمیل',
        rejectedAt: 'زمان رد',
        totalReferrals: 'کل معرفی‌ها',
        successfulReferrals: 'معرفی‌های موفق',
        earnings: 'کل درآمد',
        confirmed_commission: 'کمیسیون تاییدشده',
        pending_commission: 'کمیسیون در انتظار',
        withdrawn: 'برداشت‌شده',
        pending_withdrawal: 'برداشت در انتظار'
      },
      reports: {
        generate: 'ساخت گزارش',
        generateCustomerVisible: 'ساخت گزارش قابل مشاهده برای مشتری',
        frame: 'بازه زمانی',
        language: 'زبان',
        origin: 'منشا',
        expiresAt: 'انقضا',
        copyLink: 'کپی پیوند مشتری',
        download: 'دانلود',
        created: 'گزارش مشتری ثبت شد',
        statusUpdated: 'وضعیت یک گزارش در انتظار تغییر کرد.',
        submitSummary:
          'این عملیات گزارش {frame} به زبان {language} را برای مشتری می‌سازد و به صفحه گزارش‌های او می‌افزاید.',
        unavailable_pending: 'گزارش هنوز در حال ساخته‌شدن است.',
        unavailable_failed: 'ساخت گزارش ناموفق بود و امکان دانلود ندارد.',
        unavailable_completed: 'فایل گزارش در دسترس نیست یا منقضی شده است.',
        linkCopied: 'پیوند صفحه گزارش مشتری کپی شد',
        copyFailed: 'کپی پیوند گزارش ممکن نبود',
        downloadFailed: 'دانلود گزارش ممکن نبود',
        customerVisibleNotice:
          'گزارش ساخته‌شده توسط پشتیبانی متعلق به مشتری است و در صفحه گزارش‌های او نمایش داده می‌شود. پیوند اشتراک‌گذاری‌شده فقط پیوند احراز‌شده پلتفرم است و هرگز نشانی فضای ذخیره‌سازی نیست.'
      },
      origins: {
        self_service: 'ایجاد توسط مشتری',
        support: 'پشتیبانی'
      },
      status: {
        total: 'کل',
        yes: 'بله',
        no: 'خیر',
        enabled: 'فعال',
        disabled: 'غیرفعال',
        active: 'فعال',
        inactive: 'غیرفعال',
        revoked: 'لغوشده',
        suspended: 'تعلیق‌شده',
        expired: 'منقضی‌شده',
        draft: 'پیش‌نویس',
        locked: 'قفل‌شده',
        processing: 'در حال پردازش',
        confirmed: 'تاییدشده',
        pending: 'در انتظار',
        completed: 'تکمیل‌شده',
        rejected: 'ردشده',
        cancelled: 'لغوشده',
        failed: 'ناموفق'
      },
      validation: {
        tracking:
          'شناسه عددی پرداخت، UUID تراکنش یا کد پیگیری دقیق را فقط با حروف، عدد، نقطه، زیرخط، دونقطه، ممیز یا خط تیره وارد کنید.',
        dateRange: 'بازه‌ای مرتب و حداکثر ۳۶۶ روزه انتخاب کنید.',
        confirmedAndFailed: 'پرداخت نمی‌تواند هم تاییدشده و هم ناموفق باشد.',
        confirmedStateFailed: 'پرداخت با وضعیت تاییدشده نمی‌تواند ناموفق نیز فیلتر شود.',
        failedStateConfirmed: 'پرداخت با وضعیت ناموفق نمی‌تواند تاییدشده نیز فیلتر شود.'
      },
      gatewayBypass: {
        title: 'دور زدن تطبیق کارت با موبایل درگاه',
        status: 'وضعیت فعلی',
        enabled: 'فعال',
        disabled: 'غیرفعال',
        description:
          'با فعال بودن، این مشتری مورد اعتماد از تایید کارت‌به‌موبایل زیبال برای پرداخت خریدها معاف می‌شود. این گزینه محدودیت هفتگی پرداخت با تلفن تاییدنشده را دور نمی‌زند.',
        enableAction: 'فعال‌سازی معافیت',
        disableAction: 'غیرفعال‌سازی معافیت',
        confirmTitle: 'تغییر معافیت درگاه؟',
        confirmEnable:
          'معافیت تایید کارت‌به‌موبایل برای این مشتری فعال شود؟ فقط برای حساب‌های معتبر و مورد اعتماد انجام دهید.',
        confirmDisable: 'معافیت تایید کارت‌به‌موبایل برای این مشتری غیرفعال شود؟',
        enabledSuccess: 'معافیت درگاه برای این مشتری فعال شد.',
        disabledSuccess: 'معافیت درگاه برای این مشتری غیرفعال شد.',
        unavailable: 'تغییر معافیت درگاه برای این مشتری ممکن نبود.'
      },
      subscription: {
        title: 'لغو اشتراک پلاس و بازپرداخت',
        noPaidSubscription: 'این مشتری اشتراک پولی فعالی ندارد.',
        remainingDays: 'روزهای باقی‌مانده',
        estimatedRefund: 'بازپرداخت تخمینی',
        purchasedAt: 'تاریخ خرید',
        payment: 'پرداخت مرتبط',
        bankDetails: 'جزئیات تراکنش بانکی',
        refundTitle: 'بازپرداخت انجام شد',
        refundAmount: 'مبلغ بازپرداخت',
        paidAmount: 'مبلغ واقعی پرداخت‌شده',
        cancelAction: 'لغو اشتراک و بازپرداخت',
        notCancellable:
          'این اشتراک از اینجا قابل لغو نیست. فقط اشتراک‌های پلاس (tier2) فعال با پرداخت دارای کد رهگیری واجد شرایط هستند.',
        cancelModalTitle: 'لغو اشتراک پلاس',
        cancelWarning:
          'این کار بلافاصله اشتراک را پایان می‌دهد، اعتبارهای اشتراک باقی‌مانده را حذف می‌کند و بازپرداخت را محاسبه می‌کند. این عمل قابل بازگشت نیست.',
        trackingConfirmLabel: 'برای تایید، کد رهگیری پرداخت را وارد کنید',
        trackingConfirmHint:
          'دکمه لغو تنها زمانی فعال می‌شود که کد رهگیری واردشده دقیقا با پرداخت اشتراک مطابقت داشته باشد.',
        cancelConfirmAction: 'لغو و بازپرداخت',
        cancelSuccess: 'اشتراک لغو و بازپرداخت محاسبه شد.',
        cancelUnavailable: 'لغو اشتراک ممکن نبود. کد رهگیری و وضعیت اشتراک را بررسی کنید.',
        policy: {
          title: 'سیاست بازپرداخت',
          elapsed: 'زمان سپری‌شده از خرید',
          daysUnit: 'روز',
          refundAmount: 'بازپرداخت طبق سیاست',
          full24h: 'بازپرداخت کامل (کمتر از ۲۴ ساعت)',
          full3d: 'بازپرداخت کامل (کمتر از ۳ روز)',
          prorated: 'بازپرداخت به‌نسبت روزهای باقی‌مانده',
          ineligible: 'قابل محاسبهٔ خودکار نیست'
        },
        templates: {
          copyButton: 'کپی متن پاسخ',
          proposal: 'پیشنهاد بازپرداخت (فارسی)',
          done: 'اتمام بازپرداخت (فارسی)',
          copied: 'متن در کلیپ‌بورد کپی شد.',
          copyFailed: 'کپی متن در کلیپ‌بورد ممکن نبود.'
        }
      },
      errors: {
        title: 'بارگیری این بخش ممکن نبود',
        refreshTitle: 'به‌روزرسانی این بخش ممکن نبود',
        forbidden: 'دسترسی مدیر پشتیبانی شما تایید نشد.',
        notFound: 'تیکت یا رکورد محدود به مشتری یافت نشد.',
        rateLimited: 'تعداد درخواست‌های حساس زیاد است. کمی صبر کنید و دوباره تلاش کنید.',
        loadFailed: 'اطلاعات حساس مشتری موقتا در دسترس نیست.',
        writeFailed: 'انجام این عملیات ممکن نبود.',
        writeQuotaExceeded: 'به سقف روزانه عملیات حساس پشتیبانی رسیده‌اید.'
      }
    },

    // Status values
    statuses: {
      open: 'باز',
      inProgress: 'در حال انجام',
      waitingCustomer: 'در انتظار کاربر',
      waitingForAgent: 'در انتظار کارشناس',
      resolved: 'حل شده',
      closed: 'بسته شده'
    },

    // Status values (alternative format for compatibility)
    status: {
      open: 'باز',
      in_progress: 'در حال انجام',
      inProgress: 'در حال انجام',
      waiting_customer: 'در انتظار کاربر',
      waitingCustomer: 'در انتظار کاربر',
      waiting_for_agent: 'در انتظار کارشناس',
      waitingForAgent: 'در انتظار کارشناس',
      resolved: 'حل شده',
      closed: 'بسته شده'
    },

    // Priority values
    priorities: {
      low: 'پایه',
      medium: 'متوسط',
      high: 'بالا',
      critical: 'بحرانی'
    },

    // Priority values (alternative format for compatibility)
    priority: {
      low: 'پایه',
      medium: 'متوسط',
      high: 'بالا',
      critical: 'بحرانی'
    },

    // Categories
    categories: {
      title: 'دسته‌بندی‌های پشتیبانی',
      technical: 'مسئله فنی',
      billing: 'صورتحساب',
      account: 'حساب کاربری',
      feature: 'درخواست ویژگی',
      bug: 'گزارش باگ',
      other: 'سایر'
    },

    // Actions
    actions: {
      create: 'ایجاد تیکت',
      reply: 'ارسال پاسخ',
      previewReply: 'پیش‌نمایش پاسخ',
      attach: 'پیوست فایل',
      filter: 'فیلتر',
      search: 'جستجوی تیکت‌ها...',
      submit: 'ارسال',
      cancel: 'لغو',
      save: 'ذخیره',
      edit: 'ویرایش',
      delete: 'حذف',
      close: 'بستن تیکت',
      reopen: 'باز کردن مجدد تیکت',
      closeTicket: 'بستن تیکت',
      reopenTicket: 'باز کردن مجدد تیکت',
      moreActions: 'عملیات بیشتر',
      assign: 'اختصاص',
      viewDetails: 'مشاهده جزئیات',
      downloadAttachment: 'دانلود',
      viewAll: 'مشاهده همه',
      back: 'بازگشت',
      changeStatus: 'تغییر وضعیت',
      changePriority: 'تغییر اولویت',
      download: 'دانلود',
      searchAll: 'جستجو در همه تیکت‌ها...',
      clearFilters: 'پاک کردن فیلترها',
      retryNow: 'تلاش مجدد',
      refresh: 'بروزرسانی',
      refreshDashboardStats: 'بروزرسانی آمار داشبورد',
      refreshTicketDetails: 'بروزرسانی جزئیات تیکت',
      assignTicket: 'باز کردن کنترل‌های اختصاص تیکت {ticketNumber}',
      changeTicketStatus: 'باز کردن کنترل‌های وضعیت تیکت {ticketNumber}',
      ticketsRefreshed: 'تیکت‌ها بروزرسانی شدند',
      createTicket: 'ایجاد تیکت',
      yes: 'بله',
      no: 'خیر',
      resolveAndReply: 'حل و ارسال پاسخ',
      closeAndReply: 'بستن و ارسال پاسخ'
    },

    // پیش‌نمایش پاسخ برای کارشناسان
    preview: {
      title: 'پیش‌نمایش پاسخ',
      subtitle: 'قبل از ارسال، پاسخ خود را بررسی کنید',
      internalNoteTitle: 'پیش‌نمایش یادداشت داخلی',
      replyContent: 'متن پاسخ',
      internalReply: 'یادداشت داخلی',
      publicReply: 'پاسخ عمومی',
      internalNote: 'این یک یادداشت داخلی است و فقط برای کارشناسان قابل مشاهده است',
      publicNote: 'این پاسخ برای کاربر قابل مشاهده خواهد بود',
      agentsOnly: 'فقط کارشناسان',
      characters: 'کاراکتر',
      statusChange: 'وضعیت تغییر خواهد کرد به',
      currentStatus: 'فعلی',
      confirmTitle: 'آماده ارسال؟',
      confirmMessage: 'لطفا محتوای بالا را با دقت بررسی کنید. پس از ارسال، این پاسخ برای کاربر قابل مشاهده خواهد بود.',
      confirmMessageInternal:
        'این یادداشت داخلی فقط برای کارشناسان و تیم پشتیبانی قابل مشاهده است. کاربر این پیام را نخواهد دید.',
      checkContent: 'محتوا را از نظر صحت بررسی کرده‌ام',
      checkTone: 'لحن پیام حرفه‌ای و مفید است',
      checkCustomerVisible: 'می‌دانم که این پاسخ برای کاربر قابل مشاهده خواهد بود',
      unmodifiedTemplateTitle: 'قالب بدون تغییر شناسایی شد',
      unmodifiedTemplateMessage:
        'شما قالب یا پاسخ آماده درج‌شده را ویرایش نکرده‌اید. لطفا بررسی کنید و مطمئن شوید این پاسخ برای این تیکت صحیح است، سپس ادامه دهید.',
      unmodifiedTemplateAcknowledge: 'می‌دانم که این قالب/پاسخ آماده را تغییر نداده‌ام و تأیید می‌کنم پاسخ صحیح است',
      edit: 'ویرایش پاسخ',
      confirm: 'ارسال پاسخ',
      sendInternal: 'ارسال یادداشت داخلی',
      escToCancel: 'برای لغو کلید Esc را فشار دهید'
    },

    // Forms
    forms: {
      subjectPlaceholder: 'موضوع تیکت را وارد کنید',
      descriptionPlaceholder: 'مسئله را شرح دهید...',
      replyPlaceholder: 'پیام خود را وارد کنید...',
      selectCategory: 'دسته‌بندی را انتخاب کنید',
      selectPriority: 'اولویت را انتخاب کنید',
      selectOption: 'گزینه را انتخاب کنید',
      emailPlaceholder: 'name@example.com',
      cardNumberPlaceholder: '۰۰۰۰ ۰۰۰۰ ۰۰۰۰ ۰۰۰۰',
      cardNumberLabel: 'شماره کامل ۱۶ رقمی کارت بانکی',
      cardNumberHelp: 'شماره کامل ۱۶ رقمی کارت بانکی را وارد کنید.',
      ibanPlaceholder: 'IR ۰۰۰۰ ۰۰۰۰ ۰۰۰۰ ۰۰۰۰ ۰۰۰۰ ۰۰',
      fileUpload: 'آپلود فایل',
      dragDropFiles: 'فایل‌ها را اینجا بکشید و رها کنید یا کلیک کنید',
      maxFileSize: 'حداکثر اندازه فایل: {size} مگابایت',
      allowedTypes: 'انواع فایل مجاز: {types}',
      useTemplate: 'استفاده از قالب',
      selectTemplate: 'قالب را انتخاب کنید',
      cannedResponses: 'پاسخ‌های آماده',
      selectCannedResponse: 'پاسخ آماده را انتخاب کنید',
      categorySpecificFields: 'فیلدهای مخصوص دسته‌بندی',
      dynamicOptionsLoadError:
        'بارگذاری پیشنهادهای این فیلد ممکن نشد. اگر این فیلد پشتیبانی کند، همچنان می‌توانید مقدار را دستی وارد کنید.',
      dynamicOptionsEmpty: 'پیشنهادی برای این فیلد در دسترس نیست.',
      dynamicManualEntryHint: 'برای مقدار دلخواه، آن را تایپ کنید و Enter بزنید.',
      unsupportedFieldType: 'نوع فیلد پشتیبانی نمی‌شود: {type}',
      unsupportedFieldContactSupport: 'این نوع فیلد پشتیبانی نمی‌شود. لطفا با پشتیبانی تماس بگیرید.'
    },

    customerAI: {
      initialResponseLabel: 'دریافت پاسخ اولیه با کمک هوش مصنوعی',
      initialResponseDisclosure:
        'هوش مصنوعی ممکن است اشتباه کند. پاسخ‌ها بر پایه منابع رسمی AvalAI تهیه می‌شوند و بررسی توسط کارشناس همچنان در دسترس است.',
      queuedTitle: 'پاسخ هوش مصنوعی در صف قرار گرفت',
      queuedNote:
        'پاسخ کمکی هوش مصنوعی در حال آماده‌سازی است. در این فاصله می‌توانید همچنان از بخش پشتیبانی استفاده کنید.',
      replyDisclosure: 'این پاسخ توسط هوش مصنوعی AvalAI آماده شده و ممکن است اشتباه داشته باشد.',
      sources: 'منابع',
      thumbsUp: 'پاسخ مفید بود',
      thumbsDown: 'پاسخ مفید نبود',
      requestAgentReview: 'درخواست بررسی کارشناس',
      feedbackReason: 'دلیل',
      feedbackComment: 'توضیحات تکمیلی (اختیاری)',
      submitFeedback: 'ثبت بازخورد',
      cancelFeedback: 'انصراف',
      statusLoading: 'وضعیت پاسخ هوش مصنوعی در حال بررسی است.',
      statusPending: 'پاسخ هوش مصنوعی در حال آماده‌سازی است.',
      statusClarification: 'پاسخ هوش مصنوعی به توضیح بیشتری از سوی شما نیاز دارد.',
      statusHumanRequired: 'این تیکت باید توسط کارشناس بررسی شود.',
      statusHumanRequested: 'درخواست بررسی کارشناس ثبت شده است.',
      statusStopped: 'پاسخ‌گویی خودکار متوقف شده است.',
      statusAnswered: 'پاسخ هوش مصنوعی در گفت‌وگو در دسترس است.',
      statusNotRequested: 'هیچ پاسخ خودکاری در حال پردازش نیست.',
      feedbackReasons: {
        incorrect: 'نادرست',
        outdated: 'قدیمی',
        unhelpful: 'غیرمفید',
        unclear: 'نامفهوم',
        other: 'سایر موارد'
      },
      errors: {
        unavailable: 'وضعیت پاسخ هوش مصنوعی موقتا در دسترس نیست.',
        feedback: 'ثبت بازخورد ممکن نشد. دوباره تلاش کنید.'
      },
      humanReview: {
        title: 'بررسی کارشناس درخواست شود؟',
        confirmHistory: 'پاسخ‌گویی خودکار متوقف می‌شود. گفت‌وگو و سابقه پاسخ‌های موجود همچنان در دسترس می‌ماند.',
        confirm: 'درخواست بررسی',
        cancel: 'انصراف',
        success: 'درخواست بررسی کارشناس ثبت شد.',
        error: 'درخواست بررسی کارشناس ثبت نشد. دوباره تلاش کنید.'
      },
      agentQueue: {
        state: 'وضعیت هوش مصنوعی',
        feedback: 'بازخورد فعلی',
        responses: 'پاسخ‌های هوش مصنوعی'
      },
      agentMeta: {
        answer: 'پاسخ هوش مصنوعی',
        clarification: 'درخواست توضیح هوش مصنوعی',
        grounded: 'مبتنی بر منبع',
        not_required: 'بدون نیاز به منبع',
        voteUp: 'بازخورد مفید',
        voteDown: 'بازخورد غیرمفید',
        humanPending: 'در انتظار بررسی کارشناس',
        stopReasons: {
          enrolled: 'پاسخ هوش مصنوعی فعال شد',
          attempt_started: 'تلاش هوش مصنوعی آغاز شد',
          answer_published: 'پاسخ هوش مصنوعی منتشر شد',
          clarification_published: 'درخواست توضیح هوش مصنوعی منتشر شد',
          clarification_answered: 'توضیح تکمیلی پاسخ داده شد',
          customer_request: 'با درخواست مشتری متوقف شد',
          human_activity: 'پس از فعالیت کارشناس متوقف شد',
          policy_block: 'به دلیل سیاست ایمنی متوقف شد',
          provider_failure: 'پس از خطای سرویس هوش مصنوعی متوقف شد',
          stale_ticket: 'به دلیل تغییر تیکت متوقف شد',
          disabled: 'هوش مصنوعی مشتری غیرفعال شد',
          retention_cleanup: 'به دلیل پاک‌سازی دوره نگهداری متوقف شد'
        }
      }
    },

    // Priority selection guidance (create ticket)
    priorityGuide: {
      infoLabel: 'اولویت تیکت چگونه کار می‌کند',
      infoTrigger: 'بیشتر بیاموزید',
      currentMax: 'پلن شما می‌تواند اولویت را تا سطح {level} تنظیم کند.',
      lockedTooltip: 'اولویت {level} در پلن فعلی شما در دسترس نیست.',
      lockedOption: '{level} (نیازمند ارتقا)',
      modalTitle: 'انتخاب اولویت مناسب',
      modalIntro:
        'اولویت به تیم پشتیبانی ما کمک می‌کند تا میزان فوریت مشکل شما را درک کند. سطوح اولویت بالاتر برای حساب‌های دارای اشتراک پلاس یا سطح دسترسی API بالاتر در نظر گرفته شده‌اند تا تیم ما بتواند ابتدا به فوری‌ترین موارد رسیدگی کند.',
      yourAccess: 'دسترسی فعلی شما',
      yourAccessLow:
        'حساب شما می‌تواند تیکت‌هایی با اولویت پایه ایجاد کند. این گزینه برای پرسش‌های عمومی و درخواست‌های غیرفوری مناسب است.',
      yourAccessMedium:
        'حساب شما می‌تواند اولویت را تا سطح متوسط تنظیم کند — از اینکه عضو پلاس هستید یا به سطح دسترسی API ۳ رسیده‌اید سپاسگزاریم.',
      yourAccessHigh: 'حساب شما به لطف سطح دسترسی API ۴، می‌تواند اولویت را تا سطح بالا تنظیم کند.',
      yourAccessCritical:
        'حساب شما به لطف سطح دسترسی API ۵، می‌تواند اولویت را تا سطح بحرانی (بالاترین سطح) تنظیم کند.',
      unlockedBySubscription: 'با اشتراک پلاس شما فعال شده است',
      unlockedByApiTier: 'با سطح دسترسی API شما فعال شده است',
      ladderTitle: 'سطوح اولویت',
      levels: {
        lowTitle: 'پایه',
        lowRequirement: 'در دسترس همه',
        lowDescription: 'پرسش‌های عمومی و درخواست‌های غیرفوری.',
        mediumTitle: 'متوسط',
        mediumRequirement: 'اشتراک پلاس یا سطح دسترسی API ۳ به بالا',
        mediumDescription: 'مشکلاتی که بر کار شما تاثیر دارند اما کمی قابل انتظار هستند.',
        highTitle: 'بالا',
        highRequirement: 'سطح دسترسی API ۴ به بالا',
        highDescription: 'مشکلات مهمی که نیاز به رسیدگی سریع دارند.',
        criticalTitle: 'بحرانی',
        criticalRequirement: 'سطح دسترسی API ۵',
        criticalDescription: 'اختلالات فوری و تاثیرگذار بر کسب‌وکار.'
      },
      availableBadge: 'در پلن شما در دسترس است',
      lockedBadge: 'در پلن شما نیست',
      upgradeTitle: 'به اولویت بالاتری نیاز دارید؟',
      upgradeDescription:
        'برای فعال‌سازی سطوح اولویت بالاتر، به اشتراک پلاس ارتقا دهید یا سطح دسترسی API خود را افزایش دهید.',
      viewPlusPlans: 'مشاهده پلن‌های پلاس',
      viewApiTiers: 'مشاهده سطوح دسترسی API',
      agentNote:
        'کارشناسان پشتیبانی ما می‌توانند اولویت هر تیکت را پس از ایجاد آن تغییر دهند، پس اگر نمی‌توانید سطح دلخواه خود را انتخاب کنید نگران نباشید. تمامی درخواست‌های پشتیبانی در اسرع وقت بررسی خواهند شد.',
      close: 'متوجه شدم'
    },

    // Filters
    filters: {
      title: 'فیلترها',
      status: 'وضعیت',
      statusHint: 'صف کارشناس را بر اساس وضعیت فعلی گردش کار تیکت فیلتر کنید.',
      allStatuses: 'همه وضعیت‌ها',
      priority: 'اولویت',
      category: 'دسته‌بندی',
      dateRange: 'بازه زمانی',
      assignedTo: 'اختصاص داده شده به',
      createdBy: 'ایجاد شده توسط',
      clearFilters: 'پاک کردن فیلترها',
      applyFilters: 'اعمال فیلترها',
      showFilters: 'نمایش فیلترها',
      hideFilters: 'مخفی کردن فیلترها',
      activeFilters: 'فیلترهای فعال',
      search: 'جستجو',
      searchPlaceholder: 'جستجو در تیکت‌ها، ایمیل یا تلفن…',
      searchHint: 'در متن و شماره تیکت جستجو کنید یا ایمیل یا شماره تلفن کامل مشتری را وارد کنید.',
      searchSubmit: 'جستجو',
      unassigned: 'بدون مسئول',
      assignedToMe: 'اختصاص داده شده به من',
      assignee: 'مسئول',
      customerAccount: 'نوع حساب کاربر',
      apiAccounts: 'سطح دسترسی API',
      chatAccounts: 'اشتراک چت',
      apiTier: 'سطح API',
      apiTierZero: 'API فعال نشده',
      apiTier0: 'سطح ۰ API',
      apiTier1: 'سطح ۱ API',
      apiTier2: 'سطح ۲ API',
      apiTier3: 'سطح ۳ API',
      apiTier4: 'سطح ۴ API',
      apiTier5: 'سطح ۵ API',
      plusSubscription: 'اشتراک پلاس',
      freeAccount: 'حساب رایگان',
      collaboration: 'پیگیری پشتیبانی',
      needsHumanReview: 'نیازمند بررسی کارشناس'
    },

    // View modes
    viewModes: {
      grid: 'نمایش موزائیکی',
      list: 'نمایش لیستی'
    },

    // Views
    views: {
      grid: 'موزائیک',
      list: 'لیست'
    },

    // Sorting
    sorting: {
      sortBy: 'مرتب‌سازی بر اساس',
      newest: 'جدیدترین',
      oldest: 'قدیمی‌ترین',
      priority: 'اولویت',
      status: 'وضعیت',
      updated: 'به‌روزرسانی شده اخیر',
      createdAt: 'تاریخ ایجاد',
      updatedAt: 'تاریخ به‌روزرسانی',
      subject: 'موضوع',
      recommended: 'اولویت پیشنهادی',
      waitingTime: 'زمان انتظار',
      ascending: 'مرتب‌سازی صعودی',
      descending: 'مرتب‌سازی نزولی'
    },

    // Messages
    messages: {
      noTickets: 'تیکت یافت نشد',
      noTicketsDescription: 'شما هنوز هیچ تیکت پشتیبانی ایجاد نکرده‌اید.',
      ticketCreated: 'تیکت با موفقیت ایجاد شد',
      ticketUpdated: 'تیکت با موفقیت به‌روزرسانی شد',
      replyAdded: 'پاسخ با موفقیت اضافه شد',
      fileUploaded: 'فایل با موفقیت آپلود شد',
      ticketClosed: 'تیکت با موفقیت بسته شد',
      ticketReopened: 'تیکت با موفقیت باز شد',
      confirmCloseTicket:
        'آیا مطمئن هستید که می‌خواهید این تیکت را ببندید؟ این کار از پاسخ‌های بیشتر جلوگیری می‌کند تا زمانی که تیکت دوباره باز شود.',
      confirmReopenTicket:
        'آیا مطمئن هستید که می‌خواهید این تیکت را دوباره باز کنید؟ این کار اجازه می‌دهد پاسخ‌های جدید اضافه شوند.',
      errorClosingTicket: 'خطا در بستن تیکت',
      errorReopeningTicket: 'خطا در باز کردن مجدد تیکت',
      loadingTickets: 'در حال بارگذاری تیکت‌ها...',
      loadingTicket: 'در حال بارگذاری جزئیات تیکت...',
      errorLoadingTickets: 'خطا در بارگذاری تیکت‌ها',
      errorLoadingTicket: 'خطا در بارگذاری جزئیات تیکت',
      errorLoadingDashboard: 'خطا در بارگذاری داشبورد پشتیبانی',
      profileUnavailable: 'نمایه پشتیبانی موقتا در دسترس نیست.',
      statisticsUnavailable: 'آمار پشتیبانی موقتا در دسترس نیست.',
      ticketNotFoundWithNumber: 'تیکت {ticketNumber} یافت نشد. ممکن است حذف شده باشد.',
      ticketLoadFailedWithNumber: 'خطا در بارگذاری تیکت {ticketNumber}. لطفا دوباره تلاش کنید.',
      errorRefreshingDashboardStats: 'خطا در بروزرسانی آمار داشبورد',
      errorCreatingTicket: 'خطا در ایجاد تیکت',
      errorAddingReply: 'خطا در ارسال پاسخ',
      aiReplySubmissionUncertain:
        'ممکن است پاسخ ارسال شده باشد. بدون تغییر دوباره تلاش کنید یا پیش از ارسال پاسخ متفاوت، تیکت را تازه‌سازی کنید.',
      aiReplyChangedAfterUncertainSubmission:
        'این پاسخ پس از ارسال نامشخص تغییر کرده است. پیش از ارسال نسخه ویرایش‌شده، تیکت را تازه‌سازی کنید.',
      statusUpdated: 'وضعیت با موفقیت به‌روزرسانی شد',
      errorUpdatingStatus: 'خطا در به‌روزرسانی وضعیت',
      priorityUpdated: 'اولویت با موفقیت به‌روزرسانی شد',
      errorUpdatingPriority: 'خطا در به‌روزرسانی اولویت',
      ticketAssigned: 'تیکت با موفقیت اختصاص داده شد',
      ticketUnassigned: 'اختصاص تیکت با موفقیت لغو شد',
      errorAssigningTicket: 'خطا در اختصاص تیکت',
      ticketNotFound: 'تیکت یافت نشد',
      ticketNotFoundDesc: 'تیکت مورد نظر شما وجود ندارد یا شما مجوز مشاهده آن را ندارید.',
      retrySuccess: 'عملیات با موفقیت انجام شد',
      retryFailed: 'تلاش مجدد ناموفق بود. لطفا دوباره تلاش کنید.',
      resetSuccess: 'بازنشانی با موفقیت انجام شد',
      resetFailed: 'بازنشانی ناموفق بود. لطفا دوباره تلاش کنید.',
      ticketsRefreshed: 'تیکت‌ها با موفقیت به‌روزرسانی شدند',
      loadError: 'خطا در بارگذاری داده‌ها. لطفا دوباره تلاش کنید.',
      searchError: 'جستجو ناموفق بود. لطفا دوباره تلاش کنید.',
      feedbackError: 'خطا در ارسال بازخورد. لطفا دوباره تلاش کنید.',
      exportSuccess: 'تیکت‌ها با موفقیت خروجی گرفته شدند',
      exportError: 'خطا در خروجی گرفتن از تیکت‌ها',
      networkError: 'خطای شبکه. لطفا اتصال خود را بررسی کرده و دوباره تلاش کنید.'
    },

    // Dashboard
    dashboard: {
      title: 'پشتیبانی',
      returnToChat: 'بازگشت به صفحه گفتگوها',
      returnToChatHint: 'درخواست‌های پشتیبانی خود را اینجا مدیریت کنید و هر زمان خواستید به گفتگوها برگردید.',
      overview: 'نمای کلی',
      myStats: 'آمار من',
      recentActivity: 'فعالیت‌های اخیر',
      quickActions: 'اقدامات سریع',
      totalTickets: 'کل تیکت‌ها',
      openTickets: 'تیکت‌های باز',
      resolvedTickets: 'تیکت‌های حل شده',
      avgResponseTime: 'میانگین زمان پاسخ'
    },

    // Ticket details
    ticketDetails: {
      conversation: 'مکالمه',
      information: 'اطلاعات تیکت',
      createdBy: 'ایجاد شده توسط',
      assignedTo: 'اختصاص داده شده به',
      lastUpdated: 'آخرین به‌روزرسانی',
      timeSpent: 'زمان صرف شده',
      slaStatus: 'وضعیت SLA',
      onTime: 'به موقع',
      overdue: 'عقب افتاده',
      dueIn: 'موعد در {time}',
      toggleInformation: 'تغییر نمایش اطلاعات تیکت'
    },

    // Message and reply types
    message: {
      original: 'پیام اصلی',
      viewRaw: 'نمایش متن خام',
      viewFormatted: 'نمایش بهینه',
      copy: 'کپی پیام',
      copyFormatted: 'کپی',
      copyRaw: 'کپی متن خام',
      copiedFormatted: 'کپی شد',
      copiedRaw: 'متن خام کپی شد',
      copyFailed: 'کپی پیام انجام نشد'
    },

    replyType: {
      public: 'عمومی',
      internal: 'داخلی'
    },

    // Reply form labels
    reply: {
      type: 'نوع پاسخ',
      public: 'پاسخ عمومی',
      internal: 'یادداشت داخلی',
      templateLanguage: 'زبان قالب پاسخ',
      templateFa: 'فارسی',
      templateEn: 'English',
      resetTemplate: 'بازنشانی قالب',
      resetTemplateConfirm: 'با بازنشانی، پیش‌نویس فعلی شما با قالب خالی پاسخ جایگزین می‌شود. ادامه می‌دهید؟',
      templateHint: 'پاسخ خود را بین خط درود و خطوط پایانی بنویسید.',
      refreshTemplates: 'به‌روزرسانی قالب‌ها',
      refreshCannedResponses: 'به‌روزرسانی پاسخ‌ها',
      searchCannedResponses: 'جست‌وجوی پاسخ بر اساس عنوان، متن یا دسته‌بندی',
      cannedResponsesLoading: 'در حال بارگیری پاسخ‌های آماده…',
      cannedResponsesEmpty: 'پاسخ آماده‌ای در دسترس نیست. دوباره بارگیری کنید.',
      cannedResponsesNoResults: 'پاسخ آماده‌ای مطابق جست‌وجوی شما پیدا نشد.',
      clearCannedResponse: 'پاک کردن انتخاب',
      insertCannedResponse: 'درج در پیش‌نویس',
      replaceCannedResponse: 'جایگزینی متن پاسخ',
      appendCannedResponse: 'افزودن به انتها',
      cannedRelevance: {
        category: 'پیشنهادشده برای این دسته‌بندی',
        general: 'پاسخ عمومی',
        other: 'دسته‌بندی دیگر'
      },
      templatesUnavailable:
        'قالب‌های پاسخ در حال حاضر در دسترس نیستند. می‌توانید پاسخ را آزادانه بنویسید یا قالب‌ها را دوباره بارگیری کنید.',
      scenario: 'سناریوی پاسخ',
      selectScenario: 'درج قالب سناریو',
      suggestedScenario: 'پیشنهاد برای این تیکت: {title}',
      customFieldSummary: 'جزئیات ثبت‌شده توسط کاربر',
      insertCustomFieldSummary: 'درج جزئیات'
    },

    aiAssistant: {
      title: 'دستیار هوش مصنوعی',
      suggestions: 'پیشنهادها',
      chat: 'گفت‌وگو',
      sources: 'منابع',
      operations: {
        generate_reply: 'ایجاد پاسخ',
        improve: 'بهبود پیش‌نویس',
        shorten: 'کوتاه‌تر کردن پیش‌نویس',
        expand: 'گسترش پیش‌نویس',
        change_tone: 'تغییر لحن',
        translate: 'ترجمه',
        custom: 'دستور سفارشی'
      },
      tones: {
        professional: 'حرفه‌ای',
        empathetic: 'همدلانه',
        concise: 'مختصر',
        friendly: 'صمیمی'
      },
      operation: 'عملیات',
      tone: 'لحن',
      customInstruction: 'دستور مشخص خود را بنویسید',
      generate: 'ایجاد',
      loading: 'در حال آماده‌سازی پاسخ...',
      emptySuggestions: 'هنوز پیشنهادی ایجاد نشده است.',
      emptyChat: 'هنوز پیامی در این گفت‌وگو نیست.',
      draftTooLong: 'طول پیش‌نویس باید حداکثر {max} نویسه باشد.',
      requestTooLong: 'مجموع طول پیش‌نویس و دستور باید حداکثر {max} نویسه باشد.',
      chatRequestTooLong: 'مجموع طول پیش‌نویس و پیام باید حداکثر {max} نویسه باشد.',
      clarificationWarning: 'اطلاعات بیشتری لازم است. پیش از استفاده از این پاسخ، پرسش تکمیلی را بررسی کنید.',
      insert: 'درج در محل نشانگر',
      replace: 'جایگزینی پیش‌نویس',
      append: 'افزودن به انتهای پیش‌نویس',
      applyMode: 'روش اعمال در پیش‌نویس',
      apply: 'اعمال در پیش‌نویس',
      copy: 'رونوشت',
      regenerate: 'ایجاد دوباره',
      discard: 'کنار گذاشتن',
      thumbsUp: 'مفید بود',
      thumbsDown: 'مفید نبود',
      newConversation: 'گفت‌وگوی جدید',
      archiveConversation: 'بایگانی گفت‌وگو',
      selectConversation: 'انتخاب گفت‌وگو',
      conversationLabel: 'گفت‌وگوی {index}، {status}',
      conversationStatus: {
        active: 'فعال',
        archived: 'بایگانی‌شده',
        expired: 'منقضی‌شده'
      },
      loadOlder: 'بارگیری پیام‌های قدیمی‌تر',
      chatPlaceholder: 'پیام خود را بنویسید',
      send: 'ارسال',
      retry: 'تلاش دوباره',
      retryCountdown: 'تلاش دوباره تا {seconds} ثانیه دیگر',
      retryCountdownSingular: 'تلاش دوباره تا ۱ ثانیه دیگر',
      retryReady: 'اکنون می‌توانید دوباره تلاش کنید.',
      collapse: 'جمع کردن',
      expand: 'باز کردن',
      disabled: 'دستیار هوش مصنوعی برای این حساب فعال نیست.',
      expiredConversation: 'این گفت‌وگو منقضی شده است. برای ادامه، گفت‌وگوی جدیدی آغاز کنید.',
      readOnlyConversation: 'این گفت‌وگو فقط برای مشاهده در دسترس است.',
      ai_disabled: 'دستیار هوش مصنوعی برای این حساب فعال نیست.',
      ai_forbidden: 'شما اجازه استفاده از دستیار هوش مصنوعی برای این تیکت را ندارید.',
      ai_rollout_unavailable: 'دستیار هوش مصنوعی تا فعال شدن انتشار کنترل‌شده پشتیبانی در دسترس نیست. پاسخ‌های عادی همچنان در دسترس هستند.',
      ai_rate_limited: 'تعداد درخواست‌ها بیش از حد مجاز است. {retry_after} ثانیه دیگر دوباره تلاش کنید.',
      ai_rate_limited_singular: 'تعداد درخواست‌ها بیش از حد مجاز است. ۱ ثانیه دیگر دوباره تلاش کنید.',
      ai_rate_limited_generic: 'تعداد درخواست‌ها بیش از حد مجاز است. کمی بعد دوباره تلاش کنید.',
      ai_context_rejected: 'استفاده امن از اطلاعات این تیکت ممکن نبود. تیکت را بررسی و دوباره تلاش کنید.',
      ai_output_blocked: 'پاسخ ایجادشده در بررسی‌های ایمنی مسدود شد.',
      ai_provider_unavailable: 'دستیار هوش مصنوعی موقتا در دسترس نیست. بعدا دوباره تلاش کنید.',
      ai_timeout: 'زمان درخواست هوش مصنوعی به پایان رسید. دوباره تلاش کنید.',
      ai_invalid_output: 'پاسخ ایجادشده معتبر نبود. پاسخ تازه‌ای ایجاد کنید.',
      ai_conversation_expired: 'این گفت‌وگو منقضی شده است. گفت‌وگوی جدیدی آغاز کنید.',
      ai_idempotency_conflict: 'این درخواست با درخواست قبلی تداخل دارد. صفحه را به‌روزرسانی و دوباره تلاش کنید.',
      not_authenticated: 'نشست شما منقضی شده است. برای استفاده از دستیار هوش مصنوعی دوباره وارد شوید.',
      not_found: 'این گفت‌وگو یا پیام هوش مصنوعی دیگر در دسترس نیست. صفحه را به‌روزرسانی و دوباره تلاش کنید.',
      invalid_request: 'درخواست هوش مصنوعی نامعتبر بود. ورودی‌ها را بررسی و دوباره تلاش کنید.',
      missing_idempotency_key: 'تلاش دوباره برای این درخواست ایمن نبود. صفحه را به‌روزرسانی و دوباره تلاش کنید.',
      invalid_idempotency_key: 'تلاش دوباره برای این درخواست ایمن نبود. صفحه را به‌روزرسانی و دوباره تلاش کنید.',
      ai_conversation_limit: 'پیش از آغاز گفت‌وگوی جدید، یکی از گفت‌وگوهای فعال را بایگانی کنید.',
      privateSession: 'این نشست خصوصی است و فقط کارشناسان مجاز پشتیبانی می‌توانند محتوای آن را ببینند.',
      reviewWarning: 'پیش از ارسال، متن پیشنهادی هوش مصنوعی را از نظر درستی و ایمنی بررسی کنید.',
      feedbackReasons: {
        incorrect: 'نادرست',
        irrelevant: 'نامرتبط',
        incomplete: 'ناقص',
        unsafe: 'ناامن',
        outdated: 'قدیمی',
        poorTone: 'لحن نامناسب',
        other: 'سایر موارد'
      },
      feedbackComment: 'توضیحات تکمیلی (اختیاری)',
      feedbackDialogTitle: 'دلیل مفید نبودن پاسخ را ثبت کنید',
      feedbackFormLabel: 'بازخورد درباره پاسخ هوش مصنوعی',
      feedbackReason: 'دلیل',
      feedbackReasonPlaceholder: 'یک دلیل انتخاب کنید',
      feedbackSubmit: 'ثبت بازخورد',
      feedbackCancel: 'انصراف',
      accessibility: {
        panel: 'بخش دستیار هوش مصنوعی',
        conversationSelector: 'انتخاب گفت‌وگوی دستیار هوش مصنوعی',
        chatInput: 'نوشتن پیام برای دستیار هوش مصنوعی',
        sendMessage: 'ارسال پیام به دستیار هوش مصنوعی'
      },
      run: {
        title: 'روند اجرای درخواست',
        connection: {
          connecting: 'در حال اتصال به به‌روزرسانی‌های زنده',
          live: 'به‌روزرسانی‌های زنده برقرار است',
          reconnecting: 'در حال اتصال دوباره به به‌روزرسانی‌های زنده',
          polling: 'به‌روزرسانی دوره‌ای فعال است',
          stale: 'به‌روزرسانی‌های زنده با تأخیر دریافت می‌شود',
          offline: 'اتصال اینترنت برقرار نیست'
        },
        state: {
          queued: 'در صف',
          running: 'در حال اجرا',
          completed: 'تکمیل‌شده',
          blocked: 'مسدودشده',
          failed: 'ناموفق',
          cancelled: 'لغوشده'
        },
        stage: {
          intake: 'آماده‌سازی درخواست',
          context: 'خواندن اطلاعات تیکت',
          retrieval: 'یافتن منابع مرتبط',
          generation: 'نگارش پاسخ',
          validation: 'بررسی پاسخ',
          review: 'بازبینی پاسخ',
          repair: 'اصلاح پاسخ',
          finalization: 'نهایی‌سازی پاسخ',
          persistence: 'ذخیره پاسخ',
          finished: 'پایان‌یافته'
        },
        reviewerStatus: {
          approve: 'بازبینی تأیید شد',
          repair: 'بازبینی نیازمند اصلاح است',
          block: 'بازبینی انتشار را مسدود کرد',
          unavailable: 'بازبین در دسترس نیست'
        },
        repairStatus: {
          not_requested: 'اصلاحی درخواست نشده است',
          requested: 'اصلاح درخواست شد',
          completed: 'اصلاح تکمیل شد',
          exhausted: 'حد مجاز اصلاح به پایان رسید'
        },
        blockCategory: {
          content_safety: 'ایمنی محتوا',
          prompt_security: 'امنیت دستور',
          sensitive_data: 'داده حساس',
          grounding: 'اعتبارسنجی منابع',
          policy: 'سیاست پشتیبانی',
          human_review: 'بازبینی انسانی',
          unknown: 'بررسی ایمنی'
        },
        failureCategory: {
          provider_unavailable: 'خدمت در دسترس نیست',
          reviewer_unavailable: 'بازبین در دسترس نیست',
          timeout: 'مهلت اجرا به پایان رسید',
          stale_context: 'اطلاعات تیکت هنگام پردازش تغییر کرد',
          permission_changed: 'سطح دسترسی هنگام پردازش تغییر کرد',
          internal: 'خطای پردازش'
        },
        blockRemediation: {
          content_safety: 'محتوای ناامن را از پیش‌نویس حذف کنید و سپس درخواست تازه‌ای آغاز کنید.',
          prompt_security: 'دستورهای نامطمئن را از تیکت یا پیش‌نویس حذف کنید و سپس درخواست تازه‌ای آغاز کنید.',
          sensitive_data: 'اطلاعات ورود و داده‌های شخصی غیرضروری را حذف کنید و سپس درخواست تازه‌ای آغاز کنید.',
          grounding: 'منابع را بررسی کنید یا اطلاعات تأییدشده به تیکت بیفزایید و سپس درخواست تازه‌ای آغاز کنید.',
          policy: 'سیاست پشتیبانی را بررسی و پاسخ درخواستی را پیش از ادامه اصلاح کنید.',
          human_review: 'بازبینی کارشناس مجاز پشتیبانی را درخواست کنید یا منتظر نتیجه آن بمانید.',
          unknown: 'اطلاعات تیکت را بررسی کنید و در صورت آمادگی، درخواست تازه‌ای آغاز کنید.'
        },
        failureRemediation: {
          provider_unavailable: 'پس از برقراری خدمت، از گزینه تلاش دوباره استفاده کنید یا درخواست تازه‌ای آغاز کنید.',
          reviewer_unavailable: 'تا برقراری خدمت بازبینی صبر کنید و سپس دوباره تلاش کنید.',
          timeout: 'دامنه درخواست را کاهش دهید و درخواست تازه‌ای آغاز کنید.',
          stale_context: 'تیکت را به‌روزرسانی کنید و بر پایه وضعیت کنونی آن درخواست تازه‌ای آغاز کنید.',
          permission_changed: 'سطح دسترسی را به‌روزرسانی کنید و در صورت نیاز با مدیر پشتیبانی تماس بگیرید.',
          internal: 'اطلاعات تیکت را بررسی کنید و در صورت آمادگی، درخواست تازه‌ای آغاز کنید.'
        },
        cancel: 'لغو اجرا',
        retry: 'تلاش دوباره برای اجرا',
        retryUnavailable: 'تلاش دوباره دیگر در دسترس نیست، زیرا درخواست اصلی آن آزاد شده است.',
        reconnect: 'اتصال دوباره',
        transportDegraded: 'اجرا همچنان فعال است، اما دریافت به‌روزرسانی‌های زنده اختلال دارد.',
        blocked: 'این اجرا به‌دلیل کنترل ایمنی یا بازبینی متوقف شد.',
        failed: 'تکمیل این اجرا ممکن نبود.',
        remediation: 'اطلاعات تیکت را بررسی کنید و در صورت آمادگی، درخواست تازه‌ای آغاز کنید.',
        diagnostics: 'اطلاعات فنی ویژه مدیر',
        sources: 'منابع استفاده‌شده در این اجرا'
      }
    },

    collaboration: {
      title: 'همکاری کارشناسان',
      internalNoteCollaboration: 'همکاری داخلی',
      internalNoteHelp:
        'از یادداشت داخلی برای درخواست بررسی، واگذاری ادامه کار، افزودن دنبال‌کننده و جلب توجه سایر کارشناسان به این تیکت استفاده کنید.',
      mentionedAgents: 'اشاره به کارشناسان',
      watchers: 'دنبال‌کننده‌ها',
      selectAgents: 'کارشناسانی را برای اطلاع‌رسانی انتخاب کنید',
      selectWatchers: 'کارشناسان دنبال‌کننده این تیکت را انتخاب کنید',
      requestedAction: 'اقدام درخواستی',
      selectAction: 'انتخاب اقدام',
      urgency: 'فوریت',
      dueAt: 'مهلت انجام',
      dueAtPlaceholder: 'YYYY-MM-DD HH:mm یا تاریخ ISO',
      handoff: 'تحویل کار',
      handoffTo: 'تحویل به',
      selectHandoffAgent: 'کارشناس مقصد را انتخاب کنید',
      requiresAcknowledgment: 'کارشناسان اشاره‌شده باید دریافت را تأیید کنند',
      requiresAcknowledgmentShort: 'نیازمند تأیید',
      needsAttention: 'نیازمند توجه',
      mentionedMe: 'به من اشاره شده',
      watching: 'دنبال می‌کنم',
      handoffToMe: 'به من تحویل شده',
      acknowledge: 'تأیید دریافت',
      acknowledged: 'درخواست توجه تأیید شد',
      resolve: 'حل شد',
      resolved: 'درخواست توجه حل شد',
      errorAcknowledging: 'تأیید درخواست توجه ناموفق بود',
      errorResolving: 'حل درخواست توجه ناموفق بود',
      pendingAttentionCount: '{count} درخواست توجه در انتظار',
      actions: {
        review: 'بررسی',
        continue: 'ادامه تیکت',
        handoff: 'تحویل گرفتن',
        investigate: 'بررسی فنی',
        approve: 'تأیید',
        fyi: 'جهت اطلاع'
      },
      urgencies: {
        low: 'کم',
        normal: 'معمولی',
        high: 'زیاد',
        urgent: 'فوری'
      }
    },

    // Replies section
    replies: {
      title: 'پاسخ‌ها',
      add: 'افزودن پاسخ'
    },

    // Attachments section
    attachments: {
      title: 'فایل‌های پیوست',
      scanStatuses: {
        queued: 'در صف اسکن',
        scanning: 'در حال اسکن',
        clean: 'اسکن شد',
        infected: 'مسدود',
        error: 'خطای اسکن'
      },
      scanPendingProcedure: 'دانلود پس از پایان اسکن امنیتی فعال می‌شود.',
      scanErrorProcedure: 'اسکن ناموفق بود. کارشناسان می‌توانند پیش از انتشار دوباره اسکن را اجرا کنند.',
      infectedProcedure: 'این فایل مسدود شده و قابل دانلود نیست.',
      scanFailedSafe: 'این فایل تا زمان بررسی امنیتی موقتا در دسترس نیست.',
      infectedSafe: 'این فایل توسط اسکن امنیتی مسدود شد.',
      retryScan: 'تلاش دوباره',
      retryScanSuccess: 'اسکن فایل دوباره در صف قرار گرفت.',
      retryScanFailed: 'امکان تلاش دوباره برای اسکن فایل وجود ندارد.',
      downloadBlocked: 'این فایل تا زمان تایید اسکن امنیتی قابل دانلود نیست.',
      downloadFailed: 'دانلود این فایل پیوست امکان‌پذیر نیست.',
      preview: 'پیش‌نمایش',
      previewFailed: 'پیش‌نمایش این فایل پیوست امکان‌پذیر نیست.',
      previewUnavailable: 'پیش‌نمایش فقط برای تصاویر، PDF و فایل‌های متنی تأییدشده در دسترس است.',
      previewLoading: 'در حال بارگذاری پیش‌نمایش…',
      previewError: {
        title: 'پیش‌نمایش در دسترس نیست',
        fetch:
          'امکان بارگذاری این فایل برای پیش‌نمایش وجود ندارد. ممکن است مرورگر آن را مسدود کرده باشد یا فایل موقتا در دسترس نباشد. می‌توانید آن را دانلود کنید.',
        mismatch:
          'نوع فایل گزارش‌شده توسط سرور با نوع مورد انتظار برای پیش‌نمایش هم‌خوانی ندارد، بنابراین نمایش آن امن نیست. برای باز کردن فایل، آن را دانلود کنید.',
        render: 'این فایل در پیش‌نمایش قابل نمایش نیست. برای باز کردن با برنامه‌ای دیگر، آن را دانلود کنید.',
        unavailable: 'این فایل در این بخش قابل پیش‌نمایش نیست. برای باز کردن فایل، آن را دانلود کنید.'
      },
      downloadInstead: 'دانلود فایل',
      retryPreview: 'تلاش دوباره',
      pdfPreviewBlockedTitle: 'ممکن است پیش‌نمایش PDF مسدود شده باشد',
      pdfPreviewFallback:
        'تنظیمات مرورگر ممکن است پیش‌نمایش PDF مسدود کند. فایل را دانلود کنید یا اگر مرورگر اجازه می‌دهد آن را در تب جدید باز کنید.',
      previewAlt: 'پیش‌نمایش {fileName}',
      actions: 'عملیات فایل پیوست',
      openInNewTab: 'باز کردن در تب جدید',
      contentTypeMismatch:
        'نوع فایل گزارش‌شده توسط سرور با نوع مورد انتظار برای پیش‌نمایش هم‌خوانی ندارد. پیش‌نمایش مسدود شد.',
      unverifiedSource: 'این فایل توسط کاربر ارسال شده است. با احتیاط پیش‌نمایش کنید و فقط در صورت نیاز دانلود کنید.',
      ready: 'آماده',
      unavailable: 'در دسترس نیست',
      states: {
        ready: 'آماده',
        preparing: 'در حال آماده‌سازی',
        unavailable: 'در دسترس نیست'
      },
      previewTypes: {
        image: 'تصویر',
        pdf: 'PDF',
        text: 'متن',
        file: 'فایل'
      }
    },

    // Knowledge Base
    knowledgeBase: {
      needHelp: 'نیاز به راهنمایی دارید؟',
      title: 'پایگاه دانش',
      articles: 'مقاله',
      popularArticles: 'مقاله‌های پربازدید',
      views: 'بازدید',
      helpful: 'مفید',
      noArticles: 'مقاله‌ای پیدا نشد',
      noArticlesDesc: 'در حال حاضر مقاله‌ای برای نمایش وجود ندارد.',
      noArticlesInCategory: 'هنوز مقاله‌ای در این دسته‌بندی منتشر نشده است.',
      stillNeedHelp: 'هنوز به کمک نیاز دارید؟',
      wasHelpful: 'آیا این مقاله مفید بود؟',
      yes: 'بله',
      no: 'خیر',
      thanksFeedback: 'از بازخورد شما سپاسگزاریم.',
      sorryNotHelpful: 'متاسفیم که این مقاله مفید نبود. برای راهنمایی بیشتر با پشتیبانی تماس بگیرید.',
      searchPlaceholder: 'جستجو در مقاله‌ها...',
      browseByCategory: 'مرور بر اساس دسته‌بندی',
      searchResults: 'نتایج جستجو',
      articleResults: 'مقاله‌های پایگاه دانش',
      documentationResults: 'مستندات',
      readDocs: 'مشاهده مستندات',
      noResults: 'نتیجه‌ای پیدا نشد',
      noResultsDesc: 'هیچ مقاله یا مستندی با جستجوی شما هم‌خوانی نداشت. کلیدواژه‌های دیگری را امتحان کنید.',
      ticketSubjectPrefix: 'پرسش درباره:',
      ticketSubjectFallback: 'درخواست پشتیبانی',
      readingTime: '{minutes} دقیقه مطالعه',
      resultsFor: 'نتایج برای «{query}»',
      resultsCount: '{count} نتیجه',
      publishedOn: 'تاریخ انتشار',
      categories: {
        gettingStarted: {
          name: 'شروع کار',
          description: 'راهنماهای اولیه برای راه‌اندازی و استفاده از AvalAI'
        },
        accountManagement: {
          name: 'مدیریت حساب',
          description: 'مدیریت حساب کاربری و پروفایل شما'
        },
        billingPayments: {
          name: 'صورتحساب و پرداخت',
          description: 'صورتحساب، فاکتورها و اطلاعات پرداخت'
        },
        technicalSupport: {
          name: 'پشتیبانی فنی',
          description: 'عیب‌یابی مشکلات فنی و دسترسی به سرویس'
        },
        featuresTips: {
          name: 'نکات و قابلیت‌ها',
          description: 'نکات کاربردی برای استفاده بهتر از قابلیت‌های پلتفرم'
        },
        apiDocumentation: {
          name: 'مستندات API',
          description: 'راهنماهای توسعه‌دهنده، مرجع API و کمک برای یکپارچه‌سازی'
        },
        troubleshooting: {
          name: 'عیب‌یابی',
          description: 'راهنمای مرحله‌به‌مرحله برای حل مشکلات رایج'
        },
        featureGuides: {
          name: 'راهنمای قابلیت‌ها',
          description: 'راهنماهایی برای یادگیری و استفاده از قابلیت‌های محصول'
        }
      }
    },

    // File upload
    fileUpload: {
      selectFiles: 'انتخاب فایل‌ها',
      uploadFiles: 'آپلود فایل‌ها',
      uploading: 'در حال آپلود...',
      uploadComplete: 'آپلود کامل شد',
      uploadFailed: 'آپلود ناموفق',
      removeFile: 'حذف فایل',
      removeFileNamed: 'حذف {fileName}',
      fileCount: '{current} از {max} فایل',
      fileSize: 'اندازه فایل',
      fileName: 'نام فایل',
      units: {
        bytes: 'بایت',
        kilobytes: 'کیلوبایت',
        megabytes: 'مگابایت',
        gigabytes: 'گیگابایت'
      },
      errors: {
        fileTooLarge: 'فایل بیش از حد بزرگ است. حداکثر اندازه {maxSize} است',
        invalidFileType: 'نوع فایل نامعتبر است',
        fileAlreadyAdded: 'فایل قبلا اضافه شده است'
      },
      messages: {
        uploadSuccess: '{count} فایل با موفقیت آپلود شد',
        uploadFailed: '{count} فایل آپلود نشد',
        uploadError: 'خطا در آپلود فایل'
      }
    },

    // Polling
    polling: {
      maxRetriesExceeded: 'حداکثر تعداد تلاش مجدد به پایان رسید. نظرسنجی متوقف شد.',
      fetchError: 'خطا در دریافت داده‌ها',
      tooManyRequests: 'تعداد درخواست بیش از حد مجاز',
      tooManyRequestsDesc: 'تعداد درخواست‌ها از حد مجاز فراتر است، لطفا پس از چند لحظه دوباره تلاش کنید.'
    },

    // Errors
    errors: {
      partialLoadTitle: 'بخشی از داده‌های پشتیبانی بارگذاری نشد',
      partialLoadDescription:
        'بخشی از داده‌های پشتیبانی موقتا در دسترس نیست. همچنان می‌توانید تیکت بسازید، تیکت‌های موجود را ببینید یا دوباره تلاش کنید.',
      networkError: 'خطای شبکه',
      permissionError: 'عدم دسترسی',
      notFoundError: 'یافت نشد',
      genericError: 'خطایی رخ داده است',
      timeoutError: 'زمان درخواست تمام شد',
      serverError: 'خطای سرور',
      maintenanceError: 'در حال تعمیر و نگهداری',
      networkErrorDesc: 'عدم اتصال به سرور. لطفا اتصال اینترنت خود را بررسی کرده و دوباره تلاش کنید.',
      permissionErrorDesc: 'شما مجوز دسترسی به این منبع را ندارید. لطفا با مدیر سیستم تماس بگیرید.',
      notFoundErrorDesc: 'منبع درخواستی یافت نشد.',
      genericErrorDesc: 'خطایی در بارگذاری داده‌ها رخ داده است. لطفا دوباره تلاش کنید.',
      timeoutErrorDesc: 'درخواست بیش از حد طول کشید. لطفا دوباره تلاش کنید.',
      serverErrorDesc:
        'سرور با خطا مواجه شد (502). لطفا بعدا دوباره تلاش کنید یا در صورت ادامه مشکل با پشتیبانی تماس بگیرید.',
      maintenanceErrorDesc: 'سیستم در حال تعمیر و نگهداری است. لطفا بعدا دوباره تلاش کنید.',
      withErrorCode: '{message} (خطا: {code})',
      tryAgain: 'تلاش دوباره',
      contactSupport: 'تماس با پشتیبانی'
    },

    // Auth required
    authRequired: {
      title: 'احراز هویت لازم است',
      description: 'لطفا وارد شوید تا بتوانید به سیستم پشتیبانی دسترسی داشته باشید و تیکت‌هایتان را مدیریت کنید.',
      loginButton: 'ورود'
    },

    // Empty states
    emptyStates: {
      noTickets: {
        title: 'تیکت یافت نشد',
        description: 'اولین تیکت پشتیبانی خود را ایجاد کنید.',
        action: 'ایجاد تیکت'
      },
      noReplies: {
        title: 'هنوز پاسخی نیست',
        description: 'اولین نفری باشید که به این تیکت پاسخ می‌دهد.'
      },
      noAttachments: {
        title: 'فایل پیوستی نیست',
        description: 'هیچ فایلی به این تیکت پیوست نشده است.'
      },
      noSearchResults: {
        description: 'سعی کنید عبارت جستجو یا فیلترهای خود را تغییر دهید.'
      },
      noData: {
        description: 'داده‌ای در دسترس نیست.'
      }
    },

    // Validation
    validation: {
      subjectRequired: 'موضوع ضروری است',
      descriptionRequired: 'توضیحات ضروری است',
      categoryRequired: 'لطفا دسته‌بندی را انتخاب کنید',
      priorityRequired: 'لطفا اولویت را انتخاب کنید',
      fileTooBig: 'فایل {fileName} بیش از حد بزرگ است. حداکثر اندازه {size}MB',
      tooManyFiles: 'تعداد فایل‌ها زیاد است. حداکثر {max} فایل',
      invalidFileType: 'فایل {fileName} نوع نامعتبری دارد. انواع مجاز: {allowedTypes}',
      maxFilesExceeded: 'تعداد فایل‌ها از حد مجاز بیشتر است',
      formErrors: 'لطفا خطاهای فرم را قبل از ارسال رفع کنید',
      replyRequired: 'محتوای پاسخ ضروری است',
      // Dynamic field validation
      fieldRequired: 'فیلد {field} ضروری است',
      invalidCardNumber: 'شماره کارت نامعتبر است',
      invalidIBAN: 'شماره شبا نامعتبر است',
      invalidNumber: 'عدد وارد شده نامعتبر است',
      numberTooSmall: 'عدد باید حداقل {min} باشد',
      numberTooLarge: 'عدد نباید بیش از {max} باشد',
      invalidDate: 'تاریخ وارد شده نامعتبر است',
      invalidEmail: 'آدرس ایمیل نامعتبر است',
      textTooShort: 'متن باید حداقل {min} کاراکتر باشد',
      textTooLong: 'متن نباید بیش از {max} کاراکتر باشد',
      invalidFormat: 'فرمت وارد شده نامعتبر است',
      invalidOption: 'گزینه انتخاب شده نامعتبر است',
      addressRequired: 'انتخاب آدرس الزامی است',
      invalidAddress: 'آدرس انتخاب شده نامعتبر است',
      backendFieldInvalid: 'لطفا فیلد {field} را بررسی کنید و دوباره تلاش کنید'
    },

    address: {
      type: 'نوع آدرس',
      city: 'شهر',
      companyName: 'نام شرکت',
      fullAddress: 'آدرس کامل',
      types: {
        individual: 'شخص حقیقی',
        company: 'شرکت',
        home: 'خانه',
        business: 'کسب‌وکار',
        other: 'سایر'
      }
    },

    addresses: {
      selectAddress: 'انتخاب آدرس',
      createAddress: 'ایجاد آدرس',
      createAddressTitle: 'ایجاد آدرس صورتحساب',
      createAddressDescription: 'یک آدرس صورتحساب برای این تیکت ذخیره کنید.',
      addressLabel: 'عنوان آدرس',
      addressLabelPlaceholder: 'آدرس اصلی صورتحساب',
      companyName: 'نام شرکت',
      fullAddress: 'آدرس کامل',
      city: 'شهر',
      state: 'استان',
      province: 'استان',
      chooseProvince: 'استان را انتخاب کنید',
      cityPlaceholder: 'شهر را انتخاب یا وارد کنید',
      fullAddressPlaceholder: 'خیابان، کوچه، پلاک، واحد',
      selectedFullAddress: 'آدرس کامل انتخاب‌ شده',
      quickSelect: 'انتخاب سریع',
      countryIran: 'ایران',
      postalCode: 'کد پستی',
      postalCodePlaceholder: '۱۰ رقم بدون خط تیره',
      postalCodeHint: 'کد پستی باید ۱۰ رقم باشد',
      country: 'کشور',
      phoneNumber: 'شماره تماس',
      emailAddress: 'ایمیل',
      defaultAddress: 'پیش‌فرض',
      setAsDefault: 'تنظیم به‌عنوان آدرس پیش‌فرض',
      defaultAddressHint: 'این آدرس جایگزین آدرس پیش‌فرض فعلی شما می‌شود.',
      defaultAddressLockedHint: 'اولین آدرس همیشه پیش‌فرض است. برای جایگزینی، آدرس دیگری را پیش‌فرض کنید.',
      saveAddress: 'ذخیره آدرس',
      addNewAddress: 'افزودن آدرس جدید',
      editAddress: 'ویرایش آدرس',
      editAddressDescription: 'آدرس انتخاب‌شده را برای این تیکت به‌روزرسانی کنید.',
      updateAddress: 'به‌روزرسانی آدرس',
      updateSuccess: 'آدرس به‌روزرسانی شد',
      updateFailed: 'به‌روزرسانی آدرس ناموفق بود',
      createSuccess: 'آدرس ذخیره شد',
      createFailed: 'ذخیره آدرس ناموفق بود',
      noAddresses: 'آدرسی یافت نشد',
      noAddressesDescription: 'قبل از ارسال تیکت‌های مربوط به فاکتور، یک آدرس صورتحساب ایجاد کنید.',
      types: {
        individual: 'شخص حقیقی',
        company: 'شرکت',
        home: 'خانه',
        business: 'کسب‌وکار',
        other: 'سایر'
      }
    },

    // Help section
    help: {
      beforeCreating: 'قبل از ایجاد تیکت',
      searchKnowledge: 'برای پاسخ سریع به سوالات رایج، پایگاه دانش ما را جستجو کنید.',
      tips: 'نکاتی برای پشتیبانی بهتر',
      tip1: 'در مورد مسئله خود دقیق باشید و جزئیات مربوطه را شامل کنید',
      tip2: 'تصاویر یا فایل‌هایی که به توضیح مسئله کمک می‌کنند، پیوست کنید',
      tip3: 'دسته‌بندی و اولویت صحیح را برای حل سریع‌تر انتخاب کنید',
      urgentIssues: 'مسائل فوری',
      urgentContact: 'برای مسائل بحرانی که نیاز به توجه فوری دارند، مستقیما با تیم پشتیبانی ما تماس بگیرید.',
      contactSupport: 'تماس با پشتیبانی'
    },

    // Stats for agent dashboard
    stats: {
      total: 'کل',
      unassigned: 'بدون مسئول',
      assignedToMe: 'اختصاص داده شده به من',
      open: 'باز',
      inProgress: 'در حال بررسی',
      overdue: 'عقب‌افتاده',
      unseen: 'دیده‌نشده',
      openTickets: 'تیکت‌های باز',
      resolutionRate: 'نرخ حل تیکت',
      filtersAria: 'فیلترهای آماری تیکت‌ها',
      aria: {
        total: '{count} تیکت در کل. نمایش همه تیکت‌ها',
        unassigned: '{count} تیکت بدون مسئول. فیلتر تیکت‌های بدون مسئول',
        assignedToMe: '{count} تیکت اختصاص داده شده به من. فیلتر تیکت‌های من',
        open: '{count} تیکت باز. فیلتر تیکت‌های باز',
        inProgress: '{count} تیکت در حال بررسی',
        overdue: '{count} تیکت عقب‌افتاده. فیلتر تیکت‌های عقب‌افتاده',
        unseen: '{count} تیکت در این صفحه که هنوز توسط هیچ پشتیبانی دیده نشده است. فیلتر تیکت‌های دیده‌نشده'
      }
    },

    // Agent Dashboard
    agentDashboard: {
      title: 'داشبورد پشتیبان',
      viewAllTickets: 'مشاهده همه تیکت‌ها',
      myQueue: 'صف من',
      unassignedQueue: 'صف بدون مسئول',
      ticketsNeedingAttention: 'تیکت‌های نیازمند توجه',
      responseQueue: 'صف پاسخ‌گویی',
      responseQueueHint: 'مشتریان را بر اساس وضعیت پاسخ و مدت انتظار اولویت‌بندی کنید.',
      openOldestFirst: 'نمایش قدیمی‌ترین انتظارها'
    },

    // Role labels
    roles: {
      agent: 'پشتیبان',
      admin: 'مدیر',
      user: 'کاربر'
    },

    // Access denied
    accessDenied: {
      title: 'دسترسی غیرمجاز',
      agentRequired: 'برای دسترسی به این صفحه نیاز به دسترسی پشتیبان یا مدیر دارید.'
    },

    // All Tickets view
    allTickets: 'همه تیکت‌ها',

    // Agent actions
    agentActions: {
      title: 'عملیات پشتیبان',
      noAgentsAvailable: 'پشتیبانی در دسترس نیست',
      assignToMe: 'اختصاص به من',
      unassign: 'لغو اختصاص'
    },

    // Bulk Actions
    bulkActions: {
      selectedCount: '{count} تیکت انتخاب شده',
      changeStatus: 'تغییر وضعیت',
      changePriority: 'تغییر اولویت',
      assign: 'اختصاص',
      unassign: 'لغو اختصاص',
      clearSelection: 'پاک کردن انتخاب',
      statusChangeSuccess: 'وضعیت {count} تیکت با موفقیت به‌روزرسانی شد',
      statusChangeFailed: 'خطا در به‌روزرسانی وضعیت تیکت‌ها',
      priorityChangeSuccess: 'اولویت {count} تیکت با موفقیت به‌روزرسانی شد',
      priorityChangeFailed: 'خطا در به‌روزرسانی اولویت تیکت‌ها',
      assignSuccess: '{count} تیکت با موفقیت اختصاص داده شد',
      unassignSuccess: 'اختصاص {count} تیکت با موفقیت لغو شد',
      assignFailed: 'خطا در اختصاص تیکت‌ها',
      // Loading messages
      updatingStatus: 'در حال به‌روزرسانی وضعیت تیکت...',
      updatingPriority: 'در حال به‌روزرسانی اولویت تیکت...',
      updatingAssignment: 'در حال به‌روزرسانی اختصاص تیکت...',
      processing: 'در حال پردازش...',
      selectTickets: 'عملیات جمعی',
      cancelSelect: 'لغو'
    },

    // Activity Timeline
    activity: {
      title: 'تاریخچه فعالیت‌ها',
      noActivity: 'هنوز فعالیتی ثبت نشده است',
      loadMore: 'بارگذاری بیشتر',
      internal: 'داخلی',
      by: 'توسط',
      botUser: 'بات',
      systemUser: 'سیستم',
      types: {
        created: 'ایجاد شد',
        status_changed: 'وضعیت تغییر کرد',
        priority_changed: 'اولویت تغییر کرد',
        assigned: 'اختصاص داده شد',
        unassigned: 'لغو اختصاص شد',
        reply_added: 'پاسخ اضافه شد',
        internal_note: 'یادداشت داخلی',
        internal_note_added: 'یادداشت داخلی اضافه شد',
        attachment_added: 'فایل پیوست شد',
        reopened: 'بازگشایی شد',
        sla_breached: 'SLA نقض شد',
        escalated: 'تشدید شد',
        merged: 'ادغام شد',
        split: 'تقسیم شد',
        category_changed: 'دسته‌بندی تغییر کرد',
        custom_field_updated: 'فیلد سفارشی به‌روزرسانی شد'
      },
      messages: {
        created: 'تیکت ایجاد شد',
        status_changed: 'وضعیت از {oldValue} به {newValue} تغییر کرد',
        priority_changed: 'اولویت از {oldValue} به {newValue} تغییر کرد',
        assigned: 'تیکت اختصاص داده شد',
        unassigned: 'اختصاص تیکت لغو شد',
        reply_added: 'پاسخ اضافه شد',
        internal_note: 'یادداشت داخلی اضافه شد',
        attachment_added: 'فایل پیوست شد',
        reopened: 'تیکت بازگشایی شد',
        sla_breached: 'SLA نقض شد'
      }
    },

    // Export
    export: {
      title: 'خروجی گرفتن از تیکت‌ها',
      button: 'خروجی',
      format: 'فرمت',
      csv: 'CSV',
      excel: 'اکسل',
      exporting: 'در حال خروجی گرفتن...',
      success: 'تیکت‌ها با موفقیت خروجی گرفته شد',
      failed: 'خطا در خروجی گرفتن از تیکت‌ها',
      noTickets: 'تیکتی برای خروجی وجود ندارد',
      json: 'JSON'
    },

    // Notification Preferences
    notifications: {
      title: 'تنظیمات اعلان‌ها',
      settings: 'تنظیمات اعلان‌ها',
      loadErrorTitle: 'خطا در بارگذاری تنظیمات',
      loadError: 'بارگذاری تنظیمات اعلان‌ها با خطا مواجه شد. لطفا دوباره تلاش کنید.',
      saveSuccess: 'تنظیمات اعلان‌ها با موفقیت ذخیره شد',
      saveError: 'خطا در ذخیره تنظیمات اعلان‌ها',
      resetSuccess: 'تنظیمات اعلان‌ها به حالت پیش‌فرض بازگردانده شد',
      resetError: 'خطا در بازنشانی تنظیمات اعلان‌ها',
      enabledAll: 'همه اعلان‌ها فعال شد',
      disabledAll: 'همه اعلان‌ها غیرفعال شد',
      toggleError: 'خطا در تغییر وضعیت اعلان‌ها',
      enableAll: 'فعال کردن همه اعلان‌های ایمیل',
      enableAllDesc: 'تغییر وضعیت همه تنظیمات اعلان ایمیل به یکباره',
      quickToggleDesc: 'همه انواع اعلان ایمیلی را سریع فعال یا غیرفعال کنید.',
      toggleAll: 'تغییر وضعیت همه اعلان‌های ایمیلی',
      ticketUpdates: 'به‌روزرسانی‌های تیکت',
      slaAlerts: 'هشدارهای SLA و تشدید',
      important: 'مهم',
      critical: 'بحرانی',
      emailNotifications: 'اعلان‌های ایمیل',
      newTicket: 'تیکت جدید',
      newTicketDesc: 'هنگام ایجاد تیکت جدید ایمیل دریافت کنید',
      ticketAssigned: 'اختصاص تیکت',
      ticketAssignedDesc: 'هنگام اختصاص تیکت به شما ایمیل دریافت کنید',
      ticketReply: 'پاسخ تیکت',
      ticketReplyDesc: 'هنگام پاسخ دادن به تیکت شما ایمیل دریافت کنید',
      statusChange: 'تغییر وضعیت',
      statusChangeDesc: 'هنگام تغییر وضعیت تیکت ایمیل دریافت کنید',
      escalation: 'تشدید',
      escalationDesc: 'هنگام تشدید تیکت ایمیل دریافت کنید',
      slaWarning: 'هشدار SLA',
      slaWarningDesc: 'هنگام نزدیک شدن موعد SLA تیکت ایمیل دریافت کنید',
      slaBreach: 'نقض SLA',
      slaBreachDesc: 'هنگام نقض SLA تیکت ایمیل دریافت کنید',
      emailDigest: 'خلاصه ایمیل',
      digestFrequencyLabel: 'دوره ارسال خلاصه',
      digestFrequencyDesc: 'خلاصه فعالیت تیکت‌ها را دریافت کنید',
      selectFrequency: 'انتخاب دوره',
      digestFrequency: {
        none: 'هیچ',
        daily: 'روزانه',
        weekly: 'هفتگی'
      },
      inAppNotifications: 'اعلان‌های درون‌برنامه‌ای',
      enableInApp: 'فعال کردن اعلان‌های درون‌برنامه‌ای',
      enableInAppDesc: 'نمایش اعلان‌ها در داخل برنامه',
      resetDefaults: 'بازنشانی به پیش‌فرض',
      resetConfirmMessage: 'آیا مطمئن هستید که می‌خواهید همه تنظیمات اعلان را به پیش‌فرض بازنشانی کنید؟',
      saveChanges: 'ذخیره تغییرات'
    },

    // Time formatting
    time: {
      justNow: 'همین الان',
      minutesAgo: '{count} دقیقه پیش',
      hoursAgo: '{count} ساعت پیش',
      daysAgo: '{count} روز پیش',
      weeksAgo: '{count} هفته پیش',
      monthsAgo: '{count} ماه پیش'
    }
  },
  models: {
    name: 'اسم',
    provider: 'ارائه دهنده',
    tier: 'سطح',
    maxTokens: 'ظرفیت توکن',
    price: 'نرخ',
    costoptimizedModels: 'مدل‌های بهینه‌سازی شده از نظر هزینه',
    costoptimizedModelsDes: 'مدل‌های کوچکتر و سریع‌تر با هزینه اجرای کمتر',
    flagshipModels: 'مدل‌های پرچمدار',
    flagshipModelsDes: 'مدل‌های پرچمدار با عملکرد بالا و چندمنظوره',
    imageGeneration: 'تولید تصویر',
    imageGenerationDes: 'مدل‌هایی که از توضیحات متنی، تصاویر تولید می‌کنند',
    reasoningModels: 'مدل‌های استدلالی',
    reasoningModelsDes: 'مدل‌های پیشرفته‌ای که در وظایف پیچیده و چند مرحله‌ای عملکرد عالی دارند',
    embeddingModels: 'مدل‌های امبدینگ',
    embeddingModelsDes: 'مدل‌هایی که متن را به بردارهای امبدینگ تبدیل می‌کنند',
    stt: 'تبدیل گفتار به متن',
    sttDes: 'مدل‌هایی که گفتار را به متن تبدیل می‌کنند',
    tts: 'تبدیل متن به گفتار',
    ttsDes: 'مدل‌هایی که متن را به گفتار با صدای طبیعی تبدیل می‌کنند',
    visionModels: 'مدل‌های بینایی',
    visionModelsDes: 'مدل‌هایی که می‌توانند تصاویر را تحلیل و درک کنند',
    chatModels: 'مدل‌های گفتگو',
    chatModelsDes: 'مدل‌های هوش مصنوعی گفتگوی همه منظوره',
    multimodalModels: 'مدل‌های چندوجهی',
    multimodalModelsDes: 'مدل‌هایی که از انواع ورودی/خروجی (متن، تصویر، صدا، ویدیو) پشتیبانی می‌کنند',
    moderationModels: 'مدل‌های نظارتی',
    moderationModelsDes: 'مدل‌هایی که محتوای مضر یا نامناسب را شناسایی و فیلتر می‌کنند',
    codeModels: 'مدل‌های برنامه‌نویسی',
    codeModelsDes: 'مدل‌های تخصصی در تولید، تحلیل و تکمیل کد',
    noRateLimitReceived: 'داده‌ای برای محدودیت نرخ دریافت نشد',
    loadingModels: 'در حال بارگذاری مدل‌ها',
    featuredModels: 'مدل‌های ویژه',
    modelsFound: 'مدل یافت شد',
    searchByModel: 'جستجوی مدل‌ها بر اساس نام، ارائه‌دهنده، یا قابلیت...',
    searchByModelDes: 'برترین مدل‌های موجود',
    filterModels: 'فیلتر مدل‌ها',
    quickFilters: 'فیلترهای سریع',
    myAccessibleModels: 'مدل‌های قابل دسترس من',
    accessibleModelsDes: 'مدل‌هایی که می‌توانم به آنها دسترسی داشته باشم',
    visionModelsTxt: 'مدل‌های بینایی',
    visionModelsDes2: 'مدل‌ها با قابلیت‌های تصویری',
    reasoningModelsTxt: 'مدل‌های استدلالی',
    reasoningModelsDes2: 'قابلیت‌های استدلال پیشرفته',
    costEffective: 'مقرون به صرفه',
    costEffectiveDes: 'گزینه‌های مناسب بودجه',
    providers: 'ارائه‌دهندگان',
    selectProviders: 'انتخاب ارائه‌دهندگان',
    capabilities: 'قابلیت‌ها',
    showMore: 'نمایش بیشتر',
    showLess: 'نمایش کمتر',
    more: 'بیشتر',
    selectCapabilities: 'انتخاب قابلیت‌ها',
    accessTiers: 'سطوح دسترسی',
    selectTiers: 'انتخاب سطوح',
    priceRange: 'محدوده قیمت (به ازای ۱ میلیون توکن)',
    sortBy: 'مرتب‌سازی بر اساس',
    newest: 'جدیدترین',
    new: 'جدید',
    onlyAccessible: 'فقط نمایش مدل‌های قابل دسترس من',
    of: 'از',
    models: 'مدل',
    filter: 'فیلتر',
    filters: 'فیلترها',
    active: 'فعال',
    applyFiltersClose: 'اعمال فیلترها و بستن',
    providersPlaceholder: 'ارائه‌دهندگان',
    capabilitiesPlaceholder: 'قابلیت‌ها',
    tiersPlaceholder: 'سطوح',
    categoryPlaceholder: 'دسته‌بندی',
    allCategories: 'همه دسته‌بندی‌ها',
    tierLabel: 'سطح {0}',
    clearFilters: 'پاک کردن فیلترها',
    categoryModelsCount: 'مدل',
    noModelsFound: 'هیچ مدلی یافت نشد',
    filtersActive: 'فیلتر فعال'
  },
  tooltip: {
    tpm: 'مقدار دسترسی توکن در دقیقه (TPM) بر اساس سطح کاربری انتخاب شده، این مقدار در هر سطح کاربری متفاوت است.',
    rpm: 'درخواست در دقیقه (RPM) بر اساس سطح کاربری انتخاب شده، این مقدار در هر سطح کاربری متفاوت است.',
    negativeBalance: 'موجودی منفی',
    negativeBalanceExplanation:
      'موجودی کیف پول شما منفی است، دلیل آن درخواست‌های موازی در تعداد بالا است زمانی که اعتبار باقی مانده نزدیک به صفر بوده.',
    negativeTotalBalance: 'جزئیات موجودی منفی',
    currentBalance: 'موجودی فعلی',
    pendingCharges: 'هزینه‌های بلاتکلیف',
    rechargeAdvice: 'جهت استفاده از خدمات لطفا موجودی حساب را شارژ نمایید.',
    remainingIRT: 'باقی مانده اعتبار تومانی کیف پول',
    remainingUNIT: 'باقی مانده اعتبار کیف پول تبدیل شده به واحد (نرخ تتر)',
    imagePricingAlert:
      'محاسبه هزینه در مدل‌های تولید تصویر بر اساس نوع مدل، اندازه تصویر، کیفیت، و تعداد گام‌ها (در صورت پشتیبانی مدل از این قابلیت) انجام می‌شود. بنابراین، نرخ اعلام‌شده برای هر تصویر، یک نرخ متوسط تلقی می‌گردد. به جز مدل gpt-image-1، سایر مدل‌ها نرخ خروجی توکن ندارند و این مقدار صرفا جهت سازگاری با سیستم تخصیص داده می‌شود. به عنوان مثال، در فراخوانی مدل dall-e-3 با کیفیت HD و اندازه ۱۰۲۴ در ۱۰۲۴، مقدار توکن مصرفی ۱۰۰۰ در نظر گرفته می‌شود که با نرخ ۴۰ واحد به ازای هر یک میلیون توکن، معادل ۰.۰۴ واحد محاسبه خواهد شد. این مقدار در واقع نرخ پایه خروجی تصویر و معادل ۰.۰۴ واحد به ازای هر تصویر است.',
    remainingInUNIT:
      'مجموع ارزش اعتبار تومانی به واحد به علاوه اعتبار تبدیل شده به واحد. این مقدار ارزش کل اعتبار حساب به واحد با نرخ تبدیل لحظه‌ای است.',
    aboveTokensPricing:
      'هنگامی که مجموع توکن‌ها بالاتر از مقدار مشخص شده باشد، مبنای نرخ بر این اساس محاسبه می شود، در مواردی که مجموع توکن‌ها کمتر از این مقدار است، نرخ پایه مبنای محاسبه است، جهت کسب اطلاعات بیشتر به مستندات ارائه دهنده مراجعه نمایید.',
    endpointMightNotAvailable:
      'برخی از نقاط پایانی ممکن است در حال حاضر در AvalAI در دسترس نباشند. لطفا برای اطلاعات بیشتر به مستندات مراجعه کنید.',
    remainingCreditInIrtEquivalent:
      'مجموع اعتبار کیف پول شما به تومان. این موجودی شامل باقی مانده تومانی به علاوه باقی مانده «واحد» ضرب در نرخ لحظه‌‌ای است. به دلیل اینکه نرخ گذاری بسته‌های اعتباری بر اساس تومان است، درصورتی که موجودی کیف پول شما، دارای موجودی ارزی بر حسب «واحد» باشد، معادل آن به تومان بر اساس نرخ لحظه‌ای محاسبه می گردد.'
  },
  limits: {
    selectModalities: 'وجه ادراک',
    selectEndpoints: 'نقاط پایانی',
    rateLimits: 'سطوح دسترسی',
    supported_endpoints: 'نقاط پایانی پشتیبانی شده',
    supports_parallel_function_calling: 'Parallel Function Calling',
    supports_web_search: 'پشتیبانی از جستجوی وب',
    max_images_per_prompt: 'حداکثر تعداد تصویر ورودی',
    max_videos_per_prompt: 'حداکثر تعداد ویدیو ورودی',
    max_video_length: 'حداکثر طول ویدیو',
    max_audio_length_hours: 'حداکثر زمان آوا (ساعت)',
    max_audio_per_prompt: 'حداکثر آوا در هر پرامپت',
    max_pdf_size_mb: 'حداکثر حجم PDF (مگابایت)',
    supported_modalities: 'وجه ادارک‌های پشتیبانی شده (Modalities)',
    supported_output_modalities: 'وجه ادارک‌های خروجی پشتیبانی شده (Modalities)',
    costPerOneMillionTokens: 'بر اساس هر ۱ میلیون توکن بر مبنای نرخ واحد (تتر)',
    details: 'جزئیات',
    name: 'مدل',
    max_tokens: 'حداکثر توان خروجی',
    max_input_tokens: 'حداکثر ورودی',
    max_requests_per_1_minute: 'RPM',
    max_tokens_per_1_minute: 'TPM',
    // Nested pricing fields
    pricing: {
      input_cost_per_token: 'هزینه ورودی هر یک توکن',
      output_cost_per_token: 'هزینه خروجی هر یک توکن',
      input_cost_per_page: 'هزینه هر یک صفحه یا تصویر',
      input_cost_per_query: 'هزینه هر یک مرتبه فراخوانی',
      kTokens: 'هزار توکن',
      input: 'نرخ توکن ورودی',
      output: 'نرخ توکن خروجی',
      cached_input: 'نرخ ورودی کش شده',
      cache_creation_input: 'نرخ تولید ورودی کش شده',
      audio_input: 'نرخ ورودی صوتی',
      audio_output: 'نرخ خروجی صوتی',
      audio_cached_input: 'نرخ ورودی صوتی کش شده',
      image_input: 'نرخ ورودی تصویر',
      image_output: 'نرخ خروجی تصویر',
      image_cached_input: 'نرخ ورودی تصویر کش شده',
      video_input: 'نرخ ورودی ویدیو',
      input_cost_per_character: 'نرخ ورودی کاراکتر',
      input_cost_per_second: 'نرخ ورودی ثانیه',
      output_cost_per_second: 'نرخ خروجی ثانیه',
      output_cost_per_image: 'نرخ تولید تصویر',
      output_cost_per_video_per_second: 'نرخ هر ثانیه ویدیو',
      input_cost_per_annotation_page: 'نرخ هر صفحه حاشیه‌نویسی',
      // قالب‌های عمومی برای پیشوندهای پویا (آستانه/ابعاد)
      aboveTemplate: '{base} بالاتر از {threshold} توکن',
      resolutionTemplate: '{base} ({resolution})',
      source: 'منبع'
    },
    outputVideo: 'خروجی ویدیو',
    outputImage: 'خروجی تصویر',
    perOneImage: 'به ازای هر تصویر',
    outputSeconds: 'ثانیه خروجی',
    perOneSecond: 'هر ثانیه',
    inputSeconds: 'ثانیه ورودی',
    perOneCharacterInput: 'هر عدد کاراکتر',
    characterInput: 'کاراکتر ورودی',
    modelCapabilities: 'قابلیت‌ها',
    maxTokens: 'حداکثر ظرفیت',
    maxInputTokens: 'حداکثر ورودی',
    maxOutputTokens: 'حداکثر توان خروجی',
    mode: 'حالت',
    source: 'منبع',
    supportsSystemMessages: 'پیغام سیستم',
    supportsFunctionCalling: 'Function Calling',
    supportsVision: 'Vision',
    supportsToolChoice: 'Tool Choice',
    supportsResponseSchema: 'Response Schema',
    supportsPromptCaching: 'Prompt Caching',
    supportsReasoning: 'استدلال',
    howToUseApi1: 'دریافت لیست مدل‌ها از طریق API',
    audioPerMinute: 'صوت در دقیقه',
    imagesPerMinute: 'تصویر در دقیقه',
    searchModel: 'جستجوی مدل',
    selectOwner: 'فیلتر صاحب‌ امتیاز',
    owner: 'صاحب امتیاز',
    tier0: 'پایه',
    tier1: 'سطح ۱',
    tier2: 'سطح ۲',
    tier3: 'سطح ۳',
    tier4: 'سطح ۴',
    tier5: 'سطح ۵',
    audioInputTokens: 'توکن صوتی ورودی',
    audioOutputTokens: 'توکن صوتی خروجی',
    audioCachedInputTokens: 'توکن صوتی ورودی کش شده',
    minute: 'دقیقه',
    perMinute: 'در دقیقه',
    perOneMillionTokens: 'هر ۱ میلیون توکن',
    currency: 'ارز',
    costCalculator: 'محاسبه هزینه‌ها',
    inputTokens: 'توکن ورودی',
    cachedInputTokens: 'توکن ورودی کش شده',
    outputTokens: 'توکن خروجی',
    audioInputMinutes: 'دقایق ورودی',
    audioCachedInputMinutes: 'دقایق ورودی کش شده',
    audioOutputMinutes: 'دقایق خروجی',
    estimatedCost: 'هزینه تخمینی',
    tokenBasedPricing: 'نرخ بر اساس توکن',
    audioBasedPricing: 'نرخ بر اساس واحد صوت / دقیقه',
    modelDetails: 'جزئیات مدل',
    copyModelName: 'کپی نام مدل',
    openModelSource: 'باز کردن منبع مدل',
    openPricingSource: 'باز کردن منبع قیمت‌گذاری',
    noCapabilitiesAvailable: 'جزئیات قابلیتی برای این مدل منتشر نشده است.',
    supportedFeatures: 'قابلیت‌های پشتیبانی‌شده',
    simpleEstimate: 'برآورد سریع',
    openFullCalculator: 'باز کردن ماشین حساب کامل',
    openServiceTierDocs: 'باز کردن مستندات سطوح سرویس',
    actions: '',
    providerType: 'نوع ارائه دهنده',
    viewPricing: 'مشاهده نرخ‌ها',
    pricingDetails: 'جزئیات نرخ‌ها',
    // Service Tier Pricing
    serviceTier: 'سطح سرویس',
    serviceTiers: 'سطوح سرویس',
    selectServiceTiers: 'سطوح سرویس',
    serviceTierFilter: 'فیلتر سطح سرویس',
    serviceTierPricing: 'نرخ بر اساس سطح سرویس',
    standardTier: 'استاندارد',
    defaultTier: 'استاندارد',
    flexTier: 'منطعف',
    batchTier: 'عمده',
    priorityTier: 'اولویت‌دار',
    defaultTierDescription: 'سطح نرخ پیش‌ فرض',
    standardTierDescription: 'سطح نرخ پیش‌ فرض',
    flexTierDescription: 'هزینه کمتر، تاخیر متغیر',
    batchTierDescription: 'پردازش غیرهمزمان',
    priorityTierDescription: 'دسترسی سریع و اولویت‌دار',
    flexAvailable: 'منعطف در دسترس',
    supportsFlexPricing: 'پشتیبانی از نرخ منعطف',
    learnMoreAboutServiceTiers: 'اطلاعات بیشتر درباره سطوح سرویس',
    // Service Tier Explanation Modal
    serviceTierExplanation: {
      title: 'آشنایی با سطوح سرویس',
      overview:
        'سطوح سرویس به شما امکان می‌دهند استفاده از API را بر اساس نیازهای خاص خود بهینه‌سازی کنید. سطوح مختلف توازن‌های متفاوتی بین هزینه، تاخیر و دسترسی ارائه می‌دهند.',
      standardTitle: 'سطح استاندارد',
      standardDescription: 'سطح سرویس پیش‌فرض که عملکرد پایدار و قابل پیش‌بینی با قیمت‌گذاری استاندارد ارائه می‌دهد.',
      standardFeature1: 'زمان پاسخ‌دهی قابل پیش‌بینی',
      standardFeature2: 'محدودیت‌های نرخ استاندارد اعمال می‌شود',
      standardFeature3: 'بهترین گزینه برای بارهای کاری تولید که به تاخیر ثابت نیاز دارند',
      flexTitle: 'سطح منعطف',
      flexDescription:
        'سطح بهینه‌شده از نظر هزینه که صرفه‌جویی قابل توجهی در ازای تاخیر متغیر ارائه می‌دهد. مناسب برای بارهای کاری غیر حساس به زمان.',
      flexFeature1: 'تا ۵۰٪ کاهش هزینه نسبت به سطح استاندارد',
      flexFeature2: 'تاخیر متغیر - پاسخ‌ها ممکن است در زمان‌های اوج بیشتر طول بکشند',
      flexFeature3: 'ایده‌آل برای پردازش دسته‌ای، وظایف پس‌زمینه یا برنامه‌های حساس به هزینه',
      flexNote:
        'درخواست‌های سطح منعطف با اولویت پایین و زمانی که ظرفیت در دسترس است پردازش می‌شوند. زمان پاسخ‌دهی ممکن است بسته به تقاضا از چند ثانیه تا چند دقیقه متغیر باشد.',
      howToUseTitle: 'نحوه استفاده از سطوح سرویس',
      howToUseDescription: "برای استفاده از یک سطح سرویس خاص، پارامتر 'service_tier' را در درخواست API خود قرار دهید:",
      supportedModelsTitle: 'مدل‌های پشتیبانی‌شده',
      supportedModelsDescription:
        'در حال حاضر، فقط برخی از مدل‌های OpenAI از نرخ‌گذاری منعطف پشتیبانی می‌کنند. لیست مدل‌های پشتیبانی‌شده ممکن است در آینده افزایش یابد.',
      modelAliases: 'نام‌های جایگزین مدل',
      pricingTitle: 'مزایای قیمت‌گذاری',
      pricingDescription:
        'قیمت‌گذاری سطح منعطف معمولا ۵۰٪ کمتر از قیمت‌گذاری سطح استاندارد است. تخفیف دقیق بسته به مدل متفاوت است.',
      pricingExample:
        'مثال: اگر قیمت ورودی استاندارد ۲ دلار/۱ میلیون توکن باشد، قیمت منعطف حدود ۱ دلار/۱ میلیون توکن خواهد بود.',
      latencyTitle: 'ملاحظات تاخیر',
      latencyDescription:
        'سطح استاندارد پاسخ‌های ثابت با تاخیر کم ارائه می‌دهد که برای برنامه‌های بلادرنگ ایده‌آل است. سطح منعطف ممکن است تاخیر متغیری از چند ثانیه تا چند دقیقه داشته باشد، که آن را برای بارهای کاری ناهمزمان که پاسخ فوری حیاتی نیست مناسب می‌سازد.',
      creditPackageWarningTitle: 'مهم: بسته‌های اعتباری',
      creditPackageWarning:
        'استفاده از سطح منعطف توسط بسته‌های اعتباری پوشش داده نمی‌شود! اگر از بسته‌های اعتباری استفاده می‌کنید، فراخوانی‌های API با service_tier == flex از موجودی استاندارد شما کسر می‌شود نه از اعتبار بسته شما.'
    },
    inputPrice: 'نرخ ورودی',
    cachedInputPrice: 'نرخ ورودی کش شده',
    cacheCreationInputPrice: 'نرخ تولید ورودی کش شده',
    outputPrice: 'نرخ خروجی',
    audioInputPrice: 'نرخ صدای ورودی',
    audioOutputPrice: 'نرخ صدای تولید شده',
    noPricingAvailable: 'نرخ گذاری در دسترس نیست',
    shortDesc1: 'مشاهده و بررسی سطح دسترسی به مدل‌های مختلف',
    title: 'محدودیت‌های دسترسی',
    provider: 'ارائه دهنده',
    providerTooltip:
      'برخی مدل‌ها ممکن است ارائه‌دهندگان متفاوتی نسبت به مالک خود داشته باشند (مثلا deepseek.r1-v1:0 متعلق به DeepSeek است اما توسط AWS Bedrock ارائه می‌شود). همچنین مدل‌های یکسان در ارائه‌دهندگان مختلف ممکن است قیمت‌گذاری متفاوتی داشته باشند.',
    model: 'مدل',
    tpm: 'توکن در دقیقه (TPM)',
    rpm: 'درخواست در دقیقه (RPM)',
    info1:
      'سطوح دسترسی API منطبق با OpenAI تنظیم شده. دو نوع محدودیت اصلی شامل «توکن در دقیقه» به اختصار (TPM) و «درخواست در دقیقه یا روز» به اختصار (RPM/RPD) می‌شوند.',
    readDoc1: 'با مطالعه مستندات',
    readDoc2: 'راهنمای سطح دسترسی',
    readDoc3: 'میتوانید در مورد چگونگی آن اطلاعات بیشتری کسب نمایید.',
    usageTier: 'سطح دسترسی',
    noAccess: 'بدون دسترسی',
    free: 'پایه',
    tier: 'سطح',
    completed: 'تکمیل شده',
    current: 'فعلی',
    upcoming: 'بعدی',
    toIncreaseTier: 'برای ارتقا به سطح دسترسی بعد:',
    increaseYourLimits: 'ارتقای سطح دسترسی',
    youCurrentTier: 'حساب شما در',
    ast: 'قرار دارد',
    youWillmoveIf:
      'محدودیت‌های شما به صورت خودکار به سطح استفاده بعدی بر اساس معیارهای زیر افزایش خواهند یافت. برای کسب اطلاعات بیشتر به',
    toLearMore: 'درباره محدودیت‌های مرتبط با هر سطح استفاده مراجعه کنید.',
    tiers: {
      zero: {
        p1: 'برای فعال شدن دسترسی پایه API، ایمیل خود را تایید کنید.',
        p2: '',
        p3: '',
        p4: ''
      },
      tier0: {
        p1: 'سطح پایه برای کاربران با ایمیل تایید شده.',
        p2: 'با تایید شماره تلفن به سطح دسترسی ۱ ارتقا پیدا می‌کنید.',
        p3: '',
        p4: ''
      },
      tier1: {
        p1: 'شماره تلفن خود را تایید کنید. هیچ حداقل پرداختی لازم نیست.',
        monthlyLimit: 'سقف مصرف تا ۱۰۰ واحد در ماه.',
        p2: '',
        p3: '',
        p4: ''
      },
      tier2: {
        p1: 'دستکم ۱۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.',
        p2: '',
        monthlyLimit: 'سقف مصرف تا ۵۰۰ واحد در ماه.',
        p3: '',
        p4: ''
      },
      tier3: {
        p1: 'دستکم ۵۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.',
        p2: '',
        monthlyLimit: 'سقف مصرف تا ۱,۰۰۰ واحد در ماه.',
        p3: '',
        p4: ''
      },
      tier4: {
        p1: 'دستکم ۲۵۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.',
        p2: '',
        monthlyLimit: 'سقف مصرف تا ۵,۰۰۰ واحد در ماه.',
        p3: '',
        p4: ''
      },
      tier5: {
        p1: 'دستکم ۱,۰۰۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.',
        p2: '',
        monthlyLimit: 'سقف مصرف تا ۱۰,۰۰۰ واحد در ماه.',
        p3: '',
        p4: ''
      }
    },
    // Tier Upgrade System Localizations
    upgradeTitle: 'ارتقای سطح دسترسی',
    maxTierTitle: 'حداکثر سطح دسترسی',
    upgradeDescription:
      'با ارتقا به سطح بالاتر، قابلیت‌های دسترسی API خود را افزایش دهید. سطوح بالاتر امکان دسترسی به مدل‌های بیشتر، محدودیت‌های نرخ بالاتر (TPM/RPM) و ویژگی‌های مرتبط با سطح بعدی را فراهم می‌کنند.',
    maxTierDescription:
      'تبریک! شما به بالاترین سطح دسترسی رسیده‌اید و از حداکثر مزایا و دسترسی نامحدود به تمام ویژگی‌ها بهره‌مند هستید.',
    tierProgress: 'پیشرفت سطح دسترسی',
    howItWorks: 'نحوه عملکرد ارتقای سطح',
    importantNotes: 'اطلاعات مهم',
    currentTier: 'سطح فعلی',
    nextTier: 'سطح بعدی',
    progress: 'پیشرفت',
    totalPaid: 'مجموع پرداختی',
    required: 'مورد نیاز',
    remaining: 'باقی‌مانده',
    currentBenefits: 'مزایای فعلی',
    nextTierBenefits: 'مزایای سطح بعدی',
    upgradeNow: 'ارتقا دهید',
    maxTierReached: 'حداکثر سطح دسترسی!',
    upgradeToNextTier: 'ارتقاء به سطح بعدی',
    unlockBenefits: 'دسترسی فوری به تمام امکانات ویژه',
    instantUpgrade: 'ارتقاء فوری • بدون انتظار • بدون هزینه',

    // Step-by-step process
    step1Title: 'تایید تلفن یا شارژ حساب',
    step1Description:
      'تایید شماره تلفن، حساب دارای ایمیل تایید شده را بدون نیاز به حداقل پرداخت به سطح دسترسی ۱ ارتقا می‌دهد. برای رسیدن به سطح ۲ و بالاتر، حساب خود را شارژ کنید.',
    step2Title: 'محاسبه خودکار سطح',
    step2Description:
      'سیستم معادل واحد (UNIT) پرداخت تومان شما را در زمان پرداخت محاسبه می‌کند تا مجموع پرداختی را جهت ارتقای سطح محاسبه کند. ارتقای سطح ۲ و بالاتر بر اساس این مجموع ارزش مادام‌العمر به واحد انجام می‌شود.',
    step3Title: 'از محدودیت‌های بهبود یافته لذت ببرید',
    step3Description:
      'بلافاصله پس از ارتقای سطح، به محدودیت‌های نرخ بالاتر، مدل‌های بیشتر و ویژگی‌های ویژه دسترسی پیدا کنید.',
    step4Title: 'اعتبارات خود را حفظ کنید',
    step4Description:
      'تمام اعتبارات شارژ شده شما برای استفاده از API در دسترس باقی می‌مانند. ارتقای سطح اعتبارات شما را مصرف نمی‌کند.',
    step5Title: 'مزایای دائمی',
    step5Description: 'پس از ارتقا، مزایای سطح شما دائمی است و هرگز کاهش نخواهد یافت.',

    // Amount selection features
    selectAmount: 'انتخاب مبلغ شارژ',
    suggestedAmount: 'پیشنهادی',
    suggestedAmountTooltip: 'مبلغ توصیه شده با ۱٪ بافر برای محافظت در برابر نوسانات نرخ ارز',
    selectedAmount: 'مبلغ انتخابی',
    minimumRequired: 'حداقل مورد نیاز',
    exchangeRate: 'نرخ تبدیل',
    useSuggested: 'استفاده از پیشنهادی',

    // Tier selection features
    selectTargetTier: 'انتخاب سطح هدف',
    selectTierPlaceholder: 'سطح مورد نظر برای ارتقا را انتخاب کنید',
    selectedTier: 'سطح انتخابی',
    tier1PhoneVerificationUpgrade:
      'برای ارتقا به سطح دسترسی ۱، شماره تلفن خود را تایید کنید. هیچ پرداخت یا حداقل مجموع پرداختی لازم نیست.',
    activationGrantNewUser:
      'با تایید شماره تلفن خود، {amount} تومان اعتبار رایگان دریافت کنید.',
    activationGrantTopup:
      'با افزودن شماره تلفن، {amount} تومان اعتبار دریافت کنید تا مجموع اعتبار فعال‌سازی شما به {total} تومان برسد.',
    activationGrantBadge: '+{amount} تومان',
    emailVerificationRequired: 'ایمیل تایید شده',
    emailVerified: 'ایمیل تایید شود',
    phoneVerified: 'شماره تلفن تایید شود',
    targetTierBenefits: 'مزایای سطح هدف',
    upgradeToSelectedTier: 'ارتقا به سطح انتخابی',
    resetToNext: 'بازگشت به بعدی',
    recommended: 'توصیه شده',
    cost: 'هزینه',

    // Important notes
    note1: 'سطح دسترسی ۱ نیازمند تایید تلفن است؛ سطح ۲ و بالاتر بر اساس مجموع پرداخت‌های انجام شده محاسبه می‌شود',
    note2: 'تمام اعتبارات شارژ شده برای استفاده از API در دسترس باقی می‌مانند',
    note3: 'سطوح بالاتر امکان دسترسی به مدل‌های پیشرفته‌تر هوش مصنوعی و ویژگی‌ها را فراهم می‌کنند',

    // Tier Benefits
    benefits: {
      tier0: {
        basic: 'دسترسی پایه API با محدودیت‌های ابتدایی',
        limited: 'دسترسی فقط به مدل‌های ضروری'
      },
      tier1: {
        increased: 'محدودیت‌های نرخ و ظرفیت توکن افزایش یافته',
        priority: 'پشتیبانی اولویت‌دار و زمان پاسخ سریع‌تر',
        models: 'دسترسی به مدل‌های هوش مصنوعی اضافی'
      },
      tier2: {
        higher: 'محدودیت‌های استفاده ماهانه بالاتر (۵۰۰ واحد/ماه)',
        advanced: 'دسترسی به مدل‌های استدلالی پیشرفته',
        support: 'پشتیبانی بهبود یافته کاربران'
      },
      tier3: {
        premium: 'دسترسی ویژه با محدودیت ۱۰۰۰ واحد/ماه',
        enhanced: 'انتخاب مدل و قابلیت‌های بهبود یافته',
        features: 'دسترسی به ویژگی‌های آزمایشی و انتشارات جدید'
      },
      tier4: {
        enterprise: 'دسترسی سطح سازمانی (۵۰۰۰ واحد/ماه)',
        maximum: 'حداکثر محدودیت‌های نرخ و پردازش اولویت‌دار',
        dedicated: 'پشتیبانی اختصاصی و پیکربندی‌های سفارشی'
      },
      tier5: {
        unlimited: 'دسترسی نامحدود به تمام ویژگی‌ها و مدل‌ها',
        all: 'دسترسی به تمام مدل‌های هوش مصنوعی فعلی و آینده',
        priority: 'بالاترین اولویت پشتیبانی و راه‌حل‌های سفارشی'
      }
    },
    // Authentication and verification messages
    notLoggedIn: 'وارد نشده‌اید',
    loginRequired: 'لطفا برای دسترسی به مزایای سطح و گزینه‌های ارتقا وارد شوید.',
    loginNow: 'ورود',
    phoneNotVerified: 'تلفن تایید نشده است',
    phoneVerificationRequired: 'لطفا برای باز کردن قفل مزایای سطح، شماره تلفن خود را تایید کنید.',
    verifyPhone: 'تایید تلفن',
    notAuthenticated: 'احراز هویت مورد نیاز است',
    authenticationRequired: 'لطفا برای دسترسی به مزایای سطح خود، احراز هویت را کامل کنید.',
    authenticateNow: 'احراز هویت',
    accessRestricted: 'دسترسی محدود شده است',
    verificationRequired: 'لطفا برای دسترسی به مزایای سطح، تایید را کامل کنید.',
    getVerified: 'تایید شوید'
  },
  usage: {
    totalUsed: 'استفاده شده',
    totalAudio: 'مجموع آوا',
    audioInputSeconds: 'آوای ورودی',
    audioOutputSeconds: 'آوای خروجی',
    all: 'همه',
    success: 'موفق',
    pending: 'بلاتکلیف',
    failed: 'ناموفق',
    summary: 'خلاصه',
    download: 'بارگذاری',
    action: 'عملیات',
    status: 'وضعیت',
    expiresAt: 'تاریخ انقضا',
    generatedAt: 'تاریخ صدور',
    consumptionReport: 'گزارش مصارف',
    generateReport: 'صدور گزارش',
    timeFrame: 'بازه زمانی',
    meanExchangeRate: 'متوسط نرخ تبدیل',
    inputTokens: 'توکن وروردی',
    outputTokens: 'توکن خروجی',
    cachedTokens: 'توکن کش شده',
    request: 'درخواست',
    totalTokens: 'مجموع توکن‌ها',
    totalRequests: 'مجموع درخواست‌ها',
    costs: 'هزینه‌ها',
    cost: 'هزینه‌',
    tokens: 'توکن',
    requests: 'درخواست‌ها',
    title: 'مصارف',
    daily: 'روزانه',
    hourly: 'ساعتی'
  },
  feedback: {
    sendFeedback: 'ثبت بازخورد',
    description: 'نظر خود را با ما در میان بگذارید',
    title: 'عنوان',
    titleInputPlaceHolder: 'چه موضوعی مد نظر شماست؟',
    body: 'بازخورد',
    bodyInputPlaceHolder: 'بازخورد شما، هر آنچه که میخواهید با ما در میان بگذارید.',
    footerDescription:
      'ارائه بازخورد می‌تواند به ما کمک کند تا سیستم خود را بهبود بخشیم و تجربه کاربری را برای همه بهتر کنیم.',
    sendButton: 'ارسال',
    thankYouTitle: 'متشکریم!',
    thankYouMessage:
      'ما بازخورد شما را دریافت کردیم. معمولا دو روز طول می‌کشد تا پاسخی از ما دریافت کنید، اما گاهی اوقات زودتر.',

    okayButton: 'باشه',
    sendFailed: 'ارسال بازخورد با خطا مواجه شد',
    sendSuccess: 'بازخورد ثبت شد',
    bodyCantBeEmpty: 'متن بازخورد نمیتواند خالی باشد',
    bodyTooShort: 'متن بازخورد نباید کمتر از ۲۰ کاراکتر باشد'
  },
  languages: {
    'fa-IR': 'فارسی',
    'en-US': 'انگلیسی'
    // Add other languages as needed
  },
  paymentStatus: {
    success: 'موفق',
    pending: 'در انتظار',
    failed: 'ناموفق',
    processing: 'در حال پردازش'
  },
  status: {
    pending: 'در انتظار',
    completed: 'تکمیل شده',
    failed: 'ناموفق'
  },
  reports: {
    longerFramesRateLimit: 'برای گزارش‌های با بازه زمانی بیش از ۳ روز، تنها یک درخواست در هر ۲۴ ساعت مجاز است.',
    reportGenerationSubmitted:
      'درخواست گزارش با موفقیت ثبت شد. وضعیت آن را در فهرست زیر بررسی کنید؛ ساخت بعضی گزارش‌ها ممکن است تا ۶۰ دقیقه زمان ببرد.',
    downloadFailed: 'گزارش بارگیری نشد. پس از بررسی وضعیت و تاریخ انقضای آن، دوباره تلاش کنید.',
    fetchFailed: 'فهرست گزارش‌ها بارگیری نشد. صفحه را تازه‌سازی و دوباره تلاش کنید.',
    generatedSuccessfully: 'گزارش با موفقیت ساخته و بارگیری شد.',
    generationFailed: 'گزارش ساخته نشد. کمی بعد دوباره تلاش کنید.',
    linkedReportUnavailable: 'گزارش پیوندشده در دسترس نیست، منقضی شده یا دیگر به این حساب تعلق ندارد.',
    title: 'گزارش مصارف API',
    timeFrame: 'بازه زمانی',
    generateReport: 'صدور گزارش',
    reportSummary: 'خلاصه گزارش',
    downloadReport: 'بارگذاری',
    viewSummary: 'خلاصه',
    lastHour: 'یک ساعت پیش',
    last6Hours: '۶ ساعت گذشته',
    last12Hours: '۱۲ ساعت گذشته',
    lastDay: '۲۴ ساعت گذشته',
    last2Days: '۴۸ ساعت گذشته',
    last3Days: '۷۲ ساعت گذشته',
    lastWeek: 'هفته گذشته',
    last28Days: '۲۸ روز گذشته',
    lastMonth: 'ماه گذشته',
    last3Months: '۳ ماه گذشته',
    last6Months: '۶ ماه گذشته',
    lastYear: 'سال گذشته',
    allTime: 'از ابتدا',
    columns: {
      language: 'زبان',
      generatedAt: 'تاریخ صدور',
      timeFrame: 'بازه زمانی',
      expiresAt: 'تاریخ انقضا',
      status: 'وضعیت',
      origin: 'منشا'
    },
    origin: {
      selfService: 'ایجاد توسط کاربر',
      support: 'پشتیبانی'
    },
    summary: {
      user: 'کاربر',
      dateRange: 'بازه زمانی',
      generatedAt: 'تاریخ صدور',
      totalTransactions: 'تعداد کل تراکنش‌‌ها',
      totalCostUnits: 'کل هزینه به واحد',
      totalPaidUnits: 'کل هزینه پرداختی به واحد',
      totalPaidIRT: 'کل هزینه پرداختی تومانی',
      totalPaidGrantIRT: 'کل هزینه پرداخت شده از اعتبارات هدیه',
      financialDetails: 'خلاصه هزینه‌ها'
    }
  },
  billing: {
    addresses: {
      title: 'آدرس‌های صورتحساب',
      subtitle: 'آدرس‌های مورد استفاده برای صورتحساب، فاکتور و درخواست‌های پشتیبانی را مدیریت کنید.',
      add: 'افزودن آدرس',
      addFirst: 'افزودن اولین آدرس',
      total: 'آدرس‌های ذخیره‌شده',
      currentDefault: 'آدرس پیش‌فرض فعلی',
      historyProtection: 'سوابق تاریخی',
      historyProtectionValue: 'محافظت‌شده',
      none: 'بدون آدرس',
      noName: 'بدون عنوان',
      default: 'پیش‌فرض',
      makeDefault: 'تنظیم به‌عنوان پیش‌فرض',
      edit: 'ویرایش',
      delete: 'حذف',
      deleteAll: 'حذف همه آدرس‌ها',
      searchPlaceholder: 'جستجوی عنوان، شهر، آدرس یا کد پستی',
      empty: 'آدرس صورتحسابی ذخیره نشده است',
      noResults: 'آدرسی مطابق جستجوی شما یافت نشد',
      loadFailed: 'دریافت آدرس‌ها با خطا مواجه شد.',
      retry: 'تلاش دوباره',
      defaultSuccess: 'آدرس پیش‌فرض به‌روزرسانی شد',
      defaultFailed: 'به‌روزرسانی آدرس پیش‌فرض ناموفق بود',
      deleteSuccess: 'آدرس حذف شد',
      deleteFailed: 'حذف آدرس ناموفق بود',
      defaultDeleteBlocked: 'پیش از حذف این آدرس، آدرس دیگری را پیش‌فرض کنید.',
      inUseDeleteBlocked: 'این آدرس در سابقه پرداخت، صورتحساب یا درخواست پشتیبانی استفاده شده است.',
      deleteConfirm: 'آدرس {name} حذف شود؟ این آدرس از دفترچه آدرس فعال شما خارج می‌شود.',
      deleteConfirmAction: 'حذف آدرس',
      deleteAllConfirmTitle: 'همه آدرس‌های ذخیره‌شده حذف شوند؟',
      deleteAllConfirmDescription:
        'تمام آدرس‌ها، از جمله آدرس پیش‌فرض، از دفترچه آدرس فعال حذف می‌شوند. سوابق مالی گذشته بدون تغییر باقی می‌مانند.',
      deleteAllConfirmAction: 'حذف همه',
      deleteAllSuccess: '{count} آدرس حذف شد',
      deleteAllFailed: 'حذف دفترچه آدرس ناموفق بود',
      summaryLabel: 'خلاصه آدرس‌ها',
      statusRegion: 'وضعیت دفترچه آدرس',
      loadingLabel: 'در حال بارگذاری آدرس‌های شما'
    },
    invoices: {
      title: 'صورتحساب‌ها و رسیدها',
      subtitle: 'اسناد پرداخت صادرشده برای حساب کاربری شما.',
      total: 'مجموع اسناد',
      filters: 'فیلترها',
      allTypes: 'همه انواع سند',
      allStatuses: 'همه وضعیت‌ها',
      standard: 'رسید پرداخت',
      vat: 'ارزش افزوده',
      type: 'نوع سند',
      status: 'وضعیت',
      dateRange: 'تاریخ پرداخت',
      startDate: 'از تاریخ',
      endDate: 'تا تاریخ',
      payment: 'پرداخت',
      paymentPlaceholder: 'شناسه تراکنش پرداخت',
      invalidPaymentId: 'شناسه تراکنش پرداخت باید یک UUID معتبر باشد.',
      invalidDateRange: 'تاریخ شروع باید قبل از تاریخ پایان یا برابر با آن باشد.',
      apply: 'اعمال فیلتر',
      reset: 'پاک کردن',
      refresh: 'تازه‌سازی',
      tableDate: 'تاریخ',
      tableType: 'نوع سند',
      tablePayment: 'پرداخت',
      tableAmount: 'مبلغ پرداختی',
      tableStatus: 'وضعیت',
      tableDocument: 'اسناد',
      actions: 'عملیات',
      receipt: 'رسید',
      vatInvoice: 'صورتحساب ارزش افزوده',
      downloadReceipt: 'دریافت رسید',
      downloadVat: 'دریافت صورتحساب ارزش افزوده',
      resendEmail: 'ارسال دوباره با ایمیل',
      requestDocuments: 'درخواست تولید اسناد',
      requestReceipt: 'درخواست رسید',
      requestVat: 'درخواست صورتحساب ارزش افزوده',
      openInvoice: 'مشاهده صورتحساب',
      loadFailed: 'دریافت صورتحساب‌ها با خطا مواجه شد.',
      refreshFailed: 'تازه‌سازی صورتحساب‌ها انجام نشد. نتایج فعلی همچنان در دسترس هستند.',
      downloadFailed: 'دریافت سند با خطا مواجه شد.',
      downloadSuccess: 'سند دریافت شد.',
      resendFailed: 'درخواست ارسال ایمیل ثبت نشد.',
      resendQueued: 'ارسال ایمیل صورتحساب در صف قرار گرفت.',
      requestFailed: 'درخواست تولید سند ثبت نشد.',
      requestQueued: 'تولید اسناد در صف قرار گرفت.',
      requestAlreadyAvailable: 'سند از قبل آماده و در دسترس است.',
      requestAlreadyProcessing: 'تولید سند از قبل در حال انجام است.',
      empty: 'صورتحسابی یافت نشد',
      emptyDescription: 'سند پرداختی با این فیلترها وجود ندارد.',
      toman: 'تومان',
      categories: {
        subscription: 'اشتراک',
        credit_topup: 'افزایش اعتبار',
        credit_package: 'بسته اعتباری'
      },
      documentStatuses: {
        generating: 'در حال آماده‌سازی',
        receiptGenerating: 'رسید پرداخت در حال آماده‌سازی است',
        vatGenerating: 'صورتحساب رسمی مهرشده در حال آماده‌سازی است',
        available: 'در دسترس',
        unavailable: 'در دسترس نیست'
      }
    },
    noCreditPackages: 'بسته اعتباری فعال نیست',
    manageCreditPackages: 'مدیریت بسته‌های اعتباری',
    packagesTotalUnit: 'مجموع بسته‌های اعتباری معادل واحد',
    expirationTimeline: 'تاریخ انقضای بسته‌های اعتباری',
    creditBreakdown: 'بسته‌های اعتباری',
    unnamedPackage: 'بسته اعتباری',
    sortOptions: {
      featured: 'ویژه',
      price: 'قیمت (کم به زیاد)',
      valueRatio: 'نسبت ارزش',
      newest: 'جدیدترین',
      oldest: 'قدیمی‌ترین',
      expiration: 'زمان انقضا'
    },
    packages: {
      myPackages: 'بسته‌های من',
      promotional: 'فروش ویژه',
      summary: {
        total: 'کل بسته‌ها',
        active: 'بسته‌های فعال',
        usage: 'میانگین استفاده',
        remaining: 'باقی‌مانده بسته‌ها',
        totalSources: 'کل منابع',
        packages: 'بسته‌های اعتباری',
        grants: 'گرنت‌ها',
        totalBalance: 'کل موجودی'
      },
      tabs: {
        overview: 'نمای کلی',
        usage: 'تحلیل استفاده',
        expiration: 'جدول زمانی انقضا'
      },
      otp: {
        title: 'تایید خرید به مبلغ {amount}',
        description: 'لطفا کد تایید ۶ رقمی ارسال شده به تلفن همراه خود را برای تکمیل خرید وارد کنید.',
        invalidLength: 'طول کد تایید نامعتبر است',
        send: 'ارسال کد',
        resent: 'کد تایید مجددا ارسال شد',
        expiresIn: 'کد در {time} منقضی می‌شود',
        expired: 'کد تایید منقضی شده است',
        cancel: 'لغو',
        verify: 'تایید کد',
        resend: 'ارسال کد جدید'
      },
      timeline: {
        expired: 'منقضی شده',
        thisMonth: 'این ماه',
        nextMonth: 'ماه آینده',
        noExpiration: 'هیچ بسته‌ای تاریخ انقضا ندارد',
        expiredCount: 'بسته‌های منقضی شده',
        expiringThisWeek: 'این هفته منقضی می‌شوند',
        expiringThisMonth: 'این ماه منقضی می‌شوند',
        safePeriod: 'دوره امن (بیش از ۳۰ روز)',
        summary: 'خلاصه',
        later: 'بعدا',
        remaining: 'باقی مانده'
      },
      filters: {
        title: 'فیلترها',
        reset: 'بازنشانی فیلترها',
        allServices: 'تمام سرویس‌ها',
        serviceType: 'نوع سرویس',
        apiOnly: 'فقط API',
        subscriptionOnly: 'فقط اشتراک',
        showPromotional: 'نمایش بسته‌های تبلیغاتی',
        priceRange: 'محدوده قیمت',
        subServices: 'زیر سرویس‌ها',
        modelFamilies: 'خانواده مدل‌ها',
        subscriptionTiers: 'سطوح اشتراک'
      },
      authRequired: {
        title: 'ورود به حساب کاربری، ضروری است.',
        description: 'لطفا وارد حساب کاربری خود شوید تا بسته‌های خریداری شده و میزان استفاده از آن‌ها را مشاهده کنید.'
      },
      paymentMethods: {
        bankCard: 'کارت بانکی',
        creditBalance: 'موجودی اعتباری'
      },
      status: {
        all: 'همه',
        active: 'فعال',
        expired: 'منقضی شده',
        exhausted: 'تمام شده'
      },
      totalAmountBePaid: 'مبلغ کل پرداختی',
      totalCreditsReceiving: 'کل اعتبارات دریافتی',
      empty: 'هیچ بسته‌ای موجود نیست',
      emptyDescription: 'در حال حاضر هیچ بسته اعتباری برای خرید موجود نیست',
      allServices: 'تمام سرویس‌ها',
      noExpiration: 'بدون انقضا',
      creditPackages: 'بسته‌های اعتباری',
      grantCredits: 'اعتبارات هدیه',
      generalBalance: 'موجودی کیف پول',
      generalBalanceDescription: 'موجودی اصلی کیف پول شما برای تمام سرویس‌ها',
      creditsPerToman: 'اعتبار بیشتر',
      expired: 'منقضی شده',
      expirestoday: 'امروز منقضی می‌شود',
      expiresTomorrow: 'فردا منقضی می‌شود',
      expiresInDays: '{days} روز دیگر',
      expiresInWeeks: '{weeks} هفته دیگر منقضی می‌شود',
      expiresOn: 'در تاریخ {date} منقضی می‌شود',
      redirectingToPayment: 'در حال انتقال به درگاه پرداخت',
      purchaseComplete: 'خرید با موفقیت تکمیل شد',
      purchaseSuccessMessage:
        'بسته اعتباری شما خریداری و به حساب شما اضافه شده است. اکنون می‌توانید آن را در بخش بسته‌های من مشاهده و مدیریت کنید.',
      goToMyPackages: 'رفتن به بسته‌های من',
      purchaseFailed: 'خرید ناموفق بود. لطفا دوباره تلاش کنید.',
      insufficientCredit: 'موجودی اعتبار ناکافی',
      insufficientCreditMessage:
        'موجودی اعتبار شما برای تکمیل این خرید کافی نیست. شما به {shortfall} تومان دیگر نیاز دارید.',
      choosePaymentOption: 'یک گزینه پرداخت انتخاب کنید:',
      useDirectPayment: 'پرداخت مستقیم بانکی',
      topUpCredit: 'افزایش اعتبار کیف پول',
      otpFailed: 'تایید کد ناموفق بود',
      paymentCheckFailed: 'بررسی وضعیت پرداخت ناموفق بود. لطفا دوباره تلاش کنید.',
      openPaymentPage: 'بازگشت به صفحه پرداخت',
      paymentPending: 'تراکنش هنوز تکمیل نشده است، لطفا پرداخت را تکمیل یا مجدد وضعیت تراکنش را بررسی نمایید.',
      paymentNotFound: 'تراکنش یافت نشد! لطفا دوباره تلاش کنید.',
      clearFilters: 'پاک کردن فیلترها',
      browse: 'مرور بسته‌ها',
      title: 'بسته‌های اعتباری',
      description: 'با خرید بسته‌های اعتباری، در هزینه‌ها صرفه جویی و موجودی حساب خود را مدیریت کنید.',
      marketplace: 'فروشگاه',
      purchaseTitle: 'خرید بسته اعتباری',
      quantity: 'تعداد',
      packages: 'بسته',
      paymentMethod: 'روش پرداخت',
      unitPrice: 'قیمت واحد',
      toman: 'تومان',
      totalAmount: 'مبلغ کل',
      totalCredits: 'کل اعتبارات',
      cancel: 'لغو',
      confirmPurchase: 'تایید خرید',
      processingPayment: 'در حال پردازش پرداخت...',
      noPackagesFound: 'هیچ بسته‌ای یافت نشد',
      purchasedOn: 'خریداری شده در {date}',
      usage: 'استفاده',
      remaining: 'باقی‌مانده',
      used: 'استفاده شده',
      viewDetails: 'مشاهده جزئیات',
      viewDetailsTooltip: 'برای مشاهده آمار تفصیلی استفاده کلیک کنید',
      featured: 'ویژه',
      apiService: 'سرویس API',
      subscriptionService: 'سرویس اشتراک',
      scope: 'محدوده مجاز',
      validFor: 'معتبر برای {days} روز',
      maxPerUser: 'حداکثر {count} بسته به ازای هر کاربر',
      unavailable: 'در دسترس نیست',
      purchase: 'خرید',
      browsePackages: 'مرور بسته‌ها',
      noPackages: 'هیچ بسته‌ای یافت نشد',
      package: 'بسته',
      availableModels: 'مدل‌های در دسترس',
      balance: 'موجودی',
      grant: 'گرنت',
      maxQuantity: 'حداکثر تعداد مجاز',
      packageScope: 'محدوده پوشش بسته',
      valueRatioTooltip: 'به نسبت مبلغی که پرداخت می نمایید اعتبار بیشتری دریافت می کنید',
      packageScopeTooltip:
        'لیست خدمات مجاز تحت پوشش بسته اعتباری ممکن است شامل مدل‌ها یا سرویس‌های مشخصی باشد. این بسته صرفا برای استفاده از خدمات و مدل‌های ذکر شده در لیست محدوده پوشش مجاز که در توضیحات بسته آمده است، طراحی شده است. با خرید این بسته، امکان استفاده از تخفیف برای سایر مدل‌ها یا خدماتی که خارج از محدوده پوشش هستند وجود ندارد. در صورت استفاده از خدماتی که تحت پوشش بسته نیستند، هزینه بر اساس نرخ آزاد محاسبه خواهد شد',
      agreements: {
        title: 'قرارداد خرید',
        description: 'لطفا جهت ادامه خرید، شرایط و ضوابط زیر را مطالعه و تایید نمایید:',
        balanceRequirement:
          'جهت بهره‌مندی موثر از بسته‌های اعتباری، ضروری است که موجودی کلی حساب شما مثبت باشد. در صورت صفر یا منفی شدن موجودی کلی، سرویس‌های API به طور خودکار غیرفعال خواهند شد. توصیه می‌شود حداقل مبلغ ۵۰,۰۰۰ تومان در موجودی کلی حساب خود حفظ نمایید تا ارائه سرویس بدون وقفه ادامه یابد.',
        expirationPolicy:
          'بسته‌های اعتباری دارای تاریخ انقضای ثابت و غیرقابل تمدید هستند. پس از انقضای تاریخ مذکور، بسته‌ها، صرف‌ نظر از اعتبارات استفاده نشده باقی‌مانده، قابل تجدید یا بازیابی نخواهند بود.',
        serviceCoverage:
          'هر بسته اعتباری منحصرا برای سرویس‌ها و مدل‌های مشخص‌ شده در توضیحات همان بسته قابل استفاده است. اعتبارات مذکور قابل انتقال یا استفاده برای سرویس‌ها، مدل‌ها یا ویژگی‌های دیگری که صراحتا در شرایط بسته گنجانده نشده‌اند، نمی‌باشند.',
        acceptTerms: 'تمام شرایط و ضوابط فوق را مطالعه کرده و می‌پذیرم.',
        mustAcceptTerms: 'جهت ادامه خرید، پذیرش شرایط و ضوابط الزامی است.',
        balanceRequirementTitle: 'الزامات موجودی حساب',
        expirationPolicyTitle: 'سیاست انقضای بسته',
        serviceCoverageTitle: 'محدودیت پوشش سرویس',
        serviceTierLimitationTitle: 'محدودیت سطح سرویس',
        serviceTierLimitation:
          "بسته‌های اعتباری فقط درخواست‌های API که با سطح سرویس پیش‌فرض 'استاندارد' ارسال می‌شوند را پوشش می‌دهند. اگر از سطح سرویس 'منعطف' استفاده کنید (با تنظیم service_tier=flex در درخواست‌های API)، این هزینه‌ها از اعتبار بسته کسر نخواهد شد و در عوض از موجودی کلی حساب شما کسر می‌شوند."
      }
    },
    notificationWillBe: 'اعلانات ارسال می شود به',
    thresholdsMustBeDivisibleByFive: 'سطح آستانه باید بر ۵ بخش پذیر باشد',
    thresholdsMustBeLeast: 'حداقل سطح مجاز آستانه ',
    creditNotificationSaved: 'تنظیمات ذخیره شد',
    additionalRecipientsDescription:
      'اعلانات به آدرس ایمیل و شماره تلفن ثبت شده در حساب کاربری ارسال می گردد، با این حال اگر نیاز دارید تا اعلانات به دیگر شماره تلفن یا آدرس‌های ایمیل نیز ارسال شوند میتوانید آنها را در زیر اضافه نمایید.',
    addUpToTwoEmailsAndPhones: 'تا ۲ ایمیل و شماره تلفن دیگر را میتوانید جهت دریافت اعلانات ثبت نمایید',
    additionalRecipients: 'دیگر دریافت کنندگان',
    notificationThresholds: 'سطوح آستانه اعلانات',
    receiveAlertsWhen: 'زمانی که اعتبار حساب کاربری به یکی از سطوح آستانه برسد، اطلاع رسانی می شود',
    creditNotificationSettings: 'تنظیمات اعلانات اعتبار',
    packageBalanceWarning: {
      title: 'هشدار موجودی بسته اعتباری',
      message:
        'شما بسته‌های اعتباری فعال دارید، اما موجودی عمومی حساب شما صفر یا منفی است. سرویس‌های API به طور خودکار غیرفعال می‌شوند تا زمانی که حساب خود را شارژ کنید.',
      requirement: 'برای استفاده از بسته‌های اعتباری و فعال نگه داشتن کلیدهای API، موجودی عمومی مثبت الزامی است.',
      action: 'همین الان حساب خود را شارژ کنید تا سرویس‌های API دوباره فعال شوند.',
      rechargeButton: 'شارژ حساب'
    },
    loadingCreditNotificationSettings: 'در حال دریافت تنظیمات',
    creditNotificationDisabled: 'اعلانات کاهش اعتبار غیر فعال است',
    creditNotificationAt: 'اعلان اعتبار در این سطوح آستانه فعال است',
    creditNotification: 'اعلانات اعتبار',
    rateExpired: 'تراکنش دیگر معتبر نیست',
    clickRefreshToUpdate: 'لطفا دوباره تلاش کنید',
    refreshRate: 'تازه‌سازی',
    amountMustBePositive: 'مقدار ورودی نمیتواند منفی باشد',
    invalidExchangeAmount: 'مقادیر ورودی معتبر نمی باشند',
    invalidExchangeParameters: 'موارد مورد تبدیل نامعتبر هستند',
    exchangeReviewFailed: 'خطایی رخ داد، لطفا دوباره تلاش کنید',
    error: 'خطا',
    exchangeSuccessful: 'تبدیل با موفقیت انجام شد',
    exchangeFailedUnknown: 'تراکنش با خطا مواجه شد',
    exchangeValidationFailed: 'صحت تراکنش تایید نشد',
    unauthorizedExchange: 'تراکنش رد شد',
    tooManyRequests: 'تعداد درخواست بیش از حد مجاز، لطفا چند لحظه بعد تلاش کنید',
    tooManyRequestsDesc: '',
    exchangeFailed: 'تراکنش ناموفق',
    refreshDataFailed: 'اطلاعات دریافت نشد',
    totalPaidInUnitTooltip:
      'نمایش مجموع کل اعتبارات افزایش یافته از طریق پرداخت بانکی به حساب کاربری (بر حسب UNIT)  از زمان ایجاد آن. محاسبه هر بار شارژ بر مبنای نرخ تبدیل در زمان خرید انجام شده است، نه نرخ تبدیل کنونی.',
    totalPaidInUnit: 'مجموع پرداختی معادل واحد',
    historyAmount: 'مبلغ پرداختی',
    paymentId: 'شناسه',
    trackingCode: 'کد رهگیری',
    paymentStatusFailed: 'بررسی وضعیت تراکنش با خطا مواجه شد',
    paymentStatusUpdated: 'وضعیت تراکنش بررسی شد',
    totalAmount: 'مبلغ کل',
    pendingTransactions: 'تراکنش‌های درحال تایید',
    confirmedTransactions: 'تراکنش‌های تایید شده',
    selectStatus: 'انتخاب وضعیت',
    selectItemType: 'انتخاب نوع تراکنش',
    paymentHistory: 'تاریخچه پرداخت',
    paymentHistoryLoadFailed: 'دریافت تاریخچه پرداخت با خطا مواجه شد. دوباره تلاش کنید.',
    totalTransactions: 'مجموع تراکنش‌ها',
    purchaseItem: 'نوع',
    subscription: 'اشتراک',
    credit: 'اعتبار',
    confirmationDate: 'تاریخ تایید',
    paidAmount: 'مبلغ پرداختی',
    discount: 'تخفیف',
    howToUseApi1: 'دریافت مانده اعتبار از طریق API',
    sampleOutput: 'پاسخ نمونه:',
    howToUseApi2:
      'توضیحات: remaining_irt معادل «باقی مانده اعتبار تومانی» و remaining_unit معادل «باقی مانده اعتبار تبدیل شده به واحد (نرخ تتر)» و exchange_rate نرخ تبدیل لحظه‌ای و در نهایت total_unit معادل تمام اعتبارها از جمله اعتبار افزایش یافته از طریق پرداخت بانکی، اعتبار هدیه، گرنت و ... بر مبنای نرخ تبدیل لحظه‌ای است. مقدار total_unit ملاک سنجش است.',
    exhausted: 'مصرف شده',
    remainingDays: 'روزهای باقی‌ مانده',
    remainingHours: 'ساعات باقی مانده',
    remainingMinutes: 'دقایق باقی مانده',
    remaining: 'باقی مانده',
    expiration: 'انقضا',
    grantsTotalUnit: 'مجموع اعتبار هدیه معادل واحد',
    unnamedGrant: 'بدون عنوان',
    grants: 'اعتبار هدیه',
    exchangeRateUSDT: 'نرخ مبادله تتر',
    fee: 'کارمزد',
    timesUp: 'تراکنش دیگر معتبر نیست.',
    reviewValidTill: 'مقادیر پیش نمایش تا',
    secondsValidAst: 'ثانیه دیگر معتبر است.',
    exchangeTo: 'مقدار نهایی',
    exchangeFrom: 'تبدیل از',
    exchangeRate: 'نرخ تبدیل',
    feeAmount: 'کارمزد',
    shortDesc1: 'مدیریت و بررسی جزئیات اعتبار حساب کاربری.',
    title: 'مدیریت مالی',
    topup: 'افزایش اعتبار',
    minAmount: 'حداقل',
    maxAmount: 'حداکثر',
    IRI: 'ریال',
    IRT: 'تومان',
    UNIT: 'واحد اعتبار',
    total: 'مجموع اعتبار به واحد',
    recharge: 'افزایش اعتبار',
    confirm: 'تایید',
    and: 'و',
    pay: 'پرداخت',
    remaningCredit: 'اعتبار باقی مانده',
    zero: 'صفر',
    remainingCredit: 'اعتبار باقی مانده',
    remainingCreditTotalUnit: 'مجموع اعتبار باقی‌ مانده معادل واحد',
    noCredits: 'بدون اعتبار',
    sourceAmount: 'از',
    targetAmount: 'به مبلغ',
    amount: 'مبلغ',
    exchange: 'تبدیل',
    exchangeTitle: 'تبدیل اعتبار',
    confirmAndExchange: 'تایید و تبدیل',
    close: 'بازگشت',
    exchangeConfirmFailed: 'تبدیل با خطا مواجه شد.',
    exchangeConfirmed: 'تبدیل با موفقیت انجام شد',
    totalCost: 'هزینه کل',
    loginToViewCredit: 'برای مشاهده موجودی واقعی اعتبار و تاریخچه تراکنش‌ها وارد شوید',
    phoneVerification: {
      title: 'اتصال شماره تلفن برای ادامه پرداخت',
      description:
        'پیرو دستور پلیس فتا و برای جلوگیری از سوءاستفاده، پرداخت بیش از {amount} تومان در هفته نیازمند داشتن شماره تلفن تأییدشده در حساب کاربری است.',
      weeklyLimitAmount: '۵ میلیون',
      infoBanner:
        'این محدودیت برای مجموع پرداخت‌های ۷ روز اخیر شما اعمال می‌شود. شماره تلفن خود را همین‌جا وارد و تأیید کنید؛ پس از تأیید، محدودیت برداشته می‌شود و می‌توانید پرداخت را دوباره انجام دهید.',
      verifyHere: 'شماره تلفن خود را در ادامه وارد و تأیید کنید',
      alternativeNote:
        'در صورت عدم تمایل به اتصال شماره تلفن، می‌توانید مبلغ پرداخت را کاهش دهید یا تا خارج شدن پرداخت‌های قبلی از بازه ۷ روزه صبر کنید.',
      backToPayment: 'بازگشت به صفحه پرداخت'
    }
  },
  // descriptionXs:
  //   'به مدت یک سال از تاریخ دعوت، ۱۰ درصد از فروش بسته «پلاس» و ۱ درصد از هزینه‌های api را دریافت نمایید!',
  // descriptionXs:
  //   'به مدت یک سال از تاریخ دعوت، ۱۰ درصد از فروش اشتراک «پلاس» را دریافت نمایید! همچنین دوستان شما در اولین خرید ۱۵ درصد تخفیف خواهند گرفت!',
  affiliate: {
    stepsTitle: 'همکاری در فروش خود را همین حالا شروع کنید',
    stepsDescription: 'این مراحل ساده را دنبال کنید تا شروع به کسب درآمد کنید',
    step1Title: 'کد دعوت خود را دریافت کنید',
    step1Description: 'کد دعوت ویژه شما آماده اشتراک‌گذاری است',
    step1Description2: 'برای دریافت کد خود وارد شوید',
    step2Title: 'دوستان را دعوت کنید',
    step2Description: 'کد دعوت خود را با دوستان و همکاران به اشتراک بگذارید',
    step2Description2: 'وقتی آنها با استفاده از کد شما ثبت‌نام می‌کنند، هر دوی شما مزایا دریافت می‌کنید!',
    step3Title: 'پاداش کسب کنید',
    step3Description: 'برای هر تراکنشی که دعوت‌شدگان شما انجام می‌دهند، کمیسیون دریافت کنید',
    step3Description2: 'درآمد خود را همین‌جا در این صفحه پیگیری کنید!',
    title: 'همکاری در فروش',
    descriptionLg:
      'با همکاری در بازاریابی و معرفی AvalAI به دوستان خود از طریق لینک مقابل، در درآمد فروش سهیم شده و کسب درآمد کنید.',
    descriptionXs: 'به مدت یک سال از تاریخ دعوت، ۱۰ درصد از فروش اشتراک «پلاس» را دریافت نمایید!',
    totalUsers: 'مجموع دعوت‌ها',
    usersAddedThisMonth: 'دعوت‌های این ماه',
    totalIncomeThisMonth: 'درآمد این ماه',
    totalIncomeConfirmed: 'درآمد کل',
    totalIncomePending: 'در حال تایید',
    inWithdrawalProcess: 'در حال برداشت',
    lastSettledIncome: 'آخرین برداشت',
    usersInMonth: 'دعوت در ماه',
    username: 'نام کاربری',
    registrationDate: 'تاریخ ثبت نام',
    lastTransactionDate: 'آخرین تراکنش',
    confirmedCommission: 'تایید شده',
    pendingCommission: 'در حال تایید',
    netIncome: 'درآمد کل',
    transactions: 'تراکنش‌ها',
    noTransaction: 'ندارد'
  },
  api: {
    couldNotFetchShowingCatched: 'دریافت تنظیمات کلید با خطا مواجه شد، در حال مشاهد اطلاعات پیشین هستید.',
    loadingKeyData: 'در حال دریافت تنظیمات',
    keyNotFound: 'کلید API یافت نشد، درصورت بروز مشکل لطفا یک مرتبه صفحه را رفرش نمایید.',
    maxApiKeysReached:
      'حداکثر سقف مجاز تعداد کلید‌های API تکمیل شده است، لطفا پیش از ایجاد کلید جدید، کلید‌های قبلی را حذف نمایید.',
    invalidRequest: 'درخواست نامعتبر است. لطفا اطلاعات کلید را بررسی و دوباره تلاش کنید.',
    noPermission:
      'شما دسترسی انجام این عملیات را ندارید. لطفا از ورود به حساب کاربری اطمینان حاصل نمایید و درصورت پابرجا بودن مشکل با پشتیبانی تماس بگیرید.',
    tooManyRequests: 'تعداد درخواست‌ها زیاد است. لطفا کمی صبر کنید و دوباره تلاش کنید.',
    keyCreateFailed: 'ایجاد کلید API انجام نشد. لطفا دوباره تلاش کنید.',
    keyEditFailed: 'ذخیره تغییرات کلید API انجام نشد. لطفا دوباره تلاش کنید.',
    endpointAccess: 'نقاط دسترسی',
    allowedEndpoints: 'نقاط دسترسی مجاز',
    allowedIntents: 'مقاصد مجاز',
    allEndpointsAllowed: 'تمام نقاط دسترسی‌ها مجاز است',
    allIntentsAllowed: 'تمام مقاصد مجاز است',
    noEndpointsAvailable: 'نقاط دسترسی موجود نیست',
    noIntentsAvailable: 'مقاصد موجود نیست',
    ipFormatHelp: 'فرمت‌های پشتیبانی شده: IPv4 (مثال: 192.168.1.1)، IPv6 و نشانه‌گذاری CIDR (مثال: 192.168.1.0/24)',
    invalidCIDRFormat: 'فرمت CIDR نامعتبر',
    invalidCIDRRange: 'محدوده CIDR نامعتبر (0-128)',
    invalidIPv4CIDRRange: 'محدوده CIDR برای IPv4 نامعتبر (0-32)',
    invalidIPv4Address: 'آدرس IPv4 نامعتبر',
    invalidIPv6Address: 'آدرس IPv6 نامعتبر',
    ipExamples: 'مثال‌ها',
    max256IpsWarning: 'حداکثر تا ۲۵۶ عدد آی‌پی مجاز است، تعدادی نادیده گرفته شد',
    noUsage: 'ندارد',
    budgetUsed: 'مصرف',
    keyModified: 'کلید با موفقیت ویرایش شد',
    apiV4RangeNumebrs: 'آدرس آی‌پی باید بین ۰ تا ۲۵۵ باشد',
    noModelsAvailable: 'لیست مدل‌‌ها در دسترس نیست',
    allModelsAllowed: 'برای دسترسی به تمامی مدل‌ها این قسمت را خالی بگذارید',
    allowedModels: 'مدل‌های مجاز',
    forever: 'همیشه',
    keyExpirationDay: 'مدت زمان اعتبار (روز)',
    iPRestrictions: 'محدودیت‌های دسترسی IP',
    pleaseEnterValidIp: 'آدرس را بصورت صحیح وارد نمایید',
    neverExpires: 'هیچ وقت',
    keyExpiration: 'تاریخ انقضا',
    totalBudget: 'بودجه کل (واحد)',
    noLimit: 'بدون محدودیت',
    monthlyBudget: 'بودجه ماهانه (واحد)',
    usageLimits: 'محدودیت‌های استفاده',
    ipAddressInfoFooter:
      'برای لغو محدودیت دسترسی IP، لیست را خالی بگذارید، درصورت تمایل به ایجاد محدودیت، آدرس IPv4 یا IPv6 و یا CIDR را وارد نمایید.',
    enterIpAddress: 'آدرس IP را وارد نمایید',
    uploadIpTips: 'بارگذاری .txt یا .csv',
    importIPs: 'درون ریزی IP ها',
    securitySettings: 'تنظیمات امنیتی',
    advancedSettings: 'تنظیمات پیشرفته',
    deleteAllIps: 'حذف تمام IP ها',
    shortDesc1: 'مدیریت ایمن کلید‌های دسترسی به سرویس‌های API',
    noName: 'بدون نام',
    showOnce: 'کلید خصوصی تنها همین یک مرتبه نمایش داده میشود، لطفا قبل از بستن صفحه آن را ذخیره نمایید.',
    close: 'بازگشت',
    api: 'API',
    confirmRevoke: 'کلید حذف شود؟',
    removeConfirmYes: 'حذف کن',
    removeConfirmNo: 'منصرف شدم',
    remove: 'حذف',
    edit: 'ویرایش',
    update: 'بروزرسانی',
    guardrail: {
      performanceImpact: 'تاثیر بر عملکرد',
      howActivated: 'روش‌های فعال‌سازی گاردریل',
      recommendation: 'توصیه ما',
      futureDevelopment: 'برنامه‌های توسعه آینده',
      securityNotice: 'هشدارهای امنیتی',

      // Recommendation section
      recommended: 'توصیه شده',
      recommendationDesc:
        'ما قویا فعال‌سازی گاردریل‌ها را برای افزایش امنیت توصیه می‌کنیم. اگرچه این ویژگی تاخیر کمی اضافه می‌کند، اما محافظتی که ارائه می‌دهد برای اکثر کاربردها ارزشمند است. با این حال، اگر برنامه شما نیاز به حداقل تاخیر دارد و از نحوه مدیریت داده‌های خود اطمینان دارید، می‌توانید این ویژگی را غیرفعال کنید.',

      // Performance impact section
      latencyImpact:
        'فعال‌سازی گاردریل‌ها یک مرحله پیش‌پردازش اضافه می‌کند که بسته به حجم و پیچیدگی داده‌های ورودی، تاخیر درخواست را حدود ۲۰۰ تا ۳۰۰۰ میلی‌ثانیه افزایش می‌دهد.',
      latencyTooltip: 'تاثیر تاخیر بر اساس اندازه و پیچیدگی درخواست متغیر است',
      disableForLowLatency:
        'اگر برنامه شما نیاز به حداقل تاخیر دارد و اطمینان دارید که هیچ داده حساسی ارسال نمی‌شود، می‌توانید این ویژگی را برای کاهش سربار غیرفعال کنید.',

      detectSecrets: 'detect-secrets',
      title: 'تنظیمات گاردریل',
      description: 'محافظت از درخواست‌های API با سیستم گاردریل',
      enabled: 'گاردریل فعال است',
      disabled: 'گاردریل غیرفعال است',
      explanation: 'توضیحات گاردریل',
      explanationTitle: 'نحوه محافظت گاردریل‌ها',
      explanationContent:
        'گاردریل‌ها از درخواست‌های API شما با شناسایی و پاکسازی اطلاعات حساس مانند کلیدهای API و توکن‌ها محافظت می‌کنند. هنگامی که این سیستم فعال باشد، تمامی درخواست‌های API پیش از رسیدن به مدل‌های LLM، توسط سیستم detect-secrets بررسی شده و اطلاعات حساس با عبارت [REDACTED] جایگزین می‌شوند.',

      currentImplementation: 'پیاده‌سازی فعلی',
      implementationDetails:
        'در حال حاضر، سیستم گاردریل ما از <strong>{0}</strong> بهره می‌برد که بر مبنای پروژه متن‌باز <a href="{1}" target="_blank" rel="noopener">Yelp/detect-secrets</a> طراحی شده است. این سیستم برای شناسایی و پاکسازی داده‌های حساس مانند کلیدهای API و توکن‌ها در درخواست‌های شما استفاده می‌شود.',
      redactionProcess:
        'زمانی که گاردریل اطلاعات حساس را تشخیص می‌دهد، به صورت خودکار آن‌ها را با عبارت <code>[REDACTED]</code> جایگزین می‌کند. این فرآیند پیش از رسیدن درخواست به مدل‌های LLM انجام می‌شود و هیچ اثری از داده‌های حساس باقی نمی‌گذارد، که این امر لایه امنیتی اضافی برای محافظت از اطلاعات شما فراهم می‌کند.',

      userLevelTitle: 'فعال‌سازی در سطح حساب کاربری',
      userLevelDesc:
        'با فعال‌سازی گاردریل در تنظیمات حساب کاربری، تمامی درخواست‌های API شما به طور خودکار اسکن و محافظت خواهند شد',
      perRequestTitle: 'فعال‌سازی برای درخواست‌های خاص',
      perRequestDesc:
        'با قرار دادن <code>guardrails: ["hide-secrets"]</code> در داده‌های درخواست API، می‌توانید گاردریل را برای همان درخواست فعال کنید، حتی اگر در تنظیمات حساب کاربری غیرفعال باشد',

      futureDesc:
        'در حال حاضر، امکان تعریف گاردریل‌های سفارشی برای کاربران وجود ندارد. با این حال، ما در نظر داریم در به‌روزرسانی‌های آینده، این سیستم را با ویژگی‌های امنیتی پیشرفته‌تر و گزینه‌های شخصی‌سازی بیشتر، ارتقا دهیم.',

      securityDesc:
        'هرچند سیستم گاردریل یک لایه امنیتی اضافی برای محافظت از داده‌های شما فراهم می‌کند، اما تضمینی برای شناسایی تمامی اطلاعات حساس وجود ندارد. کارایی این سیستم به قابلیت‌های پروژه detect-secrets بستگی دارد. توصیه می‌کنیم همچنان اصول امنیتی را رعایت کرده و تا حد امکان، از ارسال اطلاعات حساس در درخواست‌های API خود خودداری نمایید.'
    },
    editSecretKey: 'ویراش کلید API',
    editingSecretKey: 'در حال ویراش کلید API',
    cancel: 'لغو',
    createNewSecret: 'ایجاد کلید جدید',
    cName: 'نام',
    cSecret: 'کلید رمز',
    cCreated: 'تاریخ ایجاد',
    cLastUsed: 'آخرین استفاده',
    cActions: 'عملیات',
    title: 'کلید‌های دسترسی API',
    editKey: 'ویرایش کلید',
    createKey: 'ساخت کلید API',
    keyName: 'نام',
    keyNamePlaceholder: 'کلید آزمایشی',
    createNewKey: 'ایجاد کلید جدید',
    maskedKeysShown: 'کلیدهای API رمز شده شما در زیر فهرست شده اند.',
    howToUse1:
      'برای استفاده در بسته‌های رسمی OpenAI کافیست base_url را به مقدار https://api.avalai.ir/v1 تنظیم نمایید. ',
    howToUse2: 'راهنمای استفاده از کلید‌های API پلتفرم AvalAI',
    konid: 'مراجعه کنید.',
    info2:
      'کلید API خود را با دیگران به اشتراک نگذارید، برای حفظ امنیت، کلید‌های جدید تنها یک مرتبه نمایش داده می‌شوند.',
    howToUse3:
      'از کتابخانه‌ها/چهارچوب‌های رسمی OpenAI استفاده کنید، یا در صورت استفاده از درخواست‌های HTTP، ساختار OpenAI را رعایت نمایید.',
    propagatingKey: 'در حال انتشار در شبکه',
    propagationMessage: 'کلید API در حال انتشار در شبکه است، معمولا کمتر از ۳۰ ثانیه طول می کشد.',
    propagationStatus: 'همگام سازی در شبکه ...'
  },
  summary: {
    requests: 'فراخوانی‌ها',
    noUsageDataTooltip: 'هیچ داده‌ای برای نمایش موجود نیست. به محض ثبت داده‌ها، در اینجا نمایش داده خواهند شد',
    remainingCredit: 'اعتبار باقی‌مانده',
    totalTokens: 'مجموع توکن‌ها',
    totalRequests: 'مجموع درخواست‌ها',
    remainingCreditUnit: 'باقی‌مانده (واحد)',
    remainingCreditIrt: 'باقی‌مانده (تومان)',
    usageTrends: 'روند مصرف',
    last7Days: '۷ روز گذشته',
    last28Days: '۲۸ روز گذشته',
    modelTokenDistribution: 'توزیع توکن مدل',
    dailyRequests: 'درخواست‌های روزانه',
    topModelsUsage: 'مدل‌های پر استفاده',
    hourlyUsageTokens: 'میزان توکن ساعتی',
    hourlyUsageRequests: 'درخواست‌های ساعتی',
    period1Hour: 'ساعت گذشته',
    period6Hours: '۶ ساعت گذشته',
    period12Hours: '۱۲ ساعت گذشته',
    period24Hours: '۲۴ ساعت گذشته',
    cost: 'هزینه',
    inputTokens: 'توکن‌های ورودی',
    outputTokens: 'توکن‌های خروجی',
    activeGrants: 'گرنت‌های فعال',
    expiresIn: 'منقضی می‌شود تا',
    days: 'روز دیگر',
    recentTransactions: 'تراکنش‌های اخیر',
    currency: 'واحد پول',
    modelTokenUsage: 'استفاده توکن مدل',
    last1Hour: '۱ ساعت گذشته',
    last6Hours: '۶ ساعت گذشته',
    last12Hours: '۱۲ ساعت گذشته',
    last24Hours: '۲۴ ساعت گذشته',
    dailyTrendNotAvailable: 'نمودار روند مصرف روزانه برای دوره‌های ۷ روزه و ۲۸ روزه در دسترس است.',
    totalCost: 'هزینه کل'
  },
  error: { fetchFailed: 'دریافت ناموفق بود' },
  system: {
    title: 'AvalAI'
  },
  common: {
    to: 'به',
    input: 'ورودی',
    output: 'خروجی',
    remainingTime: 'زمان باقی مانده',
    at: 'در',
    allTiers: 'تمام سطوح',
    allModels: 'تمام مدل‌ها',
    outof: 'از',
    days: 'روز',
    hours: 'ساعت',
    minutes: 'دقیقه',
    moreItems: 'مورد دیگر',
    tiers: 'سطوح دسترسی',
    models: 'مدل‌',
    discountOff: 'ارزان‌تر',
    discount: 'تخفیف',
    fetchFailed: 'دریافت اطلاعات ناموفق بود',
    sort: 'مرتب‌سازی',
    tier: 'سطح',
    copy: 'کپی',
    projectUpdates: 'آخرین تغییرات',
    viewAll: 'مشاهده همه',
    readMore: 'مشاهده',
    loadMore: 'نمایش بیشتر',
    noResults: 'چیزی پیدا نشد',
    resultsFoundInOtherTabs: 'نتیجه در سربرگ‌های دیگر یافت شد',
    noResultsInCurrentTab: 'نتیجه‌ای در این سربرگ پیدا نشد',
    and: 'و',
    additionalPersianOnly: 'دیگر',
    additionalEnglishOnly: '',
    additional: 'دیگر',
    emailAddress: 'آدرس ایمیل',
    phoneNumber: 'شماره تلفن',
    fetchError: 'دریافت اطلاعات با خطا مواجه شد',
    tier1AndAbove: 'سطح ۱ به بالا',
    tier3AndAvove: 'سطح ۳ به بالا',
    tier5Only: 'سطح کاربری ۵',
    requiresTier1: 'این قابلیت در سطح کاربری ۱ به بالا در دسترس است',
    requiresTier3: 'تعریف سطح آستانه سفارشی در سطح کاربری ۳ به بالا در دسترس است',
    requiresTier5: 'تعریف دریافت کنندگان بیشتر، تنها در سطح کاربری ۵ در دسترس است',
    fixErrorsBeforeSaving: 'قبل از ذخیره سازی لطفا خطاها را رفع کنید',
    failedToSaveSettingsTryAgain: 'ذخیره تغییرات با خطا مواجه شد، لطفا دوباره تلاش کنید',
    equivalent: 'معادل',
    manage: 'مدیریت',
    threshold: 'آستانه',
    saveChanges: 'ذخیره تغییرات',
    saving: 'در حال ذخیره',
    phone: 'شماره تلفن',
    email: 'آدرس ایمیل',
    recipients: 'دریافت کنندگان',
    thresholds: 'سطوح آستانه',
    custom: 'سفارشی',
    default: 'پیش فرض',
    retry: 'تلاش مجدد',
    pageLoading: 'در حال بارگذاری صفحه...',
    pageLoadError: 'خطا در بارگذاری صفحه',
    pageLoadErrorDesc: 'هنگام بارگذاری این صفحه خطایی رخ داد. لطفا دوباره تلاش کنید.',
    useInApi: 'استفاده از API',
    seconds: 'ثانیه',
    docs: 'مستندات',
    learnMore: 'بیشتر بیاموزید',
    save: 'ذخیره',
    select: 'انتخاب',
    comingSoon: 'به زودی',
    attach: 'ضمیمه',
    back: 'بازگشت',
    clickToCopy: 'کپی کنید',
    disabled: 'غیرفعال',
    enabled: 'فعال',
    hide: 'مخفی کردن',
    configure: 'تنظیم کردن',
    show: 'نمایش',
    systemStatus: 'وضعیت سرویس',
    page: 'صفحه',
    total: 'تعداد کل',
    showLess: 'نمایش نده',
    showMore: 'نمایش بیشتر',
    // noDataToDownload: 'اطلاعاتی وحود ',
    downloadError: 'بارگذاری با خطا مواجه شد',
    downloadSuccess: 'بارگذاری انجام شد',
    downloadCSV: 'فایل CSV',
    downloadExcel: 'فایل Excel',
    download: 'بارگذاری',
    api: 'API',
    credit: 'اعتبار',
    subscription: 'اشتراک',
    recheck: 'بررسی',
    nothingFound: 'چیزی یافت نشد',
    time: 'زمان',
    date: 'تاریخ',
    somethingWentWrongRefreshPage: 'خطایی رخ داد، لطفا پس از چند لحظه مجدد تلاش کنید',
    shortCuts: 'میانبرها',
    phoneAlreadyVerified: 'شماره تلفن با موفقیت تایید شده، بروزرسانی خودکار صفحه تا چند لحظه دیگر',
    phoneVerificationRequired: 'جهت دسترسی به سرویس‌ها، نیاز به ثبت شماره تلفن است، لطفا شماره تلفن خود را تایید کنید.',
    backToChat: 'صفحه گفتگوها',
    copied: 'کپی شد',
    copyFailed: 'خطایی رخ داد',
    optional: 'اختیاری',
    action: 'عملیات',
    add: 'افزودن',
    addSuccess: 'افزودن با موفقیت انجام شد',
    backToHome: 'بازگشت به خانه',
    batchDelete: 'حذف دسته جمعی',
    cancel: 'لغو',
    close: 'بستن',
    check: 'بررسی',
    columnSetting: 'تنظیمات ستون',
    config: 'پیکربندی',
    confirm: 'تایید',
    delete: 'حذف',
    deleteSuccess: 'حذف با موفقیت انجام شد',
    confirmDelete: 'می خواهید حذف کنید؟',
    edit: 'ویرایش',
    index: 'فهرست',
    keywordSearch: 'لطفا کلیدواژه را وارد کنید',
    logout: 'خروج',
    logoutConfirm: 'می خواهید از حساب کاربری خارج شوید؟',
    lookForward: 'به زودی',
    modify: 'تغییر دادن',
    modifySuccess: 'تغییر با موفقیت انجام شد',
    noData: 'بدون داده',
    operate: 'عملیات',
    pleaseCheckValue: 'لطفا مقدار را بررسی کنید',
    refresh: 'تازه‌سازی',
    reset: 'تنظیم مجدد',
    search: 'جستجو',
    switch: 'تغییر',
    tip: 'نکته',
    trigger: 'رونده',
    update: 'بروزرسانی',
    updateSuccess: 'بروزرسانی با موفقیت انجام شد',
    userCenter: 'مرکز کاربری',
    yesOrNo: {
      yes: 'بله',
      no: 'خیر'
    },
    newsCategories: {
      announcement: 'اعلان',
      api: 'API',
      models: 'مدل‌ها',
      performance: 'عملکرد',
      billing: 'صورتحساب',
      security: 'امنیت',
      feature: 'قابلیت',
      documentation: 'مستندات',
      tutorial: 'آموزش',
      release: 'انتشار'
    },
    next: 'بعدی',
    noUpdates: 'هیچ به‌روزرسانی موجود نیست'
  },
  request: {
    logout: 'کاربر بعد از درخواست ناموفق خارج شود',
    logoutMsg: 'وضعیت کاربر نامعتبر است، لطفا مجددا وارد شوید',
    logoutWithModal: 'پنجره بازشو بعد از درخواست ناموفق ظاهر شود و سپس کاربر خارج شود',
    logoutWithModalMsg: 'وضعیت کاربر نامعتبر است، لطفا مجددا وارد شوید',
    refreshToken: 'توکن درخواست شده منقضی شده است، توکن را تازه کنید',
    tokenExpired: 'توکن درخواست شده منقضی شده است'
  },
  theme: {
    themeSchema: {
      title: 'طرح تم',
      light: 'روشن',
      dark: 'تیره',
      auto: 'بر اساس  سیستم'
    },
    layoutMode: {
      title: 'حالت چیدمان',
      vertical: 'حالت منوی عمودی',
      horizontal: 'حالت منوی افقی',
      'vertical-mix': 'حالت منوی عمودی مخلوط',
      'horizontal-mix': 'حالت منوی افقی مخلوط'
    },
    themeColor: {
      title: 'رنگ تم',
      primary: 'اصلی',
      info: 'اطلاعات',
      success: 'موفقیت',
      warning: 'هشدار',
      error: 'خطا',
      followPrimary: 'دنبال کردن رنگ اصلی'
    },
    scrollMode: {
      title: 'حالت پیمایش',
      wrapper: 'پوشش',
      content: 'محتوا'
    },
    page: {
      animate: 'انیمیشن صفحه',
      mode: {
        title: 'حالت انیمیشن صفحه',
        fade: 'محو شدن',
        'fade-slide': 'کشیدن',
        'fade-bottom': 'محو زوم',
        'fade-scale': 'مقیاس محو',
        'zoom-fade': 'محو زوم',
        'zoom-out': 'زوم خروج',
        none: 'هیچ'
      }
    },
    fixedHeaderAndTab: 'سربرگ و تب ثابت',
    header: {
      height: 'ارتفاع سربرگ',
      breadcrumb: {
        visible: 'نمایش خرده نان',
        showIcon: 'نمایش آیکون خرده نان'
      }
    },
    tab: {
      visible: 'نمایش برگه',
      cache: 'کش برگه',
      height: 'ارتفاع برگه',
      mode: {
        title: 'حالت برگه',
        chrome: 'کروم',
        button: 'دکمه'
      }
    },
    sider: {
      inverted: 'کناری تیره',
      width: 'عرض کناری',
      collapsedWidth: 'عرض کناری فشرده',
      mixWidth: 'عرض کناری مخلوط',
      mixCollapsedWidth: 'عرض کناری فشرده مخلوط',
      mixChildMenuWidth: 'عرض منوی فرزند مخلوط'
    },
    footer: {
      visible: 'پاورقی نمایش داده شده',
      fixed: 'پاورقی ثابت',
      height: 'ارتفاع پاورقی',
      right: 'پاورقی سمت راست'
    },
    themeDrawerTitle: 'پیکربندی تم',
    pageFunTitle: 'کارکرد صفحه',
    configOperation: {
      copyConfig: 'کپی پیکربندی',
      copySuccessMsg: 'کپی موفق، لطفا متغیر themeSettings را در src/theme/settings.ts جایگزین کنید',
      resetConfig: 'تنظیم مجدد پیکربندی',
      resetSuccessMsg: 'تنظیم مجدد موفق'
    }
  },
  sponsorship: {
    common: {
      irt: 'تومان',
      notAvailable: 'ثبت نشده'
    },
    status: {
      draft: 'پیش‌نویس',
      submitted: 'ارسال‌شده',
      under_review: 'در حال بررسی',
      needs_modification: 'نیازمند اصلاح',
      approved: 'تأییدشده',
      rejected: 'ردشده',
      active: 'فعال',
      cooldown: 'دورهٔ انتظار',
      completed: 'تکمیل‌شده',
      withdrawn: 'لغوشده',
      locked: 'قفل',
      available: 'در دسترس',
      in_progress: 'در حال انجام',
      credit_granted: 'اعتبار اعطا شد',
      level_active: 'سطح فعال',
      level_completed: 'سطح تکمیل‌شده',
      next_level_locked: 'سطح بعدی قفل است',
      pending: 'در انتظار',
      passed: 'تأیید شد',
      failed: 'ناموفق',
      manual_override: 'تأیید دستی',
      unknown: 'وضعیت نامشخص',
      applicationSummary: 'خلاصهٔ درخواست',
      title: 'وضعیت درخواست',
      none: 'هنوز درخواستی ثبت نکرده‌اید.',
      cooldownUntil: 'امکان درخواست مجدد از',
      creditUsage: 'مصرف اعتبار',
      grantedAmount: 'مبلغ اعطاشده',
      remaining: 'مانده',
      expiresOn: 'تاریخ انقضا',
      submissions: 'مراحل ارسال‌شده',
      withdraw: 'لغو درخواست',
      withdrawTitle: 'لغو درخواست؟',
      withdrawConfirm:
        'با لغو درخواست فعلی، درخواست شما بسته می‌شود. هر زمان آماده بودید می‌توانید درخواست جدیدی شروع کنید.',
      withdrawSuccess: 'درخواست لغو شد.',
      withdrawFailed: 'لغو درخواست انجام نشد. لطفا دوباره تلاش کنید.',
      startNewApplication: 'شروع درخواست جدید',
      needsModificationTitle: 'نیازمند اصلاح',
      needsModificationHint:
        'تیم بررسی درخواست اصلاح در درخواست شما کرده است. لطفا بازخورد را بررسی و مجددا ارسال کنید.',
      editAndResubmit: 'ویرایش و ارسال مجدد',
      expiresIn: 'انقضا تا',
      daysLeft: '{days} روز باقی‌مانده',
      expired: 'منقضی‌شده',
      consumed: 'مصرف‌شده',
      submittedOn: 'تاریخ ارسال',
      updatedOn: 'آخرین به‌روزرسانی',
      highestLevel: 'بالاترین سطح طی‌شده',
      sectionCompany: 'شرکت',
      sectionRepresentative: 'نمایندهٔ قانونی',
      sectionTimeline: 'زمان‌بندی',
      nextStep: 'گام بعدی',
      narrative: {
        generic:
          'وضعیت درخواست حمایت شما به‌روزرسانی شده است. جزئیات را در ادامه بررسی و گام بعدی موجود را دنبال کنید.',
        draft: 'درخواست شما پیش‌نویس است. مراحل باقی‌مانده را تکمیل و برای بررسی ارسال کنید.',
        submitted: 'درخواست شما ارسال شد. تیم AvalAI به‌زودی آن را بررسی می‌کند.',
        under_review: 'تیم AvalAI در حال بررسی درخواست شماست. پس از هر به‌روزرسانی به شما اطلاع می‌دهیم.',
        needs_modification: 'تیم بررسی درخواست اصلاح کرده است. موارد مشخص‌شده را به‌روزرسانی و مجددا ارسال کنید.',
        approved: 'درخواست شما تأیید شد. اعتبار حمایتی شما در حال فعال‌سازی است.',
        credit_granted: 'اعتبار حمایتی شما اعطا شده و آمادهٔ استفاده است.',
        rejected: 'این درخواست تأیید نشد. پس از دورهٔ انتظار می‌توانید مجددا درخواست دهید.',
        active: 'حمایت شما فعال است. مصرف اعتبار و پیشرفت سطوح خود را در ادامه دنبال کنید.',
        level_active: 'سطح حمایتی شما فعال است. مصرف اعتبار و پیشرفت سطوح خود را در ادامه دنبال کنید.',
        cooldown: 'در دورهٔ انتظار هستید. پس از پایان آن می‌توانید مجددا درخواست دهید.',
        completed:
          'برنامهٔ حمایت را تکمیل کرده‌اید. اگر می‌خواهید دوباره اقدام کنید، می‌توانید درخواست جدیدی شروع کنید.',
        level_completed: 'این سطح را تکمیل کردید. برای ادامه، الزامات سطح بعدی را بررسی کنید.',
        next_level_locked: 'سطح حمایتی بعدی تا تکمیل مراحل لازم قفل می‌ماند.',
        withdrawn: 'این درخواست را لغو کردید. هر زمان آماده بودید می‌توانید درخواست جدیدی شروع کنید.'
      }
    },
    levels: {
      journeyTitle: 'نمای کلی سطوح',
      journeyLead: 'هر سطح حمایت، الزامات آن و وضعیت باز شدن سطح برای شما را مرور کنید.',
      levelOf: 'سطح {level} از {total}',
      stepsProgress: '{done}/{total} مرحله انجام شد',
      currentLevel: 'شما اینجا هستید',
      locked: 'قفل',
      unlockAfter: 'پس از کامل‌شدن سطح {level} باز می‌شود',
      autoUnlock: 'با کامل‌شدن سطح قبلی، به‌صورت خودکار باز می‌شود',
      manualReview: 'بررسی AvalAI',
      manualReviewHint: 'بررسی و تأیید توسط تیم AvalAI',
      awaitingReview: 'در انتظار بررسی AvalAI',
      needsModificationHint: 'اصلاحات درخواست شده است. بازخورد را بررسی و این سطح را دوباره ارسال کنید.',
      approvedHint: 'تأیید شد. اعتبار این سطح در حال آماده‌سازی است.',
      rejectedHint: 'این سطح رد شد. پیش از درخواست دوباره، بازخورد را بررسی کنید.',
      completed: 'تکمیل‌شده',
      completionReasons: {
        exhausted: 'اعتبار مصرف شد',
        expired: 'بسته منقضی شد',
        manual: 'تکمیل دستی'
      },
      requiredStep: 'الزامی',
      optionalStep: 'اختیاری',
      reviewerNotes: 'یادداشت‌های بررسی‌کننده',
      documentUploadDeferred:
        'بارگذاری مدرک هنوز در این بخش فعال نیست. AvalAI مدارک پشتیبان را هنگام بررسی دستی درخواست می‌کند.',
      previewSteps: 'مشاهده شرط‌ها',
      hideSteps: 'پنهان‌کردن شرط‌ها',
      noProgress: 'برای شروع مسیر سطح‌ها، درخواست دهید.'
    },
    levelNames: {
      '1': 'سطح ۱ — شروع',
      '2': 'سطح ۲ — تأیید محصول',
      '3': 'سطح ۳ — MVP / بازار',
      '4': 'سطح ۴ — رشد اثبات‌شده',
      '5': 'سطح ۵ — مقیاس'
    },
    levelDescriptions: {
      '1': 'اعتبار آغازین شما. اطلاعات شرکت را ثبت و نمایندهٔ قانونی را تأیید کنید تا فعال شود.',
      '2': 'پس از مصرف یا انقضای اعتبار سطح ۱ باز می‌شود. نمایشی از محصول ارائه دهید تا محصول شما تأیید شود.',
      '3': 'برای استارتاپ‌های در مرحلهٔ MVP یا حاضر در بازار. AvalAI حضور در بازار و نشانه‌های جذب کاربر را پیش از تأیید بررسی می‌کند.',
      '4': 'برای استارتاپ‌هایی با رشد قابل مشاهده. AvalAI نشانه‌های رشد و جذب کاربر را پیش از تأیید بررسی می‌کند.',
      '5': 'برای استارتاپ‌های دارای درآمد و تناسب محصول-بازار. نیازمند بررسی نهایی دستی توسط تیم AvalAI است.'
    },
    stepDescriptions: {
      company_form: 'اطلاعات شرکت ثبت‌شدهٔ خود را ارائه دهید.',
      identity_check: 'نمایندهٔ قانونی کد ملی و شمارهٔ تماس خود را برای تأیید ارائه می‌کند.',
      product_demo:
        'وقتی AvalAI بررسی این سطح را درخواست کرد، لینک نمایش محصول یا توضیح کوتاهی دربارهٔ محصول خود ثبت کنید.',
      market_evidence: 'خلاصه‌ای از MVP یا حضور در بازار را برای بررسی AvalAI ثبت کنید.',
      traction_docs: 'خلاصه‌ای از رشد و جذب کاربر را برای بررسی AvalAI ثبت کنید.',
      revenue_proof: 'خلاصه‌ای از درآمد و نشانه‌های تناسب محصول-بازار را برای بررسی AvalAI ثبت کنید.',
      manual_review: 'بررسی نهایی دستی توسط تیم AvalAI.'
    },
    steps: {
      company_form: 'اطلاعات شرکت',
      identity_check: 'تأیید هویت',
      product_demo: 'نمایش محصول',
      market_evidence: 'بازار و جذب کاربر',
      traction_docs: 'بررسی رشد',
      revenue_proof: 'بررسی درآمد و تناسب محصول-بازار',
      manual_review: 'بررسی دستی'
    },
    apply: {
      title: 'ثبت‌نام در برنامهٔ حمایت از استارتاپ‌ها',
      introLead:
        'برای استارتاپ خود اعتبار API دریافت کنید. یک فرم کوتاه را تکمیل کنید؛ با رشد شما سطوح بالاتر باز می‌شوند.',
      start: 'شروع درخواست',
      stepIntro: 'معرفی',
      stepAuth: 'تأیید شماره',
      stepCompany: 'شرکت',
      stepIdentity: 'هویت',
      stepReview: 'بازبینی',
      verifyIdentity: 'تأیید هویت',
      editIdentity: 'ویرایش اطلاعات هویتی',
      reviewLead: 'اطلاعات خود را بازبینی و سپس برای بررسی ارسال کنید.',
      submit: 'ارسال درخواست',
      submitted: 'درخواست برای بررسی ارسال شد.',
      saveFailed: 'ذخیره اطلاعات انجام نشد. لطفا دوباره تلاش کنید.',
      stepFailed: 'ثبت این مرحله با خطا مواجه شد. لطفا دوباره تلاش کنید.',
      fixFieldErrors: 'لطفا فیلدهای مشخص‌شده را اصلاح کنید.',
      onFile: 'قبلا ثبت شده — برای حفظ مقدار خالی بگذارید',
      loadFailed: 'بارگذاری برنامه با خطا مواجه شد. لطفا دوباره تلاش کنید.',
      loadDescription: 'آخرین اطلاعات حمایت بارگذاری نشد. لطفا پیش از ادامه دوباره تلاش کنید.',
      serverLoadFailed:
        'سرویس حمایت در حال حاضر در دسترس نیست. لطفا کمی بعد دوباره تلاش کنید یا در صورت ادامه مشکل با پشتیبانی تماس بگیرید.',
      rateLimited: 'در مدت کوتاه درخواست‌های زیادی برای بخش حمایت ارسال شده است. لطفا چند لحظه بعد دوباره تلاش کنید.',
      retry: 'تلاش مجدد',
      reset: 'پاک‌کردن فرم',
      resetTitle: 'فرم پاک شود؟',
      resetConfirm: 'اطلاعات شرکت و هویتی که وارد کرده‌اید پاک می‌شود. این عمل قابل بازگشت نیست.',
      draftRestored: 'اطلاعات ذخیره‌شدهٔ شما بازیابی شد.',
      draftSaved: 'ذخیره شد'
    },
    fields: {
      companyName: 'نام شرکت',
      companyRegisterId: 'شناسهٔ ثبت شرکت',
      companyNationalId: 'شناسهٔ ملی شرکت',
      website: 'وب‌سایت',
      domain: 'دامنه',
      legalRepName: 'نام نمایندهٔ قانونی',
      legalRepNationalId: 'کد ملی نمایندهٔ قانونی',
      contactPhone: 'تلفن تماس',
      verification: 'تأیید هویت'
    },
    validation: {
      required: '{field} الزامی است.',
      companyNationalId: 'شناسهٔ ملی شرکت باید ۱۱ رقم باشد.',
      website: 'یک آدرس وب‌سایت HTTPS معتبر وارد کنید.',
      domain: 'نام دامنه را بدون پروتکل و به‌صورت معتبر وارد کنید.',
      legalRepNationalId: 'یک کد ملی معتبر وارد کنید.',
      contactPhone: 'یک شماره موبایل معتبر وارد کنید.'
    },
    auth: {
      phoneHint:
        'شماره تلفن خود را وارد کنید؛ کد تأیید ارسال می‌شود. در صورت نبود حساب، به‌صورت خودکار حساب ساخته می‌شود.',
      phoneInputLabel: 'شماره تلفن',
      codeInputLabel: 'کد تأیید',
      sendCode: 'ارسال کد',
      resend: 'ارسال مجدد کد',
      resendIn: 'ارسال مجدد در {time} ثانیه',
      verifyAndContinue: 'تأیید و ادامه',
      codeSent: 'کد تأیید ارسال شد.',
      applyingAs: 'ثبت‌نام با شمارهٔ {phone}',
      continue: 'ادامه',
      useDifferentNumber: 'استفاده از شمارهٔ دیگر',
      welcomeNew: 'خوش آمدید! حساب شما ساخته شد.',
      welcomeBack: 'خوش بازگشتید!',
      codeInvalid: 'کد نامعتبر یا منقضی شده است.',
      sendFailed: 'ارسال کد ناموفق بود. دوباره تلاش کنید.',
      tooManyRequests: 'درخواست‌های زیاد. کمی بعد دوباره تلاش کنید.',
      forbidden: 'این عملیات مجاز نیست.',
      userNotFound: 'حسابی برای این شماره یافت نشد.',
      phoneConflict: 'این شماره قبلا به حساب دیگری متصل شده است.'
    },
    verification: {
      pendingTitle: 'تأیید هویت در حال انجام است',
      pendingHint: 'تأیید هویت در حال انجام است. پس از تکمیل، درخواست شما به‌روزرسانی می‌شود.',
      passedHint: 'هویت شما تأیید شد.',
      failedHint: 'تأیید هویت ناموفق بود. لطفا اطلاعات را بررسی و دوباره تلاش کنید.',
      manual_overrideHint: 'هویت شما توسط تیم بررسی AvalAI تأیید شد.',
      stillPending:
        'تأیید هنوز در حال انجام است. می‌توانید این صفحه را ترک کنید؛ وضعیت به‌صورت خودکار به‌روزرسانی می‌شود.'
    },
    hub: {
      memberTitle: 'حمایت شما',
      memberLead: 'مزایا، مصرف اعتبار و پیشرفت سطح خود را دنبال کنید.',
      prospectTitle: 'استارتاپ خود را با اعتبار حمایتی API رشد دهید',
      prospectLead:
        'با پیوستن به برنامهٔ حمایت از استارتاپ‌ها، همگام با رشد شرکت خود در پنج سطح اعتبار API دریافت کنید.',
      pendingTitle: 'درخواست شما در حال بررسی است',
      pendingLead: 'شما را در جریان می‌گذاریم. می‌توانید درخواست خود را در ادامه بررسی یا تکمیل کنید.',
      nextLevelActionTitle: 'سطح بعدی شما آماده است',
      nextLevelActionLead: 'الزامات سطح تازه بازشده را از مسیر سطح‌ها تکمیل کنید.',
      currentLevel: 'سطح فعلی',
      yourBenefits: 'مزایای شما',
      benefitCredit: 'اعتبار حمایتی API برای استارتاپ شما',
      benefitModels: 'دسترسی به مدل‌های هوش مصنوعی ویژه',
      benefitSupport: 'پشتیبانی اولویت‌دار',
      benefitGrowth: 'با رشد شما سطوح بالاتر باز می‌شوند',
      nextLevel: 'سطح بعدی',
      nextLevelHint: 'برای باز شدن سطح بعد، سطح فعلی را کامل کنید.',
      viewStatus: 'مشاهدهٔ وضعیت',
      viewLevels: 'مشاهدهٔ سطوح',
      continueApplication: 'ادامهٔ درخواست',
      continueLevelJourney: 'ادامهٔ مسیر سطح',
      applyNow: 'همین حالا درخواست دهید',
      plansTitle: 'طرح‌های حمایت استارتاپی',
      plansLead: 'پنج سطح اعتبار API که همگام با رشد استارتاپ شما باز می‌شوند.',
      howItWorks: 'چطور کار می‌کند',
      step1Title: 'درخواست',
      step1Desc: 'شماره خود را تأیید و اطلاعات شرکت را در یک فرم کوتاه ارسال کنید.',
      step2Title: 'تأیید',
      step2Desc: 'هویت شما را تأیید و درخواستتان را بررسی می‌کنیم.',
      step3Title: 'دریافت اعتبار',
      step3Desc: 'پس از تأیید، اعتبار حمایتی به حساب شما اعطا می‌شود.',
      step4Title: 'رشد و ارتقا',
      step4Desc: 'از اعتبار خود استفاده کنید؛ با تحقق اهداف، سطوح بالاتر باز می‌شوند.',
      eligibilityTitle: 'چه کسانی می‌توانند درخواست دهند',
      eligibilityItem1: 'استارتاپ‌های ثبت‌شده در داخل کشور',
      eligibilityItem2: 'هویت قابل‌تأیید نمایندهٔ قانونی',
      eligibilityItem3: 'محصول یا MVP برای سطوح بالاتر',
      cooldownNotice: 'پس از پایان دورهٔ انتظار می‌توانید مجددا درخواست دهید.',
      programFallbackNotice:
        'دادهٔ زندهٔ برنامه موقتا در دسترس نیست. همچنان می‌توانید سطوح حمایت را ببینید؛ پیش از ارسال درخواست دوباره تلاش کنید.',
      badge: 'برنامهٔ حمایت از استارتاپ‌ها',
      heroStatCredit: '۱۰۰M+',
      heroStatCreditLabel: 'تومان اعتبار',
      heroStatLevels: '۵',
      heroStatLevelsLabel: 'سطح رشد',
      heroStatFree: '۰',
      heroStatFreeLabel: 'هزینهٔ اولیه',
      secondaryCta: 'مشاهدهٔ طرح‌ها',
      planLevel: 'سطح {level}',
      planUpTo: 'تا',
      planSelect: 'شروع کنید',
      ctaBandTitle: 'آمادهٔ شتاب‌دهی به استارتاپتان هستید؟',
      ctaBandSubtitle:
        'در چند دقیقه درخواست دهید. شماره را تأیید کنید، اطلاعات شرکت را وارد کنید و نخستین اعتبار خود را دریافت کنید.',
      trustLine: 'بدون کارت بانکی. بدون هزینهٔ اولیه. اعتبار پس از تأیید اعطا می‌شود.',
      faqTitle: 'پرسش‌های پرتکرار',
      faq1Q: 'هزینهٔ آن چقدر است؟',
      faq1A: 'هیچ هزینهٔ اولیه‌ای ندارد. اعتبار حمایتی به‌صورت رایگان به استارتاپ‌های تأییدشده اعطا می‌شود.',
      faq2Q: 'چگونه به سطح بالاتر می‌روم؟',
      faq2A: 'با مصرف اعتبار فعلی و اثبات اهدافی مانند نمایش محصول، جذب کاربر یا درآمد، سطوح بالاتر باز می‌شوند.',
      faq3Q: 'تأیید چقدر طول می‌کشد؟',
      faq3A: 'پس از ارسال، تیم ما درخواست شما را بررسی و نتیجه را اعلام می‌کند.'
    }
  },

  modelStudio: {
    title: 'استودیو مدل',
    subtitle: 'چت، چندرسانه‌ای، ابزارها، خروجی ساختاریافته و کد آماده را آزمایش کنید.',
    overviewTitle: 'نمای کلی',
    overviewSubtitle: 'کار اخیر را ادامه دهید یا یک کار متمرکز مدل آغاز کنید.',
    overviewConnectionTitle: 'راه‌اندازی اتصال',
    overviewConnectionDescription:
      'هر زمان آماده اجرا بودید، در محیط آزمایش یک کلید انتخاب یا ایجاد کنید.',
    overviewConnectionAction: 'باز کردن محیط آزمایش',
    overviewResumeEyebrow: 'ادامه از آخرین فعالیت',
    overviewResumeWorkflowDescription: 'گردش‌کار ذخیره‌شده',
    overviewResumeRequestDescription: 'درخواست ثبت‌شده',
    overviewResumeEmptyTitle: 'نخستین اجرا را آغاز کنید',
    overviewResumeEmptyDescription: 'برای ساخت و اجرای درخواست مدل، محیط آزمایش را باز کنید.',
    overviewStartFirstRun: 'شروع در محیط آزمایش',
    overviewQuickActions: 'شروع سریع',
    overviewOpenPlayground: 'باز کردن محیط آزمایش',
    overviewOpenPlaygroundDescription: 'با وضعیت محلی فعلی استودیو ادامه دهید.',
    overviewBrowsePrompts: 'مرور پرامپت‌ها',
    overviewBrowsePromptsDescription: 'پیکربندی‌های ذخیره‌شده و تنظیمات قابل استفاده مجدد را باز کنید.',
    overviewCompareModels: 'مقایسه مدل‌ها',
    overviewCompareModelsDescription: 'یک پرامپت را با دو مدل ارزیابی کنید.',
    overviewCreateWorkflow: 'ساخت گردش‌کار',
    overviewCreateWorkflowDescription: 'یک پیکربندی خالی و قابل استفاده مجدد آغاز کنید.',
    overviewRecentWorkflows: 'گردش‌کارهای اخیر',
    overviewRecentRequests: 'درخواست‌های اخیر',
    overviewViewAll: 'مشاهده همه',
    overviewNoWorkflows: 'هنوز گردش‌کاری ذخیره نشده است.',
    overviewNoRequests: 'هنوز درخواستی ثبت نشده است.',
    overviewOpenWorkflow: 'باز کردن گردش‌کار: {name}',
    overviewInspectRequest: 'بررسی درخواست: {name}',
    overviewTokens: '{count} توکن',
    overviewLatency: '{count} میلی‌ثانیه',
    promptsTitle: 'کتابخانه پرامپت‌ها',
    promptsSubtitle:
      'پیکربندی‌های کامل محیط آزمایش را ذخیره، سازمان‌دهی و دوباره استفاده کنید.',
    promptsEmptyTitle: 'کتابخانه پرامپت خود را بسازید',
    promptsEmptyDescription:
      'یک پیکربندی قابل استفاده مجدد از محیط آزمایش ذخیره کنید یا اینجا پرامپت بسازید.',
    createPrompt: 'ساخت پرامپت',
    openPlayground: 'باز کردن محیط آزمایش',
    browsePrompts: 'مرور پرامپت‌ها',
    promptBack: 'بازگشت',
    promptSearchPlaceholder: 'جستجوی پرامپت‌ها',
    promptClearFilters: 'پاک کردن فیلترها',
    promptsFilteredEmpty: 'پرامپتی با این فیلترها پیدا نشد.',
    promptMode: 'حالت',
    promptModel: 'مدل',
    promptName: 'نام',
    promptDescription: 'توضیحات',
    promptTags: 'برچسب‌ها',
    promptPin: 'سنجاق کردن پرامپت',
    promptUnpin: 'برداشتن سنجاق پرامپت',
    promptDuplicate: 'تکثیر پرامپت',
    promptDelete: 'حذف پرامپت',
    promptOpenInPlayground: 'باز کردن در محیط آزمایش',
    promptActions: 'عملیات پرامپت',
    promptStatusDirty: 'تغییرات ذخیره‌نشده',
    promptStatusClean: 'بدون تغییر',
    promptStatusNew: 'پرامپت جدید',
    promptStatusSaved: 'پرامپت ذخیره‌شده',
    promptRequiresReattachment: 'فایل لازم است',
    promptNameRequired: 'نام پرامپت را وارد کنید.',
    promptNameTooLong: 'حداکثر ۶۰ نویسه وارد کنید.',
    promptNameDuplicate: 'یک پرامپت ذخیره‌شده از این نام استفاده می‌کند.',
    promptDescriptionTooLong: 'حداکثر ۲۴۰ نویسه وارد کنید.',
    promptTooManyTags: 'حداکثر هشت برچسب وارد کنید.',
    promptTagTooLong: 'هر برچسب باید حداکثر ۲۴ نویسه باشد.',
    promptUpdate: 'به‌روزرسانی پرامپت',
    promptSaveAsNew: 'ذخیره به‌عنوان مورد جدید',
    promptSaveToLibrary: 'ذخیره در کتابخانه',
    promptSaveDialogTitle: 'ذخیره پرامپت در کتابخانه',
    promptSaveAsNewDialogTitle: 'ذخیره پرامپت به‌عنوان مورد جدید',
    promptPersistenceUnavailable: 'فضای ذخیره‌سازی پرامپت در دسترس نیست.',
    promptHandoffNotFound: 'آن پرامپت ذخیره‌شده دیگر در دسترس نیست.',
    promptLoaded: 'پرامپت {name} به‌عنوان نسخه کاری بارگذاری شد.',
    promptReattachFile: 'پیوست دوباره فایل',
    promptAudioReattachmentHelp: 'پیش از اجرای پرامپت صوتی، این فایل را دوباره انتخاب کنید.',
    promptListLabel: 'پرامپت‌های ذخیره‌شده',
    promptSelectLabel: 'ویرایش پرامپت: {name}',
    promptEditorNewTitle: 'ساخت پرامپت',
    promptEditorSavedTitle: 'ویرایش پرامپت',
    promptStorageReadOnly:
      'فضای ذخیره‌سازی مرورگر در دسترس نیست. می‌توانید پرامپت را بررسی یا باز کنید، اما تغییرات ذخیره نمی‌شوند.',
    promptConfiguration: 'پیکربندی پرامپت',
    promptSystemPrompt: 'پرامپت سامانه',
    promptMessages: 'پیام‌ها',
    promptMessageRole: 'نقش پیام',
    promptMessageContent: 'محتوای پیام',
    promptAddMessage: 'افزودن پیام',
    promptRemoveMessage: 'حذف پیام',
    promptVariables: 'متغیرها',
    promptAddVariable: 'افزودن متغیر',
    promptRemoveVariable: 'حذف متغیر',
    promptOutputFormat: 'قالب خروجی',
    promptFunctions: 'تعریف توابع',
    promptAddFunction: 'افزودن تابع',
    promptRemoveFunction: 'حذف تابع',
    promptMcpServers: 'تعریف سرورهای MCP',
    promptAddMcpServer: 'افزودن سرور MCP',
    promptRemoveMcpServer: 'حذف سرور MCP',
    promptAttachmentPlaceholder: 'پیش از اجرای این پرامپت، فایل‌های ذخیره‌شده را دوباره پیوست کنید.',
    promptAudioFilePlaceholder: 'پیش از اجرای این پرامپت صوتی، {name} را دوباره پیوست کنید.',
    promptRoleSystem: 'سامانه',
    promptRoleUser: 'کاربر',
    promptRoleAssistant: 'دستیار',
    promptRoleDeveloper: 'توسعه‌دهنده',
    promptUnsavedTitle: 'تغییرات ذخیره‌نشده کنار گذاشته شوند؟',
    promptUnsavedDescription: 'با ادامه دادن، تغییرات این ویرایشگر پرامپت از بین می‌روند.',
    promptDiscardChanges: 'کنار گذاشتن تغییرات',
    promptDeleteTitle: 'پرامپت حذف شود؟',
    promptDeleteDescription: 'پرامپت {name} حذف شود؟ این کار قابل بازگشت نیست.',
    promptDeleteConfirm: 'حذف پرامپت',
    promptMalformedTitle: 'برخی پرامپت‌ها قابل خواندن نبودند',
    promptMalformedDescription: '{count} رکورد نامعتبر بدون تغییر نگه داشته شد.',
    promptStorageUnsupportedTitle: 'داده پرامپت مربوط به نسخه جدیدتری است',
    promptStorageUnsupportedDescription:
      'نسخه فعلی استودیو مدل نمی‌تواند این داده مرورگر را با اطمینان ویرایش کند.',
    promptStorageWriteFailedTitle: 'تغییرات پرامپت ذخیره نشد',
    promptStorageWriteFailedDescription:
      'پرامپت‌های بارگذاری‌شده همچنان نمایش داده می‌شوند، اما برای حفاظت از داده محلی امکان تغییر بیشتر غیرفعال شده است.',
    promptModelMetadataNotice:
      'فراداده مدل موقتاً در دسترس نیست. مدل ذخیره‌شده همچنان قابل انتخاب است.',
    promptFilterModes: 'فیلتر بر پایه حالت',
    promptFilterTags: 'فیلتر بر پایه برچسب',
    promptSortLabel: 'مرتب‌سازی پرامپت‌ها',
    promptPinnedOnly: 'فقط سنجاق‌شده‌ها',
    promptSelected: 'پرامپت {name} انتخاب شد.',
    promptMissing: 'این پرامپت دیگر در دسترس نیست.',
    promptCreated: 'پرامپت {name} ساخته شد.',
    promptUpdated: 'پرامپت {name} به‌روزرسانی شد.',
    promptSavedAsNew: 'پرامپت {name} به‌عنوان مورد جدید ذخیره شد.',
    promptDuplicated: 'پرامپت {name} تکثیر شد.',
    promptPinned: 'پرامپت سنجاق شد.',
    promptUnpinned: 'سنجاق پرامپت برداشته شد.',
    promptDeleted: 'پرامپت {name} حذف شد.',
    workflowsTitle: 'گردش‌کارها',
    workflowsSubtitle: 'پیکربندی‌های مدل را برای کارهای تکرارشونده توسعه دوباره استفاده کنید.',
    newWorkflow: 'گردش‌کار جدید',
    workflowTemplates: 'گردش‌کارهای آماده',
    workflowSearchPlaceholder: 'جستجوی گردش‌کارها',
    workflowsPinnedOnly: 'فقط سنجاق‌شده‌ها',
    workflowsEmpty: 'گردش‌کاری با این فیلتر پیدا نشد.',
    workflowOpenInPlayground: 'باز کردن',
    workflowPin: 'سنجاق',
    workflowUnpin: 'برداشتن سنجاق',
    workflowRename: 'تغییر نام',
    workflowActions: 'عملیات گردش‌کار',
    workflowDuplicate: 'تکثیر',
    workflowDelete: 'حذف',
    workflowDeleteConfirm: 'این گردش‌کار حذف شود؟',
    workflowRenameTitle: 'تغییر نام گردش‌کار',
    workflowSave: 'ذخیره',
    workflowRenamed: 'نام گردش‌کار تغییر کرد.',
    workflowDuplicated: 'گردش‌کار تکثیر شد.',
    workflowDeleted: 'گردش‌کار حذف شد.',
    workflowSortLabel: 'مرتب‌سازی گردش‌کارها',
    workflowSortUpdated: 'آخرین به‌روزرسانی',
    workflowSortName: 'نام',
    workflowSortMode: 'حالت',
    workflowTemplateStructuredTitle: 'استخراج ساختاریافته',
    workflowTemplateStructuredDescription: 'خروجی JSON معتبر از سند یا متن دریافت کنید.',
    workflowTemplateSupportTitle: 'دستیار پشتیبانی',
    workflowTemplateSupportDescription: 'یک گفت‌وگوی پشتیبانی آماده ابزار آغاز کنید.',
    workflowTemplateImageTitle: 'شرح تصویر',
    workflowTemplateImageDescription: 'تنظیمات تصویر و ابعاد خروجی را دوباره استفاده کنید.',
    compareTitle: 'مقایسه',
    compareSubtitle: 'پاسخ مدل‌ها را با یک درخواست مشترک کنار هم ارزیابی کنید.',
    compareConnect: 'اتصال',
    runBoth: 'اجرای هر دو',
    comparePromptPlaceholder: 'یک پرامپت برای هر دو مدل وارد کنید',
    compareModelA: 'انتخاب مدل الف',
    compareModelB: 'انتخاب مدل ب',
    compareResults: 'نتایج مقایسه',
    comparePromptRequired: 'پیش از مقایسه مدل‌ها یک پرامپت وارد کنید.',
    compareConnectRequired: 'پیش از اجرای مقایسه یک کلید API متصل کنید.',
    compareReady: 'آماده',
    compareComplete: 'کامل',
    comparePreferred: 'ترجیحی',
    compareMarkPreferred: 'انتخاب به‌عنوان پاسخ ترجیحی',
    compareOutdated: 'قدیمی‌شده',
    compareFaster: 'سریع‌تر',
    compareFewerTokens: 'توکن کمتر',
    compareLowerCost: 'هزینه کمتر',
    comparePreferredTabLabel: '{model}، ترجیحی',
    compareFailed: 'ناموفق',
    compareResultEmpty: 'برای دیدن پاسخ، مقایسه را اجرا کنید.',
    compareLatency: 'تأخیر',
    compareTokens: 'توکن‌ها',
    compareCost: 'هزینه برآوردی',
    compareRerun: 'اجرای دوباره',
    copyResponse: 'کپی',
    compareCopied: 'پاسخ کپی شد.',
    compareCopyFailed: 'کپی پاسخ ممکن نبود.',
    openInPlayground: 'باز کردن در محیط آزمایش',
    requestsTitle: 'درخواست‌ها',
    requestsSubtitle: 'فراخوانی‌های مدل ثبت‌شده در مرورگر را بررسی، بازپخش و عیب‌یابی کنید.',
    requestsSearch: 'جستجوی درخواست یا مدل',
    requestsAllModes: 'همه حالت‌ها',
    requestsAllStatuses: 'همه وضعیت‌ها',
    requestsEmpty: 'درخواستی با این فیلتر پیدا نشد.',
    requestsBack: 'بازگشت',
    requestDetails: 'جزئیات درخواست',
    requestReplay: 'بازپخش',
    requestSuccess: 'موفق',
    requestError: 'خطا',
    requestsFilters: 'فیلترها',
    requestsAnyTime: 'هر زمان',
    requestsPastHour: 'یک ساعت گذشته',
    requestsPastDay: 'یک روز گذشته',
    requestsPastWeek: 'یک هفته گذشته',
    requestsPastMonth: 'یک ماه گذشته',
    requestModeFilter: 'فیلتر بر اساس حالت',
    requestStatusFilter: 'فیلتر بر اساس وضعیت',
    requestTimeFilter: 'فیلتر بر اساس زمان',
    requestMinimumTokens: 'حداقل توکن‌ها',
    requestMaximumCost: 'حداکثر هزینه (دلار)',
    requestModel: 'مدل',
    requestMode: 'حالت',
    requestResponse: 'پاسخ',
    requestPayload: 'بدنه درخواست',
    requestCode: 'کد درخواست',
    requestCodeCopied: 'کد درخواست کپی شد.',
    requestCodeCopyFailed: 'کپی کد درخواست ممکن نبود.',
    requestDelete: 'حذف درخواست',
    requestDeleted: 'درخواست حذف شد.',
    requestDeleteConfirm: 'این درخواست حذف شود؟',
    requestSelect: 'یک درخواست را برای بررسی انتخاب کنید.',
    historyCleared: 'تاریخچه درخواست‌ها پاک شد.',
    storageUnavailableTitle: 'ذخیره محلی در دسترس نیست',
    storageUnavailable:
      'تغییرات در این نشست در دسترس می‌مانند، اما مرورگر نتوانست آن‌ها را به‌صورت محلی ذخیره کند. داده ذخیره‌شده موجود حذف نشده است.',
    handoffNotFound: 'این گردش‌کار یا درخواست ذخیره‌شده دیگر در دسترس نیست.',
    workflowTemplateStructuredPrompt: 'واقعیت‌های کلیدی را استخراج کن و JSON معتبر برگردان.',
    workflowTemplateSupportPrompt: 'به مشتری برای حل این درخواست پشتیبانی کمک کن.',
    workflowTemplateImagePrompt: 'یک طرح محصول تمیز روی پس‌زمینه خنثی بساز.',
    setup: 'راه‌اندازی',
    controls: 'کنترل‌ها',
    configure: 'پیکربندی',
    studioSetup: 'راه‌اندازی استودیو',
    studioControls: 'کنترل‌های استودیو',
    setupRail: 'پنل راه‌اندازی',
    controlsRail: 'پنل کنترل‌ها',
    railOpen: 'باز',
    railClosed: 'بسته',
    openStudioSetup: 'باز کردن پنل راه‌اندازی استودیو',
    openStudioControls: 'باز کردن پنل کنترل‌های استودیو',
    closeStudioSetup: 'بستن پنل راه‌اندازی استودیو',
    closeStudioControls: 'بستن پنل کنترل‌های استودیو',
    openAttachments: 'باز کردن پیوست‌های چت',
    focusWorkspace: 'تمرکز',
    focusWorkspaceAction: 'تمرکز روی فضای کار',
    focusComposerAction: 'تمرکز روی کادر پیام چت',
    restoreWorkspace: 'بازگردانی',
    restoreWorkspaceAction: 'بازگردانی پنل‌های کناری',
    expandRail: 'باز کردن پنل',
    collapseRail: 'بستن پنل',
    connection: 'اتصال',
    connectionDetails: 'جزئیات اتصال',
    manageConnection: 'مدیریت اتصال',
    hideConnectionDetails: 'پنهان کردن جزئیات اتصال',
    avalai: 'AvalAI',
    custom: 'سفارشی',
    dashboardApiKey: 'کلید API پیشخان',
    dashboardApiKeySelect: 'انتخاب کلید API موجود',
    keySetupPaths: 'مسیرهای راه‌اندازی کلید API',
    recommended: 'توصیه شده',
    browserKeyPath: 'ساخت کلید مرورگر',
    browserKeyPathDescription: 'یک کلید مخصوص پیشخان برای همین نشست استودیو بسازید.',
    existingKeyPath: 'استفاده از کلید موجود',
    existingKeyPathDescription: 'کلیدهای API پیشخان را بارگذاری کنید و یکی را برای فراخوانی SDK مرورگر انتخاب کنید.',
    dashboardApiKeySelectPlaceholder: 'یک کلید API پیشخان انتخاب کنید',
    loadApiKeys: 'بارگذاری کلیدها',
    loadApiKeysAction: 'بارگذاری کلیدهای API موجود پیشخان',
    refreshApiKeys: 'نوسازی کلیدها',
    refreshApiKeysAction: 'نوسازی کلیدهای API موجود پیشخان',
    noApiKeysFound: 'کلید API پیدا نشد.',
    apiKeysFetchError: 'بارگذاری کلیدهای API با خطا مواجه شد.',
    selectedApiKeyFetchError: 'دریافت کلید API انتخاب‌شده با خطا مواجه شد.',
    selectedApiKeySecretUnavailable:
      'مقدار محرمانه کلید انتخاب‌شده در دسترس نیست. برای فراخوانی مرورگر، کلید پیشخان بسازید.',
    selectedApiKeyReady: 'کلید API انتخاب‌شده برای فراخوانی SDK مرورگر آماده است.',
    dashboardKeyReady: 'برای فراخوانی SDK در مرورگر آماده است.',
    dashboardKeyMissing: 'کلید پیشخان بارگذاری نشده است.',
    ready: 'آماده',
    needed: 'نیازمند',
    keyReady: 'کلید آماده است',
    keyNeeded: 'کلید لازم است',
    connectionInvalid: 'اتصال نامعتبر',
    freshKeyNotice: 'یک کلید تازه برای پیشخان ساخته شد. ممکن است کمی زمان ببرد تا فعال شود.',
    signInForDashboardKey: 'برای دریافت کلید API پیشخان وارد شوید.',
    dashboardKeyFetchError: 'دریافت کلید API پیشخان با خطا مواجه شد.',
    selectOrGenerateKeyError: 'پیش از اجرای درخواست، یک کلید API انتخاب یا ایجاد کنید.',
    runUnavailable: 'پیش از اجرا، یک کلید API انتخاب کنید و ورودی لازم را کامل کنید.',
    requestInProgress: 'درخواست در حال اجراست. پیش از تغییر تنظیمات آن را متوقف کنید.',
    dashboardKeyRequestInProgress:
      'درخواست کلید API پیشخان در حال اجراست. پیش از تغییر تنظیمات کلید منتظر پایان آن بمانید.',
    chatMessageRequired: 'پیش از اجرا، یک پیام چت وارد یا اضافه کنید.',
    chatNothingToClear: 'چت از قبل خالی است.',
    imagePromptRequired: 'پیش از تولید تصویر، پرامپت تصویر را وارد کنید.',
    speechInputRequired: 'پیش از اجرای گفتار، متن موردنظر را وارد کنید.',
    embeddingInputRequired: 'پیش از ساخت بردار، متن ورودی را وارد کنید.',
    requestJsonRequired: 'پیش از اجرا، JSON درخواست را وارد کنید.',
    resetParameters: 'بازنشانی پارامترها',
    resetSettings: 'بازنشانی تنظیمات',
    selectAudioFileError: 'پیش از اجرای رونویسی یا ترجمه، یک فایل صوتی انتخاب کنید.',
    requestCancelled: 'درخواست لغو شد.',
    requestFailed: 'درخواست پیش از دریافت پاسخ ناموفق بود.',
    providerAuthenticationFailed:
      'کلید API رد شد یا برای این درخواست مجوز ندارد. پنل راه‌اندازی استودیو را باز کنید، کلید را نوسازی یا جایگزین کنید و دوباره تلاش کنید.',
    providerRateLimited: 'ارائه‌دهنده تعداد درخواست‌ها را محدود کرده است. کمی صبر کنید و دوباره تلاش کنید.',
    providerNetworkError: 'اتصال به ارائه‌دهنده برقرار نشد. اتصال شبکه را بررسی کنید و دوباره تلاش کنید.',
    providerRequestRejected:
      'ارائه‌دهنده این درخواست را رد کرد. مدل و پارامترهای انتخاب‌شده را بررسی کنید و دوباره تلاش کنید.',
    providerUnavailable: 'ارائه‌دهنده موقتاً در دسترس نیست. کمی صبر کنید و دوباره تلاش کنید.',
    modelMetadataError: 'بارگذاری فراداده مدل‌ها با خطا مواجه شد.',
    generateApiKey: 'ساخت کلید API',
    generateDashboardKeyAction: 'ساخت کلید API پیشخان برای فراخوانی‌های مرورگری Model Studio',
    refreshDashboardKey: 'نوسازی کلید پیشخان',
    refreshDashboardKeyAction: 'نوسازی کلید API پیشخان تولیدشده برای فراخوانی‌های مرورگری Model Studio',
    customProvider: 'ارائه‌دهنده سفارشی',
    providerLabel: 'نام ارائه‌دهنده',
    customBaseUrl: 'نشانی پایه API',
    customBaseUrlPlaceholder: 'https://api.example.com/v1',
    customBaseUrlInvalid: 'پیش از اجرای درخواست‌ها، یک نشانی پایه HTTP(S) معتبر وارد کنید.',
    customBaseUrlHttpsRequired:
      'از نشانی پایه HTTPS استفاده کنید. در محیط توسعه، HTTP فقط برای نشانی‌های حلقهٔ محلی localhost مجاز است.',
    customApiKey: 'کلید API',
    customKeyPlaceholder: 'کلید API را برای همین نشست وارد کنید',
    customKeyNotice: 'کلیدهای سفارشی فقط در حافظه همین نشست می‌مانند و ذخیره نمی‌شوند.',
    clearCustomKey: 'پاک کردن کلید',
    clearCustomKeyAction: 'پاک کردن کلید API سفارشی از این نشست',
    roleUser: 'کاربر',
    roleAssistant: 'دستیار',
    viewRawResponse: 'نمایش متن خام پاسخ',
    viewFormattedResponse: 'نمایش پاسخ قالب‌بندی‌شده',
    rawResponseSource: 'متن خام پاسخ',
    roleSystem: 'سیستم',
    roleDeveloper: 'توسعه‌دهنده',
    prompt: 'پرامپت',
    savePreset: 'ذخیره تنظیم',
    applyPreset: 'اعمال',
    applyPresetWithName: 'اعمال تنظیم {name}',
    removePresetWithName: 'حذف تنظیم {name}',
    history: 'اجراهای اخیر',
    noLocalHistory: 'هنوز اجرای اخیر ندارید.',
    applyHistory: 'بازیابی',
    applyHistoryWithName: 'بازیابی اجرای اخیر {name}',
    removeHistoryWithName: 'حذف اجرای اخیر {name}',
    clearHistory: 'پاک کردن',
    clearHistoryConfirm: 'همه اجراهای اخیر پاک شوند؟',
    clearHistoryConfirmPositive: 'پاک کردن',
    clearHistoryConfirmNegative: 'انصراف',
    clearHistoryAction: 'پاک کردن همه اجراهای اخیر Model Studio',
    removePresetConfirm: 'این تنظیم ذخیره‌شده حذف شود؟',
    removePresetConfirmPositive: 'حذف',
    removePresetConfirmNegative: 'انصراف',
    presetNamePlaceholder: 'نام این تنظیم',
    presetName: 'تنظیم استودیو',
    workflows: 'گردش‌کارها',
    openWorkflows: 'باز کردن گردش‌کارهای ذخیره‌شده و اخیر',
    closeWorkflows: 'بستن گردش‌کارها',
    saveCurrentWorkflow: 'ذخیره تنظیم فعلی',
    recentWorkflows: 'اجراهای اخیر',
    savedWorkflows: 'ذخیره‌شده‌ها',
    manageWorkflowsInSetup: 'مدیریت همه در راه‌اندازی',
    loadWorkflowWithName: 'بازیابی گردش‌کار {name}',
    workflowLoaded: 'گردش‌کار {name} بازیابی شد. هر زمان آماده بودید اجرا را بزنید.',
    workflowLoadFailed: 'بازیابی گردش‌کار {name} انجام نشد. تنظیم فعلی اجرا نشده است.',
    workflowSaved: 'گردش‌کار {name} در این مرورگر ذخیره شد.',
    workflowSavedForSession: 'گردش‌کار {name} فقط در این نشست در دسترس است و ممکن است پس از بازخوانی باقی نماند.',
    workflowName: 'نام گردش‌کار',
    workflowNamePlaceholder: 'برای این گردش‌کار نامی بنویسید',
    workflowNameRequired: 'نام گردش‌کار را وارد کنید.',
    workflowNameTooLong: 'نام باید حداکثر ۶۰ نویسه باشد.',
    workflowNameDuplicate: 'گردش‌کاری با این نام از قبل ذخیره شده است.',
    workflowMutationLocked: 'برای تغییر گردش‌کارها، اجرای فعال را متوقف کنید یا منتظر پایان آن بمانید.',
    recentWorkflowsEmpty: 'پس از تکمیل اجرا، تنظیم آن برای استفاده دوباره اینجا نمایش داده می‌شود.',
    savedWorkflowsEmpty: 'تنظیم فعلی را ذخیره کنید تا بعداً دوباره از آن استفاده کنید.',
    workflowPersistenceUnavailable: 'ذخیره‌سازی مرورگر در دسترس نیست؛ تغییرها ممکن است پس از بازخوانی باقی نمانند.',
    modePromptInCanvas: 'پرامپت یا ورودی این حالت را در بوم میانی ویرایش کنید.',
    variables: 'متغیرها',
    addVariable: 'افزودن متغیر',
    variableName: 'نام متغیر',
    variableValue: 'مقدار متغیر',
    variableNamePlaceholder: 'customer_name',
    variableValuePlaceholder: 'مقداری که برای این متغیر استفاده می‌شود',
    removeVariable: 'حذف متغیر {name}',
    noPromptVariables: 'هنوز متغیر پرامپت ندارید.',
    systemInstructions: 'دستورهای سیستم',
    attachments: 'پیوست‌ها',
    attachFiles: 'فایل، تصویر یا صوت را برای مدل‌های پشتیبانی‌شده پیوست کنید.',
    attachmentTypeFile: 'فایل',
    attachmentTypeImage: 'تصویر',
    attachmentTypeAudio: 'صوت',
    attachmentIgnored: 'این مدل نادیده می‌گیرد',
    unsupportedAttachmentsIgnored:
      '{count} پیوست به دلیل پشتیبانی نشدن نوع ورودی توسط مدل انتخاب‌شده نادیده گرفته می‌شود.',
    removeAttachment: 'حذف {name}',
    remove: 'حذف',
    presets: 'تنظیم‌های ذخیره‌شده',
    noLocalPresets: 'هنوز تنظیم محلی ندارید.',
    compare: 'مقایسه',
    exitCompare: 'خروج از مقایسه',
    compareUnavailable:
      'مقایسه برای حالت‌های چت و تصویر در دسترس است، به شرطی که مدل انتخاب‌شده قابلیت فعال را پشتیبانی کند.',
    stop: 'توقف',
    run: 'اجرا',
    runProfile: 'نمایه اجرا',
    rerun: 'اجرای دوباره',
    chat: 'چت',
    images: 'تصویر',
    imageGeneration: 'تولید تصویر',
    imageGenerationUnavailableReason: 'فراداده مدل انتخاب‌شده تولید تصویر را اعلام نکرده است.',
    audio: 'صوت',
    embeddings: 'بردارسازی',
    rawApi: 'API خام',
    compactModeChat: 'چت',
    compactModeImages: 'تصویر',
    compactModeAudio: 'صوت',
    compactModeEmbeddings: 'بردار',
    compactModeRawApi: 'API',
    compactConfigure: 'تنظیم',
    compactCode: 'کد',
    compactInspector: 'بازرس',
    askAnything: 'هر چیزی بپرسید. پیوست‌ها و تنظیمات از پنل‌ها اعمال می‌شوند.',
    streamEvents: '{count} رویداد جریان',
    conversationEmpty: 'گفت‌وگوی شما اینجا نمایش داده می‌شود.',
    chatDraftReady: 'پیش‌نویس در کادر پیام آماده است.',
    chatDraftReadyHint: 'آن را پایین ویرایش کنید، به زمینه گفتگو اضافه کنید، یا وقتی کلید آماده بود اجرا کنید.',
    firstRunTitle: 'اولین درخواست خود را بسازید',
    firstRunDescription: 'اتصال امن را برقرار کنید، یک نمونه آغازین برگزینید و پیش از اجرا پرامپت را بازبینی کنید.',
    firstRunProgressLabel: 'راه‌اندازی اولین درخواست',
    firstRunProgressValue: '{current} از {total}',
    firstRunCompleted: 'تکمیل‌شده',
    firstRunCurrent: 'مرحله فعلی',
    firstRunReopenStep: 'بازبینی مرحله تکمیل‌شده: {step}',
    firstRunFocusComposer: 'تمرکز روی کادر پیام',
    returningChatTitle: 'درخواست تازه‌ای آغاز کنید',
    returningChatDescription: 'هر زمان آماده بودید، درخواست خود را در کادر پیام پایین بنویسید.',
    firstRunConnectTitle: 'برای اجرای نخستین درخواست متصل شوید',
    firstRunConnectDescription:
      'یک کلید موقت پیشخان بسازید یا اتصال دیگری را در راه‌اندازی تنظیم کنید.',
    firstRunPromptTitle: 'چه چیزی را می‌خواهید آزمایش کنید؟',
    firstRunPromptDescription: 'پرامپت خود را پایین بنویسید یا با یک نمونه آغاز کنید.',
    firstRunExamplesLabel: 'شروع با یک نمونه',
    firstRunChooseTitle: 'انتخاب نقطه آغاز',
    firstRunChooseDescription: 'نمونه انتخاب‌شده هنگام آماده‌سازی اتصال حفظ می‌شود.',
    firstRunReviewTitle: 'بازبینی و اجرا',
    firstRunReviewDescription: 'پرامپت را در کادر پیام ویرایش کنید و فقط پس از آماده‌شدن اجرا کنید.',
    firstRunGenerateDashboardKey: 'ساخت کلید پیشخان',
    firstRunGeneratingDashboardKey: 'در حال ساخت کلید پیشخان',
    firstRunConnectionReady: 'اتصال آماده است',
    firstRunConnectionNeeded: 'اتصال لازم است',
    firstRunWaiting: 'در انتظار',
    firstRunSelected: 'انتخاب‌شده',
    firstRunRetry: 'تلاش دوباره برای ساخت کلید',
    firstRunShortcut: 'پرامپت را بازبینی کنید، سپس Ctrl یا Command و Enter را فشار دهید.',
    starterPrompts: 'پرامپت‌های آماده',
    starterSummarize: 'این یادداشت انتشار را برای تیم پشتیبانی فنی خلاصه کن.',
    starterStructuredOutput: 'یک آبجکت JSON با title، summary، risks و next_steps برگردان.',
    starterToolPlanning: 'ابزارها و پارامترهای لازم برای پاسخ به پرسش صورتحساب مشتری را برنامه‌ریزی کن.',
    imageStarterProduct: 'یک عکس محصول تمیز از خزانه شیشه‌ای توکن API روی میز سفید.',
    imageStarterDiagram: 'یک دیاگرام ایزومتریک شفاف از پرامپت کاربر، درگاه API، مدل و پاسخ.',
    imageStarterScene:
      'یک فضای کاری سینمایی که توسعه‌دهندگان خروجی دو مدل هوش مصنوعی را روی نمایشگرهای بزرگ مقایسه می‌کنند.',
    audioStarterSupport:
      'سلام، از تماس شما با پشتیبانی AvalAI سپاسگزاریم. می‌توانم برای چرخش کلید API راهنمایی‌تان کنم.',
    audioStarterProductUpdate:
      'Model Studio اکنون به شما کمک می‌کند پرامپت‌ها را آزمایش کنید، مدل‌ها را مقایسه کنید و کد خروجی بگیرید.',
    audioStarterNarration: 'در این راهنما، یک کلید API وصل می‌کنیم، مدل را انتخاب می‌کنیم و درخواست را اجرا می‌کنیم.',
    embeddingStarterSearch: 'ابزار جستحوی وبی جستجو: بهترین روش‌های چرخش کلیدهای API در محیط تولید',
    embeddingStarterClassification: 'این تیکت پشتیبانی را دسته‌بندی کن: مشتری کلید API تولیدشده را پیدا نمی‌کند.',
    embeddingStarterSimilarity: 'شباهت معنایی بین اختلاف فاکتور، پرسش صورتحساب و درخواست بازپرداخت را مقایسه کن.',
    streamingResponse: 'در حال دریافت پاسخ...',
    imagePrompt: 'پرامپت تصویر',
    imagePromptPlaceholder: 'تصویری را که می‌خواهید بسازید یا ویرایش کنید توصیف کنید.',
    generatedImageAlt: 'تصویر تولیدشده',
    generatedImageAltWithIndex: 'تصویر تولیدشده {index}',
    generatedCompareImageAlt: 'تصویر تولیدشده {index} از لاین {label}',
    downloadImage: 'دانلود تصویر',
    downloadImageWithIndex: 'دانلود تصویر {index}',
    downloadCompareLaneImage: 'دانلود تصویر {index} از لاین {label}',
    downloadAudioOutput: 'دانلود صدای تولیدشده: {fileName}',
    base64ImageGenerated: 'تصویر Base64 تولید شد',
    imageOutput: 'خروجی تصویر',
    generatedImagesEmpty: 'تصاویر تولیدشده اینجا نمایش داده می‌شوند.',
    generateImage: 'تولید تصویر',
    audioTask: 'وظیفه صوتی',
    speech: 'تبدیل متن به گفتار',
    transcription: 'رونویسی',
    translation: 'ترجمه',
    speechInputPlaceholder: 'متن موردنظر برای تبدیل به گفتار را وارد کنید.',
    audioContextPlaceholder: 'پرامپت یا زمینه اختیاری برای این صوت.',
    selectAudioFile: 'انتخاب فایل صوتی',
    removeAudioFile: 'حذف {name}',
    selectedAudioFileHelp: 'این فایل مستقیم از طریق SDK مرورگر OpenAI ارسال می‌شود.',
    audioFileRequiredHelp: 'برای رونویسی و ترجمه صوتی لازم است.',
    output: 'خروجی',
    audioOutputEmpty: 'رونوشت‌ها یا پاسخ‌های صوتی اینجا نمایش داده می‌شوند.',
    audioResponseReturned: 'پاسخ صوتی برگشت داده شد. پاسخ خام را در پنل کنترل‌ها ببینید.',
    runAudio: 'اجرای صوت',
    embeddingInput: 'ورودی بردارسازی',
    embeddingInputPlaceholder: 'متنی را برای بردارسازی وارد کنید.',
    vectorPreview: 'پیش‌نمایش بردار',
    vectorPreviewEmpty: 'اولین مقدارهای بردار اینجا نمایش داده می‌شوند.',
    createEmbedding: 'ساخت بردار',
    rawEndpoint: 'نقطه پایانی',
    rawEndpointPlaceholder: '/responses',
    rawEndpointInvalid: 'یک مسیر نسبی API مانند /responses یا /chat/completions وارد کنید.',
    rawRequestSummary: 'نقطه پایانی درخواست کد تولیدشده را هدایت می‌کند',
    rawControlsNote:
      'نقطه پایانی API خام و JSON درخواست در بوم میانی ویرایش می‌شوند. قطعه‌کدهای زیر بر اساس همان درخواست ساخته می‌شوند.',
    formatJson: 'قالب‌بندی JSON',
    formatJsonRequiresJson: 'پیش از قالب‌بندی، JSON درخواست را وارد کنید.',
    formatJsonSchemaRequiresJson: 'پیش از قالب‌بندی، اسکیما JSON را وارد کنید.',
    formatFunctionParametersRequiresJson: 'پیش از قالب‌بندی، JSON پارامترهای تابع را وارد کنید.',
    rawRequestTemplates: 'قالب‌های درخواست',
    rawStarterResponses: 'Responses',
    rawStarterChat: 'Chat completions',
    rawStarterEmbeddings: 'Embeddings',
    useStarterPrompt: 'استفاده از پرامپت آماده: {prompt}',
    useRequestTemplate: 'استفاده از قالب درخواست: {template}',
    requestJson: 'JSON درخواست',
    rawJsonPlaceholder: '{\'{"model":"gpt-4o-mini","input":"Hello"}\'}',
    rawJsonInvalid: 'پیش از اجرای درخواست خام، یک آبجکت JSON معتبر وارد کنید.',
    jsonSchemaInvalid: 'برای اسکیما خروجی ساختاریافته، یک آبجکت JSON معتبر وارد کنید.',
    functionParametersInvalid: 'برای پارامترهای تابع، یک آبجکت JSON معتبر وارد کنید.',
    response: 'پاسخ',
    rawResponseEmpty: 'خروجی پاسخ خام اینجا نمایش داده می‌شود.',
    runRawRequest: 'اجرای درخواست خام',
    model: 'مدل',
    selectModel: 'انتخاب مدل',
    modelCapabilities: 'قابلیت‌های مدل',
    capabilitiesAvailable: '{count} در دسترس',
    vision: 'بینایی',
    tools: 'ابزارها',
    capabilityAvailable: '{label} در دسترس است',
    capabilityUnavailable: '{label} در دسترس نیست',
    unsupportedBySelectedModel: 'مدل انتخاب‌شده پشتیبانی نمی‌کند',
    capabilityUnavailableReason: 'فراداده مدل انتخاب‌شده این قابلیت را اعلام نکرده است.',
    visionUnavailableReason: 'نقطه پایانی تصویر یا بینایی اعلام نشده است.',
    parameters: 'پارامترها',
    temperature: 'دما',
    temp: 'دما',
    topP: 'Top P',
    max: 'حداکثر',
    maxOutput: 'حداکثر خروجی',
    reasoningEffort: 'سطح استدلال',
    reasoningUnavailableReason: 'فراداده مدل انتخاب‌شده کنترل‌های استدلال را اعلام نکرده است.',
    verbosity: 'جزئیات پاسخ',
    serviceTier: 'سطح سرویس',
    none: 'هیچ‌کدام',
    minimal: 'حداقلی',
    low: 'کم',
    medium: 'متوسط',
    high: 'زیاد',
    xhigh: 'خیلی زیاد',
    auto: 'خودکار',
    default: 'پیش‌فرض',
    flex: 'انعطاف‌پذیر',
    priority: 'اولویت‌دار',
    text: 'متن',
    jsonMode: 'حالت JSON',
    jsonSchema: 'اسکیما JSON',
    structuredOutput: 'خروجی ساختاریافته',
    structuredOutputUnavailableReason: 'فراداده مدل انتخاب‌شده خروجی ساختاریافته را اعلام نکرده است.',
    systemMessages: 'پیام‌های سیستم',
    systemMessagesUnavailableReason: 'فراداده مدل انتخاب‌شده پیام‌های سیستم را اعلام نکرده است.',
    webSearch: 'جست‌وجوی وب',
    webSearchUnavailableReason: 'فراداده مدل انتخاب‌شده جست‌وجوی وب را اعلام نکرده است.',
    vectorStoreIds: 'شناسه‌های Vector Store',
    fileSearchUnavailableReason: 'فراداده مدل انتخاب‌شده جست‌وجوی فایل را اعلام نکرده است.',
    functionName: 'نام تابع',
    functionDescription: 'توضیح تابع',
    functionCallingUnavailableReason: 'فراداده مدل انتخاب‌شده فراخوانی تابع را اعلام نکرده است.',
    mcpServerLabel: 'نام سرور MCP',
    mcpServerUrl: 'نشانی سرور MCP',
    mcpApproval: 'تأیید MCP',
    mcpApprovalAlways: 'همیشه تأیید لازم است',
    mcpApprovalNever: 'تأیید لازم نیست',
    mcpToolsUnavailableReason: 'فراداده مدل انتخاب‌شده پشتیبانی ابزار برای سرورهای MCP را اعلام نکرده است.',
    mcpServerInvalid: 'نام سرور MCP و یک نشانی معتبر HTTP(S) را وارد کنید.',
    modeSettings: 'تنظیمات حالت',
    modeNavigation: 'حالت‌های Model Studio',
    mode: 'حالت',
    imageSize: 'اندازه تصویر',
    quality: 'کیفیت',
    background: 'پس‌زمینه',
    transparent: 'شفاف',
    opaque: 'مات',
    voice: 'صدا',
    format: 'فرمت',
    dimensions: 'ابعاد',
    code: 'کد',
    codeLanguageNavigation: 'زبان‌های کد تولیدشده',
    codeContextMode: 'کد تولیدشده از تنظیمات فعلی {mode} پیروی می‌کند.',
    codeContextCompare: 'کد تولیدشده از لاین مقایسه فعال پیروی می‌کند: {lane}.',
    codeCapabilityWarning:
      'فراداده مدل انتخاب‌شده پشتیبانی از {mode} را نشان نمی‌دهد. پیش از استفاده از این کد، مدل یا حالت را تغییر دهید.',
    codeSampleInputNotice: 'تا وقتی ورودی را در بوم وارد کنید، این قطعه‌کدها از ورودی نمونه استفاده می‌کنند.',
    codeStatusModelMismatch: 'عدم تطابق مدل',
    codeStatusSampleInput: 'ورودی نمونه',
    copy: 'کپی',
    copySnippet: 'کپی قطعه کد {language}',
    copyMessage: 'کپی پیام',
    copyMessageWithContext: 'کپی پیام {role}: {preview}',
    copied: 'کپی شد',
    copyMessageFailed: 'امکان کپی پیام وجود ندارد. متن پیام انتخاب شده است تا بتوانید آن را دستی کپی کنید.',
    removeMessage: 'حذف پیام',
    removeMessageWithContext: 'حذف پیام {role}: {preview}',
    copyFailed: 'امکان کپی قطعه کد وجود ندارد. متن قطعه انتخاب شده است تا بتوانید آن را دستی کپی کنید.',
    download: 'دانلود',
    downloadSnippet: 'دانلود قطعه کد {language}',
    downloaded: 'دانلود قطعه کد شروع شد',
    downloadFailed: 'امکان دانلود قطعه کد وجود ندارد',
    lines: '{count} خط',
    inspector: 'بازرس',
    inspectorEmpty: 'برای مشاهده پاسخ خام، یک درخواست اجرا کنید.',
    latency: 'تأخیر: {value} میلی‌ثانیه',
    usage: 'مصرف: {value}',
    inspectorUsageTotal: 'کل توکن‌ها: {value}',
    inspectorUsageInput: 'توکن‌های ورودی: {value}',
    inspectorUsageOutput: 'توکن‌های خروجی: {value}',
    notRun: 'اجرا نشده',
    compareChatResponses: 'مقایسه پاسخ‌های چت',
    compareImageGenerations: 'مقایسه تولید تصویر',
    compareContextHelp:
      'لاین اصلی و جایگزین زمینه پرامپت مشترک دارند. یک لاین را انتخاب کنید تا کد تولیدشده از همان تنظیمات ساخته شود.',
    compareLaneCapabilityUnavailable: 'لاین {label} از مدل {model} استفاده می‌کند که این حالت را پشتیبانی نمی‌کند.',
    sharedChatPlaceholder: 'یک پیام چت مشترک برای هر دو لاین اضافه کنید.',
    messagesInContext: '{count} پیام در زمینه مشترک | {count} پیام در زمینه مشترک',
    addMessage: 'افزودن پیام',
    clearChat: 'پاک کردن چت',
    sharedImagePromptPlaceholder: 'پرامپت تصویر مشترک هر دو لاین را توصیف کنید.',
    primary: 'اصلی',
    variant: 'جایگزین',
    useForCode: 'استفاده برای کد',
    usingForCode: 'در کد استفاده می‌شود',
    useLaneForCode: 'استفاده از {label} برای کد',
    usingLaneForCode: '{label} در کد استفاده می‌شود',
    responseWillAppear: 'پاسخ اینجا نمایش داده می‌شود.',
    imageDataWillAppear: 'داده تصویر تولیدشده اینجا نمایش داده می‌شود.',
    runLane: 'اجرای {label}',
    runPrimary: 'اجرای اصلی',
    runVariant: 'اجرای جایگزین'
  },
  route: {
    sponsorship: 'استارتاپ‌ها',
    sponsorship_home: 'نمای کلی',
    sponsorship_apply: 'درخواست حمایت استارتاپی',
    sponsorship_status: 'وضعیت عضویت',
    sponsorship_levels: 'سطح عضویت',
    'support_knowledge-base': 'پایگاه دانش',
    support: 'پشتیبانی',
    support_dashboard: 'داشبورد',
    'support_create-ticket': 'ایجاد تیکت',
    'support_my-tickets': 'تیکت‌های من',
    'support_all-tickets': 'همه تیکت‌ها',
    'support_ai-operations': 'عملیات هوش مصنوعی',
    agentOnlyBadge: 'پشتیبان',
    agentOnlyBadgeTooltip: 'فقط برای کارشناسان و مدیران پشتیبانی نمایش داده می‌شود',
    // "support_ticket-details": "جزئیات تیکت",
    models: 'مدل‌ها',
    'model-studio': 'استودیو مدل',
    'model-studio_overview': 'نمای کلی',
    'model-studio_playground': 'محیط آزمایش',
    'model-studio_prompts': 'پرامپت‌ها',
    'model-studio_workflows': 'گردش‌کارها',
    'model-studio_compare': 'مقایسه',
    'model-studio_requests': 'درخواست‌ها',
    calculator: 'ماشین حساب هزینه',
    tokenizer: 'توکن‌پرداز',
    // assistants: "دستیارها",
    // storage: "فضای ذخیره‌سازی",
    billing_addresses: 'آدرس‌ها',
    billing_history: 'تاریخچه',
    billing_invoices: 'صورتحساب‌ها',
    usage_reports: '‌گزارش‌ها',
    usage_overview: 'نمایش',
    billing_credit: 'اعتبار',
    billing_packages: 'بسته‌ها',
    affiliate: 'کسب درآمد',
    usage: 'مصارف',
    limits: 'سطح دسترسی',
    billing: 'مالی',
    'api-keys': 'کلید‌های API',
    login: 'ورود',
    403: 'بدون اجازه',
    404: 'صفحه یافت نشد',
    500: 'خطای سرور',
    home: 'پیشخان',
    // docs: 'مستندات',
    // "docs_whats-new": "تازه‌های سیستم",
    // docs_vision: "بینایی ماشین",
    // "docs_text-to-speech": "تبدیل متن به گفتار",
    // "docs_text-generation": "تولید متن",
    // "docs_structured-outputs": "خروجی‌های ساختاریافته",
    // "docs_speech-to-text": "تبدیل گفتار به متن",
    // "docs_safety-best-practices": "بهترین شیوه‌های امنیتی",
    // docs_reasoning: "استدلال و منطق",
    // "docs_release-notes": "یادداشت‌های انتشار",
    // "docs_realtime-websocket": "یکپارچه‌سازی وب‌سوکت",
    // "docs_realtime-webrtc": "یکپارچه‌سازی WebRTC",
    // "docs_realtime-model-capabilities": "قابلیت‌های مدل بلادرنگ",
    // docs_realtime: "ویژگی‌های بلادرنگ",
    // "docs_rate-limits": "محدودیت‌های نرخ درخواست",
    // docs_quickstart: "راهنمای شروع سریع",
    // "docs_prompt-generation": "تولید پرامپت",
    // "docs_prompt-examples": "نمونه‌های پرامپت",
    // "docs_prompt-engineering": "مهندسی پرامپت",
    // "docs_prompt-caching": "کش‌کردن پرامپت",
    // "docs_production-best-practices": "بهترین شیوه‌های تولید",
    // "docs_predicted-outputs": "خروجی‌های پیش‌بینی شده",
    // docs_overview: "نمای کلی",
    // "docs_optimizing-llm-accuracy": "بهینه‌سازی دقت LLM",
    // docs_moderation: "نظارت بر محتوا",
    // docs_models: "مدل‌ها",
    // "docs_model-selection": "راهنمای انتخاب مدل",
    // docs_libraries: "کتابخانه‌ها و SDK‌ها",
    // "docs_latency-optimization": "بهینه‌سازی تاخیر",
    // "docs_image-generation": "تولید تصویر",
    // "docs_function-calling": "فراخوانی توابع",
    // "docs_fine-tuning": "تنظیم دقیق مدل‌ها",
    // docs_evals: "ارزیابی مدل‌ها",
    // "docs_error-codes": "کدهای خطا",
    // docs_distillation: "تقطیر مدل",
    // docs_embeddings: "جاسازی‌ها",
    // docs_deprecations: "اعلان‌های منسوخ شدگی",
    // "docs_deep-dive": "بررسی عمیق فنی",
    // docs_changelog: "تاریخچه تغییرات",
    // docs_batch: "پردازش دسته‌ای",
    // docs_assistant_usage: "راهنمای استفاده از دستیار",
    // docs_assistant_tools: "ابزارهای دستیار",
    // docs_assistant_quickstart: "شروع سریع دستیار",
    // "docs_audio-generation": "تولید صدا",
    // "docs_assistant_whats-new": "به‌روزرسانی‌های دستیار",
    // docs_assistant_overview: "نمای کلی دستیار",
    // docs_assistant_tools_overview: "نمای کلی ابزارها",
    // "docs_assistant_tools_function-calling": "ابزارهای فراخوانی توابع",
    // "docs_assistant_tools_file-search": "ابزارهای جستجوی فایل",
    // "docs_assistant_tools_code-interpreter": "مفسر کد",
    // docs_assistant_migration: "راهنمای مهاجرت دستیار",
    // docs_assistant: "دستیار هوش مصنوعی",
    // "docs_assistant_deep-dive": "جزئیات فنی دستیار",
    // "docs_advanced-usage": "استفاده پیشرفته",
    // "docs_actions_sending-files": "ارسال فایل با اکشن‌ها",
    // docs_actions_production: "اکشن‌ها در محیط تولید",
    // docs_actions_introduction: "معرفی اکشن‌ها",
    // docs: "مستندات",
    // "docs_accuracy-optimization": "بهینه‌سازی دقت",
    // docs_actions: "اکشن‌ها",
    // "docs_actions_actions-library": "کتابخانه اکشن‌ها",
    // "docs_actions_data-retrieval": "اکشن‌های بازیابی داده",
    // docs_actions_authentication: "احراز هویت اکشن‌ها",
    // "docs_actions_getting-started": "شروع کار با اکشن‌ها",
    // 'user-center': 'مرکز کاربری',
    // about: 'درباره',
    // function: 'کارکرد سیستم',
    // function_tab: 'برگه',
    // 'function_multi-tab': 'برگه چندگانه',
    // 'function_hide-child': 'پنهان کردن فرزند',
    // 'function_hide-child_one': 'پنهان کردن فرزند',
    // 'function_hide-child_two': 'دو',
    // 'function_hide-child_three': 'سه',
    // function_request: 'درخواست',
    // 'function_toggle-auth': 'تغییر مجوز',
    // 'function_super-page': 'قابل مشاهده مدیر فوق العاده',
    // manage: 'مدیریت سیستم',
    // manage_user: 'مدیریت کاربر',
    // 'manage_user-detail': 'جزئیات کاربر',
    // manage_role: 'مدیریت نقش',
    // manage_menu: 'مدیریت منو',
    // 'multi-menu': 'منوی چندگانه',
    // 'multi-menu_first': 'منوی یک',
    // 'multi-menu_first_child': 'فرزند منوی یک',
    // 'multi-menu_second': 'منوی دو',
    // 'multi-menu_second_child': 'فرزند منوی دو',
    // 'multi-menu_second_child_home': 'خانه فرزند منوی دو',
    exception: 'استثنا',
    exception_403: '403',
    exception_404: '404',
    exception_500: '500'
  },
  page: {
    login: {
      common: {
        // visitAsGuest: 'ورود بصورت مهمان',
        login: 'ورود به حساب کاربری',
        needLogin: 'برای دسترسی به این صفحه نیاز است ابتدا وارد شوید',
        continueAsGuest: 'ادامه به عنوان مهمان',
        loginBenefits: 'برای دسترسی کامل به داشبورد خود وارد شوید',
        unlockFeatures: 'با ورود به حساب کاربری دسترسی پیدا کنید:',
        grantHeroTitle: '{amount} تومان اعتبار رایگان دریافت کنید',
        grantHeroSubtitle: 'ثبت‌نام کنید، اعتبار هدیه‌تان را بگیرید و همین حالا استفاده از API را شروع کنید. اعتبار به‌صورت خودکار به حساب شما اضافه می‌شود.',
        grantCtaPrimary: 'ثبت‌نام و دریافت اعتبار',
        grantEmailTopupNote: 'قبلاً با ایمیل ثبت‌نام کرده‌اید؟ با تایید شماره تلفن، {amount} تومان دیگر دریافت کنید تا مجموع اعتبار شما به {total} تومان برسد.',
        loginRequired: 'برای دسترسی کامل به داشبورد خود وارد شوید',
        loginOrRegister: 'ورود / ثبت نام',
        userNamePlaceholder: 'لطفا نام کاربری را وارد کنید',
        phonePlaceholder: 'لطفا شماره تلفن را وارد کنید',
        codePlaceholder: 'لطفا کد تایید را وارد کنید',
        passwordPlaceholder: 'لطفا رمز عبور را وارد کنید',
        confirmPasswordPlaceholder: 'لطفا رمز عبور را دوباره وارد کنید',
        codeLogin: 'ورود با کد تایید',
        confirm: 'تایید',
        back: 'بازگشت',
        validateSuccess: 'تایید موفق',
        loginSuccess: 'ورود موفقیت آمیز',
        welcomeBack: 'خوش آمدید, {userName} !',
        benefits: {
          'api-keys': {
            a: 'ایجاد و مدیریت کلیدهای API',
            b: 'نظارت بر استفاده و هزینه‌های API',
            c: 'تنظیم محدودیت‌های نرخ و مجوزها'
          },
          billing: {
            a: 'مشاهده تاریخچه تفصیلی صورتحساب',
            b: 'افزودن اعتبار به حساب کاربری',
            c: 'دانلود فاکتورها و رسیدها'
          },
          packages: {
            a: 'مشاهده و مدیریت بسته‌های اعتبار',
            b: 'خرید بسته‌های اعتباری جدید',
            c: 'مشاهده تاریخچه بسته‌های اعتباری خریداری شده'
          },
          home: {
            a: 'دسترسی به داشبورد شخصی‌سازی شده',
            b: 'مشاهده داده‌های استفاده در زمان واقعی',
            c: 'سفارشی‌سازی تنظیمات و ترجیحات'
          },
          models: {
            a: 'دسترسی به تمام مدل‌های موجود',
            b: 'مشاهده اطلاعات تفصیلی مدل‌ها',
            c: 'مقایسه قابلیت‌های مدل‌ها'
          },
          usage: {
            a: 'تجزیه و تحلیل تفصیلی استفاده',
            b: 'صادرات گزارش‌های استفاده',
            c: 'پیگیری هزینه‌ها در طول زمان'
          },
          affiliate: {
            a: 'کسب درآمد از طریق معرفی',
            b: 'مشاهده کاربران معرفی شده و درآمد',
            c: 'برداشت درآمدهای کسب شده'
          },
          support: {
            a: 'ایجاد و پیگیری تیکت‌های پشتیبانی خود',
            b: 'پاسخ به کارشناسان و دنبال کردن گفتگوها',
            c: 'دریافت پشتیبانی برای حساب کاربری'
          }
        }
      },
      pwdLogin: {
        title: 'ورود با رمز عبور',
        rememberMe: 'مرا به خاطر بسپار',
        forgetPassword: 'رمز عبور را فراموش کرده اید؟',
        register: 'ثبت نام',
        otherAccountLogin: 'ورود با حساب کاربری دیگر',
        otherLoginMode: 'حالت ورود دیگر',
        superAdmin: 'مدیر فوق العاده',
        admin: 'مدیر',
        user: 'کاربر'
      },
      codeLogin: {
        title: 'ورود با کد تایید',
        getCode: 'دریافت کد تایید',
        sendFailed: 'ارسال کد تایید با خطا مواجه شد، لطفا دوباره تلاش کنید',
        reGetCode: 'دریافت مجدد پس از {time} ثانیه',
        sendCodeSuccess: 'کد تایید با موفقیت ارسال شد',
        sendCodeSuccessViaFallback: 'کد تایید از طریق {provider} ارسال شد',
        imageCodePlaceholder: 'لطفا کد تایید تصویری را وارد کنید',
        codeNotValid: 'کد صحیح نیست و یا منقضی شده',
        phoneAlreadyAssociated: 'این شماره تلفن قبلا به حساب کاربری دیگری متصل شده است.',
        phoneAlreadyAssociatedHelp:
          'چنانچه مالک این شماره تلفن هستید، ابتدا حساب مرتبط با این شماره تلفن را از صفحه حذف حساب کاربری حذف نمایید تا شماره آزاد شود، سپس مجدد تلاش کنید.',
        deleteLinkedAccount: 'باز کردن صفحه حذف حساب کاربری',
        fallbackProvider: {
          bale: 'پیام رسان بله'
        },
        fallbackProviderLink: {
          bale: 'https://web.bale.ai/'
        },
        openFallbackProvider: 'باز کردن {provider}',
        fallbackOtpTitle: 'روش تایید جایگزین',
        fallbackOtpWhyTitle: 'چرا این را می‌بینم؟',
        fallbackOtpWhyDescription:
          'ما سعی کردیم کد تایید را از طریق پیامک برای شما ارسال کنیم، اما سرویس پیامک ما موقتا در دسترس نیست. برای اطمینان از اینکه همچنان می‌توانید به طور ایمن به حساب خود دسترسی داشته باشید، کد تایید شما را از طریق کانال جایگزین ارسال کرده‌ایم.',
        fallbackOtpSmsNotResponding:
          'سرویس پیامک در حال حاضر پاسخگو نیست. کد شما به صورت امن از طریق {provider} ارسال شده است.',
        fallbackOtpStep1: 'ما سعی کردیم پیامک ارسال کنیم اما سرویس در دسترس نبود',
        fallbackOtpStep2: 'کد تایید شما به صورت امن به {provider} ارسال شده است',
        fallbackOtpStep3: 'کدی که دریافت کرده‌اید را وارد کنید تا تایید کامل شود',
        fallbackOtpAlternativeTitle: 'ترجیح می‌دهید پیامک دریافت کنید؟',
        fallbackOtpAlternativeDescription:
          'اگر ترجیح می‌دهید کد تایید را از طریق پیامک دریافت کنید، می‌توانید چند دقیقه صبر کنید و دوباره امتحان کنید. سیستم ما همیشه ابتدا سعی می‌کند پیامک ارسال کند و سپس از روش‌های جایگزین استفاده می‌کند.',
        fallbackOtpRetryLater:
          'لطفا چند دقیقه صبر کنید و دوباره امتحان کنید. سرویس پیامک ممکن است به زودی در دسترس قرار گیرد.',
        fallbackOtpInfoButton: 'چرا این روش؟'
      },
      register: {
        title: 'ثبت نام',
        agreement: 'من خوانده ام و موافقت می کنم با',
        protocol: '《توافق نامه کاربر》',
        policy: '《سیاست حفظ حریم خصوصی》'
      },
      resetPwd: {
        title: 'بازنشانی رمز عبور'
      },
      bindWeChat: {
        title: 'پیوستن به WeChat'
      },
      guestMode: {
        message: 'شما به عنوان مهمان در حال مشاهده هستید. برای دسترسی کامل، لطفا وارد شوید.',
        timeRemaining: 'جلسه مهمان در {time} منقضی می‌شود',
        upgradePrompt: 'از پلتفرم لذت می‌برید؟ حساب کاربری بسازید تا پیشرفت خود را ذخیره کنید.'
      },
      benefits: {
        createApiKeys: '[REDACTED]',
        manageKeys: 'قابلیت‌های کامل مدیریت کلید',
        viewUsage: 'تحلیل‌های دقیق استفاده',
        viewBilling: 'دسترسی به تاریخچه صورتحساب',
        addCredits: 'افزودن اعتبار و مدیریت پرداخت‌ها',
        downloadInvoices: 'دانلود فاکتور و رسید',
        personalizedDashboard: 'تجربه داشبورد شخصی‌سازی شده',
        realTimeData: 'داده‌ها و اعلان‌های لحظه‌ای',
        customSettings: 'تنظیمات و ترجیحات سفارشی'
      }
    },
    about: {
      title: 'درباره',
      introduction:
        'Soybean Admin یک قالب مدیریتی زیبا و قدرتمند است که بر اساس آخرین تکنولوژی های فرانت اند ایجاد شده است، از جمله Vue3, Vite5, TypeScript, Pinia و UnoCSS. این قالب دارای پیکربندی تم غنی و اجزا ساخته شده است، مشخصات کد سختگیرانه، و سیستم مسیریابی فایل خودکار. علاوه بر این، از راه حل داده های mock آنلاین بر اساس ApiFox استفاده می کند. Soybean Admin یک راه حل مدیریتی یکپارچه برای شما فراهم می کند، بدون هیچ پیکربندی اضافی، و آماده برای استفاده. همچنین این یک روش بهترین عملکرد برای یادگیری سریع تکنولوژی های جدید است.',
      projectInfo: {
        title: 'اطلاعات پروژه',
        version: 'نسخه',
        latestBuildTime: 'آخرین زمان ساخت',
        githubLink: 'لینک Github',
        previewLink: 'لینک پیش نمایش'
      },
      prdDep: 'وابستگی تولید',
      devDep: 'وابستگی توسعه'
    },
    home: {
      offer1: '۳۵۰ میلیون تومان',
      offer2: '۵۵۰ میلیون تومان',
      offer3: '۱ میلیارد تومان',
      offer1Benefit: '۵۰ میلیون تومان',
      offer2Benefit: '۱۰۰ میلیون تومان',
      offer3Benefit: '۲۰۰ میلیون تومان',
      specialOffer: 'پیشنهاد ویژه: اعتبار رایگان تا ۲۰۰ میلیون تومان!',
      inChargeMoreGetMore:
        'با شارژ حساب خود، اعتبار رایگان دریافت کنید. هر چه بیشتر شارژ کنید، اعتبار بیشتری می‌گیرید!',
      offerExpiresIn: 'این پیشنهاد تا ۳۱ شهریور معتبر است. اعتبار دریافتی تا ۶۰ روز قابل استفاده می‌باشد.',
      shortDesc1: 'پلتفرم AvalAI ارائه‌دهنده API مدل‌های هوش مصنوعی',
      // desc1Title: 'دسترسی راحت',
      desc1:
        'با ایجاد تنها یک حساب کاربری توسعه‌دهنده در پلتفرم هوش مصنوعی AvalAI، به دنیایی از امکانات بی‌پایان و دسترسی نامحدود به تمامی خدمات پیشرو هوش مصنوعی از جمله OpenAI، Anthropic، Meta، Mistral AI، Cohere، Google (Gemini) و Deepseek بر اساس تعرفه‌های رسمی ارائه‌دهندگان دست خواهید یافت.',
      desc2:
        'دسترسی آسان به AvalAI، بدون مواجهه با محدودیت‌های ناخواسته مانند محدودیت‌های جغرافیایی، پرداخت‌های امن ریالی بدون کارمزد اضافی، فعال‌سازی فوری حساب‌های کاربری، و پایداری حداکثری زیرساخت‌های ما، همگی تضمین‌کننده تجربه‌ای لذت‌بخش برای توسعه‌دهندگان، پژوهشگران و کسب‌وکارها می‌باشد. با استفاده از پلتفرم هوش مصنوعی AvalAI، شما به راحتی می‌توانید از قابلیت‌های برترین مدل‌های هوش مصنوعی برای رشد و توسعه پروژه‌ها و ایده‌های خود بهره‌مند شوید.',
      desc3:
        'ما در AvalAI به ارائه تجربه‌ای لذت‌ بخش و کارآمد برای توسعه‌دهندگان، پژوهشگران و کسب‌وکارها متعهد هستیم. از قابلیت‌های بی نظیر AI برای ارتقای پروژه‌ها و ایده‌های خود به سطوح جدید استفاده کنید. به جمع ما در AvalAI بپیوندید و از همین امروز آینده را شکل دهید.',
      greeting: 'خوش آمدید',
      weatherDesc: 'امروز ابری تا صاف است, 20℃ - 25℃!',
      projectCount: 'تعداد پروژه',
      todo: 'کار های برنامه ریزی شده',
      message: 'پیام',
      downloadCount: 'تعداد دانلود',
      registerCount: 'تعداد ثبت نام',
      schedule: 'برنامه کار و استراحت',
      study: 'مطالعه',
      work: 'کار',
      rest: 'استراحت',
      entertainment: 'سرگرمی',
      visitCount: 'تعداد بازدید',
      turnover: 'دوران سرمایه',
      dealCount: 'تعداد معاملات',
      projectNews: {
        title: 'اخبار پروژه',
        moreNews: 'اخبار بیشتر',
        desc1: 'Soybean در 28 می 2021 پروژه متن باز soybean-admin را ایجاد کرد!',
        desc2: 'یانبوو یک باگ به soybean-admin ارسال کرد، نوار multi-tab تنظیم نمی شود.',
        desc3: 'Soybean در حال آماده سازی کافی برای انتشار soybean-admin است!',
        desc4: 'Soybean در حال نوشتن مستندات پروژه برای soybean-admin است!',
        desc5: 'Soybean فقط برخی از صفحات کارگاه را به صورت تصادفی نوشت، و این کافی بود تا ببیند!'
      },
      creativity: 'خلاقیت'
    },
    function: {
      tab: {
        tabOperate: {
          title: 'عملکرد برگه',
          addTab: 'افزودن برگه',
          addTabDesc: 'به صفحه درباره',
          closeTab: 'بستن برگه',
          closeCurrentTab: 'بستن برگه فعلی',
          closeAboutTab: '',
          addMultiTab: 'افزودن برگه چندگانه',
          addMultiTabDesc1: 'به صفحه MultiTab',
          addMultiTabDesc2: 'به صفحه MultiTab (با پارامترهای query)'
        },
        tabTitle: {
          title: 'عنوان برگه',
          changeTitle: 'تغییر عنوان',
          change: 'تغییر',
          resetTitle: 'بازنشانی عنوان',
          reset: 'بازنشانی'
        }
      },
      multiTab: {
        routeParam: 'پارامتر مسیر',
        backTab: 'برگشت به function_tab'
      },
      toggleAuth: {
        toggleAccount: 'تغییر حساب',
        authHook: 'کارکرد مجوز hasAuth',
        superAdminVisible: 'قابل مشاهده مدیر فوق العاده',
        adminVisible: 'قابل مشاهده مدیر',
        adminOrUserVisible: 'قابل مشاهده مدیر و کاربر'
      }
    },
    manage: {
      common: {
        status: {
          enable: 'فعال کردن',
          disable: 'غیر فعال کردن'
        }
      },
      role: {
        title: 'لیست نقش ها',
        roleName: 'نام نقش',
        roleCode: 'کد نقش',
        roleStatus: 'وضعیت نقش',
        roleDesc: 'توضیحات نقش',
        menuAuth: 'مجوز منو',
        buttonAuth: 'مجوز دکمه',
        form: {
          roleName: 'لطفا نام نقش را وارد کنید',
          roleCode: 'لطفا کد نقش را وارد کنید',
          roleStatus: 'لطفا وضعیت نقش را انتخاب کنید',
          roleDesc: 'لطفا توضیحات نقش را وارد کنید'
        },
        addRole: 'اضافه کردن نقش',
        editRole: 'ویرایش نقش'
      },
      user: {
        title: 'لیست کاربران',
        userName: 'نام کاربری',
        userGender: 'جنسیت',
        nickName: 'نام مستعار',
        userPhone: 'شماره تلفن',
        userEmail: 'ایمیل',
        userStatus: 'وضعیت کاربر',
        userRole: 'نقش کاربر',
        form: {
          userName: 'لطفا نام کاربری را وارد کنید',
          userGender: 'لطفا جنسیت را انتخاب کنید',
          nickName: 'لطفا نام مستعار را وارد کنید',
          userPhone: 'لطفا شماره تلفن را وارد کنید',
          userEmail: 'لطفا ایمیل را وارد کنید',
          userStatus: 'لطفا وضعیت کاربر را انتخاب کنید',
          userRole: 'لطفا نقش کاربر را انتخاب کنید'
        },
        addUser: 'اضافه کردن کاربر',
        editUser: 'ویرایش کاربر',
        gender: {
          male: 'مرد',
          female: 'زن'
        }
      },
      menu: {
        home: 'خانه',
        title: 'لیست منو',
        id: 'شناسه',
        parentId: 'شناسه والد',
        menuType: 'نوع منو',
        menuName: 'نام منو',
        routeName: 'نام مسیر',
        routePath: 'مسیر',
        routeParams: 'پارامترهای مسیر',
        layout: 'کامپوننت چیدمان',
        page: 'کامپوننت صفحه',
        i18nKey: 'کلید بین المللی',
        icon: 'آیکون',
        localIcon: 'آیکون محلی',
        iconTypeTitle: 'نوع آیکون',
        order: 'ترتیب',
        keepAlive: 'نگه داشتن زنده',
        href: 'آدرس اینترنتی',
        hideInMenu: 'مخفی کردن در منو',
        activeMenu: 'منوی فعال',
        multiTab: 'برگه های چندگانه',
        fixedIndexInTab: 'شاخص ثابت در برگه',
        button: 'دکمه',
        buttonCode: 'کد دکمه',
        buttonDesc: 'توضیح دکمه',
        menuStatus: 'وضعیت منو',
        form: {
          home: 'لطفا خانه را انتخاب کنید',
          menuType: 'لطفا نوع منو را انتخاب کنید',
          menuName: 'لطفا نام منو را وارد کنید',
          routeName: 'لطفا نام مسیر را وارد کنید',
          routePath: 'لطفا مسیر را وارد کنید',
          page: 'لطفا کامپوننت صفحه را انتخاب کنید',
          layout: 'لطفا کامپوننت چیدمان را انتخاب کنید',
          i18nKey: 'لطفا کلید بین المللی را وارد کنید',
          icon: 'لطفا نام آیکون را وارد کنید',
          localIcon: 'لطفا نام آیکون محلی را وارد کنید',
          order: 'لطفا ترتیب را وارد کنید',
          keepAlive: 'لطفا انتخاب کنید که آیا مسیر کش شود یا خیر',
          href: 'لطفا آدرس اینترنتی را وارد کنید',
          hideInMenu: 'لطفا انتخاب کنید که آیا منو مخفی شود یا خیر',
          activeMenu: 'لطفا نام مسیر منوی برجسته را وارد کنید',
          multiTab: 'لطفا انتخاب کنید که آیا پشتیبانی از برگه های چندگانه انجام شود یا خیر',
          fixedInTab: 'لطفا انتخاب کنید که آیا در برگه ثابت شود یا خیر',
          fixedIndexInTab: 'لطفا شاخص ثابت در برگه را وارد کنید',
          button: 'لطفا انتخاب کنید که آیا این یک دکمه است یا خیر',
          buttonCode: 'لطفا کد دکمه را وارد کنید',
          buttonDesc: 'لطفا توضیح دکمه را وارد کنید',
          menuStatus: 'لطفا وضعیت منو را انتخاب کنید'
        },
        addMenu: 'اضافه کردن منو',
        editMenu: 'ویرایش منو',
        addChildMenu: 'اضافه کردن زیرمنو',
        type: {
          directory: 'دایرکتوری',
          menu: 'منو'
        },
        iconType: {
          iconify: 'آیکون Iconify',
          local: 'آیکون محلی'
        }
      }
    }
  },
  form: {
    required: 'نمی تواند خالی باشد',
    userName: {
      required: 'لطفا نام کاربری را وارد کنید',
      invalid: 'فرمت نام کاربری اشتباه است'
    },
    phone: {
      required: 'لطفا شماره تلفن را وارد کنید',
      invalid: 'فرمت شماره تلفن اشتباه است'
    },
    pwd: {
      required: 'لطفا رمز عبور را وارد کنید',
      invalid: '6-18 کاراکتر، شامل حروف، اعداد، و خط زیر'
    },
    confirmPwd: {
      required: 'لطفا رمز عبور را دوباره وارد کنید',
      invalid: 'دو رمز عبور یکسان نیستند'
    },
    code: {
      required: 'لطفا کد تایید را وارد کنید',
      invalid: 'فرمت کد تایید اشتباه است'
    },
    email: {
      required: 'لطفا ایمیل را وارد کنید',
      invalid: 'فرمت ایمیل اشتباه است'
    }
  },
  dropdown: {
    closeCurrent: 'بستن فعلی',
    closeOther: 'بستن بقیه',
    closeLeft: 'بستن چپ',
    closeRight: 'بستن راست',
    closeAll: 'بستن همه'
  },
  icon: {
    themeConfig: 'پیکربندی تم',
    themeSchema: 'طرح تم',
    lang: 'تغییر زبان',
    fullscreen: 'تمام صفحه',
    fullscreenExit: 'خروج از حالت تمام صفحه',
    reload: 'بارگذاری مجدد صفحه',
    collapse: 'بستن منو',
    expand: 'باز کردن منو',
    pin: 'سنجاق',
    unpin: 'برداشتن سنجاق'
  },
  storage: {
    uploadModalTitle: 'بارگذاری فایل',
    fileSelected: 'فایل انتخاب شد',
    uploadFilePlaceholder: 'یک فایل بارگذاری کنید یا اینجا بکشید و رها کنید',
    fileNameLabel: 'نام',
    fileNameDescription: 'نام فایل بارگذاری شده',
    fileNamePlaceholder: 'نام فایل را وارد کنید',
    purposeLabel: 'هدف',
    purposeDescription: 'هدف از بارگذاری فایل',
    purposePlaceholder: 'انتخاب هدف',
    learnMoreLink: 'درباره اهداف فایل بیشتر بدانید',
    searchFilesPlaceholder: 'جستجوی فایل‌ها ...',
    invalidFileType: 'نوع فایل برای {purpose} نامعتبر است',
    supportedFormatsAssistants: 'فرمت‌های پشتیبانی‌شده: {formats}',
    supportedFormatsVision: 'فرمت‌های پشتیبانی‌شده: {formats}',
    supportedFormatsJsonl: 'فقط فایل‌های .jsonl پشتیبانی می‌شوند.',
    fileNotFound: 'فایل پیدا نشد.',
    fileUploadedButNotListed: 'فایل بارگذاری شد، اما هنوز در لیست نمایش داده نمی‌شود.',
    fileUploadedAndListed: 'فایل بارگذاری شد و در لیست تایید شد.',
    downloadStarting: 'شروع دانلود...',
    downloading: 'در حال دانلود...',
    downloadComplete: 'دانلود کامل شد.',
    downloadError: 'خطا در دانلود فایل.',
    file: 'فایل',
    status: 'وضعیت',
    fileId: 'شناسه فایل',
    purpose: 'هدف',
    size: 'اندازه',
    createdAt: 'تاریخ ایجاد',
    download: 'دانلود',
    delete: 'حذف',
    deleteConfirm: 'آیا مطمئن هستید که می‌خواهید این فایل را حذف کنید؟',
    selectFile: 'برای مشاهده جزئیات، یک فایل را انتخاب کنید.',
    files: 'فایل‌ها',
    vectorStores: 'مخازن برداری',
    upload: 'بارگذاری',
    noFiles: 'هنوز فایلی بارگذاری نشده است.',
    noVectorStores: 'هنوز مخزن برداری ایجاد نشده است.',
    selectItem: 'برای مشاهده جزئیات، یک مورد را انتخاب کنید.',
    uploadSuccess: 'فایل با موفقیت بارگذاری شد',
    uploadError: 'بارگذاری فایل با خطا مواجه شد',
    fileDeleted: 'فایل با موفقیت حذف شد',
    deleteError: 'حذف فایل با خطا مواجه شد',
    fetchError: 'دریافت اطلاعات با خطا مواجه شد'
  },
  assistants: {
    vectorStore: 'Vector Store',
    noAssistants: 'No assistants found',
    createAssistantGetStarted: 'Create an assistant to get started with Assistants API.',
    defineResponseSchema: 'Define Response Schema',
    responseSchemaDescription: "Define the JSON schema for the assistant's responses",
    enterVectorStoreId: 'Enter vector store Id',
    selectExisting: 'Select Existing',
    uploadNew: 'Upload New',
    uploadFile: 'Upload File',
    generate: 'Generate',
    examples: 'Examples',
    getStockPrice: 'Get Stock Price',
    weatherForecast: 'Weather Forecast',
    calculator: 'Calculator',
    functions: 'Functions',
    addFunction: 'Add Function',
    editFunction: 'Edit Function',
    removeFunction: 'Remove Function',
    functionName: 'Function Name',
    functionDescription:
      'Define a function that the assistant can call. The function should be defined using JSON Schema format.',
    functionDefinitionPlaceholder: '    Enter function definition in JSON Schema format...',
    definition: 'Function Definition',
    strictMode: 'Strict Mode',
    strictModeHelp:
      'When enabled, the assistant will only call functions exactly as defined. Disable for more flexible function calling.',
    invalidDefinition: 'Invalid function definition. Please check the JSON Schema format.',
    duplicateFunctionName: 'A function with this name already exists.',
    functionRequired: 'Function definition is required',
    generateFunction: 'Generate Function',
    exampleFunctions: 'Example Functions',
    functionSaved: 'Function saved successfully',
    functionRemoved: 'Function removed successfully',
    functionValidationError: 'Function validation failed. Please check the definition.',
    learnMoreFunctions: 'Learn more about function definitions',
    modelRequired: 'Model is required',
    responseFormatRequired: 'Response format is required',
    temperatureInvalid: 'Temperature must be between 0 and 2',
    topPInvalid: 'Top P must be between 0 and 1',
    maxResultsInvalid: 'Max results must be within the allowed range',
    title: 'Assistants',
    selectToView: 'Select an assistant to view details',
    createNew: 'Create New Assistant',
    name: 'Name',
    namePlaceholder: 'Enter a user friendly name',
    nameRequired: 'Name is required',
    instructions: 'Instructions',
    instructionsPlaceholder: 'You are a helpful assistant...',
    instructionsRequired: 'Instructions are required',
    model: 'Model',
    tools: 'Tools',
    fileSearch: 'File Search',
    codeInterpreter: 'Code Interpreter',
    addFiles: 'Add Files',
    selectVectorStore: 'Select Vector Store',
    modelConfig: 'Model Configuration',
    responseFormat: 'Response Format',
    temperature: 'Temperature',
    topP: 'Top P',
    maxResults: 'Max Results',
    maxResultsHelp: 'Maximum number of results to return from file search',
    create: 'Create',
    attachFiles: 'Attach Files to File Search',
    attachVectorStore: 'Attach Vector Store',
    dragFilesHere: 'Drag your files here',
    clickToUpload: 'Click to Upload',
    fileUploadHelp: 'Files will be processed and made available for the assistant to search through',
    vectorStoreHelp: 'Select an existing vector store to allow the assistant to search through its contents',
    searchVectorStores: 'Search vector stores...',
    noVectorStoresFound: 'No vector stores found',
    vectorStoreSearchPlaceholder: 'Enter vector store id',
    attach: 'Attach',
    back: 'Back',
    learnMore: 'Learn more',
    fileName: 'File Name',
    fileSize: 'Size',
    fileStatus: 'Status',
    fileActions: 'Actions',
    removeFile: 'Remove',
    fileAttached: 'File attached successfully',
    vectorStoreAttached: 'Vector store attached successfully',
    fileRemoved: 'File removed',
    invalidFileType: 'Invalid file type',
    fileTooLarge: 'File is too large',
    uploadError: 'Error uploading file',
    temperatureHelp: "Controls randomness in the assistant's responses",
    topPHelp: "Controls diversity of the assistant's responses",
    fileSearchHelp: 'Enable searching through attached files',
    codeInterpreterHelp: 'Enable Python code execution capabilities'
  }
};

export default local satisfies App.I18n.Schema;
